/*!
 * Materialize v0.96.0 (http://materializecss.com)
 * Copyright 2014-2015 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 *
 * Modifications: nK
 */
! function(t) {
    function e(t) {
        var e = t.length,
            n = i.type(t);
        return "function" === n || i.isWindow(t) ? !1 : 1 === t.nodeType && e ? !0 : "array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t
    }
    if (!t.jQuery) {
        var i = function(t, e) {
            return new i.fn.init(t, e)
        };
        i.isWindow = function(t) {
            return null != t && t == t.window
        }, i.type = function(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? a[r.call(t)] || "object" : typeof t
        }, i.isArray = Array.isArray || function(t) {
                return "array" === i.type(t)
            }, i.isPlainObject = function(t) {
            var e;
            if (!t || "object" !== i.type(t) || t.nodeType || i.isWindow(t)) return !1;
            try {
                if (t.constructor && !o.call(t, "constructor") && !o.call(t.constructor.prototype, "isPrototypeOf")) return !1
            } catch (n) {
                return !1
            }
            for (e in t);
            return void 0 === e || o.call(t, e)
        }, i.each = function(t, i, n) {
            var a, o = 0,
                r = t.length,
                s = e(t);
            if (n) {
                if (s)
                    for (; r > o && (a = i.apply(t[o], n), a !== !1); o++);
                else
                    for (o in t)
                        if (a = i.apply(t[o], n), a === !1) break
            } else if (s)
                for (; r > o && (a = i.call(t[o], o, t[o]), a !== !1); o++);
            else
                for (o in t)
                    if (a = i.call(t[o], o, t[o]), a === !1) break; return t
        }, i.data = function(t, e, a) {
            if (void 0 === a) {
                var o = t[i.expando],
                    r = o && n[o];
                if (void 0 === e) return r;
                if (r && e in r) return r[e]
            } else if (void 0 !== e) {
                var o = t[i.expando] || (t[i.expando] = ++i.uuid);
                return n[o] = n[o] || {}, n[o][e] = a, a
            }
        }, i.removeData = function(t, e) {
            var a = t[i.expando],
                o = a && n[a];
            o && i.each(e, function(t, e) {
                delete o[e]
            })
        }, i.extend = function() {
            var t, e, n, a, o, r, s = arguments[0] || {},
                l = 1,
                u = arguments.length,
                c = !1;
            for ("boolean" == typeof s && (c = s, s = arguments[l] || {}, l++), "object" != typeof s && "function" !== i.type(s) && (s = {}), l === u && (s = this, l--); u > l; l++)
                if (null != (o = arguments[l]))
                    for (a in o) t = s[a], n = o[a], s !== n && (c && n && (i.isPlainObject(n) || (e = i.isArray(n))) ? (e ? (e = !1, r = t && i.isArray(t) ? t : []) : r = t && i.isPlainObject(t) ? t : {}, s[a] = i.extend(c, r, n)) : void 0 !== n && (s[a] = n));
            return s
        }, i.queue = function(t, n, a) {
            function o(t, i) {
                var n = i || [];
                return null != t && (e(Object(t)) ? ! function(t, e) {
                    for (var i = +e.length, n = 0, a = t.length; i > n;) t[a++] = e[n++];
                    if (i !== i)
                        for (; void 0 !== e[n];) t[a++] = e[n++];
                    return t.length = a, t
                }(n, "string" == typeof t ? [t] : t) : [].push.call(n, t)), n
            }
            if (t) {
                n = (n || "fx") + "queue";
                var r = i.data(t, n);
                return a ? (!r || i.isArray(a) ? r = i.data(t, n, o(a)) : r.push(a), r) : r || []
            }
        }, i.dequeue = function(t, e) {
            i.each(t.nodeType ? [t] : t, function(t, n) {
                e = e || "fx";
                var a = i.queue(n, e),
                    o = a.shift();
                "inprogress" === o && (o = a.shift()), o && ("fx" === e && a.unshift("inprogress"), o.call(n, function() {
                    i.dequeue(n, e)
                }))
            })
        }, i.fn = i.prototype = {
            init: function(t) {
                if (t.nodeType) return this[0] = t, this;
                throw new Error("Not a DOM node.")
            },
            offset: function() {
                var e = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
                    top: 0,
                    left: 0
                };
                return {
                    top: e.top + (t.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
                    left: e.left + (t.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
                }
            },
            position: function() {
                function t() {
                    for (var t = this.offsetParent || document; t && "html" === !t.nodeType.toLowerCase && "static" === t.style.position;) t = t.offsetParent;
                    return t || document
                }
                var e = this[0],
                    t = t.apply(e),
                    n = this.offset(),
                    a = /^(?:body|html)$/i.test(t.nodeName) ? {
                        top: 0,
                        left: 0
                    } : i(t).offset();
                return n.top -= parseFloat(e.style.marginTop) || 0, n.left -= parseFloat(e.style.marginLeft) || 0, t.style && (a.top += parseFloat(t.style.borderTopWidth) || 0, a.left += parseFloat(t.style.borderLeftWidth) || 0), {
                    top: n.top - a.top,
                    left: n.left - a.left
                }
            }
        };
        var n = {};
        i.expando = "velocity" + (new Date).getTime(), i.uuid = 0;
        for (var a = {}, o = a.hasOwnProperty, r = a.toString, s = "Boolean Number String Function Array Date RegExp Object Error".split(" "), l = 0; l < s.length; l++) a["[object " + s[l] + "]"] = s[l].toLowerCase();
        i.fn.init.prototype = i.fn, t.Velocity = {
            Utilities: i
        }
    }
}(window),
    function(t) {
        "object" == typeof module && "object" == typeof module.exports ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : t()
    }(function() {
        return function(t, e, i, n) {
            function a(t) {
                for (var e = -1, i = t ? t.length : 0, n = []; ++e < i;) {
                    var a = t[e];
                    a && n.push(a)
                }
                return n
            }

            function o(t) {
                return g.isWrapped(t) ? t = [].slice.call(t) : g.isNode(t) && (t = [t]), t
            }

            function r(t) {
                var e = p.data(t, "velocity");
                return null === e ? n : e
            }

            function s(t) {
                return function(e) {
                    return Math.round(e * t) * (1 / t)
                }
            }

            function l(t, i, n, a) {
                function o(t, e) {
                    return 1 - 3 * e + 3 * t
                }

                function r(t, e) {
                    return 3 * e - 6 * t
                }

                function s(t) {
                    return 3 * t
                }

                function l(t, e, i) {
                    return ((o(e, i) * t + r(e, i)) * t + s(e)) * t
                }

                function u(t, e, i) {
                    return 3 * o(e, i) * t * t + 2 * r(e, i) * t + s(e)
                }

                function c(e, i) {
                    for (var a = 0; g > a; ++a) {
                        var o = u(i, t, n);
                        if (0 === o) return i;
                        var r = l(i, t, n) - e;
                        i -= r / o
                    }
                    return i
                }

                function d() {
                    for (var e = 0; b > e; ++e) S[e] = l(e * w, t, n)
                }

                function p(e, i, a) {
                    var o, r, s = 0;
                    do r = i + (a - i) / 2, o = l(r, t, n) - e, o > 0 ? a = r : i = r; while (Math.abs(o) > m && ++s < y);
                    return r
                }

                function h(e) {
                    for (var i = 0, a = 1, o = b - 1; a != o && S[a] <= e; ++a) i += w;
                    --a;
                    var r = (e - S[a]) / (S[a + 1] - S[a]),
                        s = i + r * w,
                        l = u(s, t, n);
                    return l >= v ? c(e, s) : 0 == l ? s : p(e, i, i + w)
                }

                function f() {
                    C = !0, (t != i || n != a) && d()
                }
                var g = 4,
                    v = .001,
                    m = 1e-7,
                    y = 10,
                    b = 11,
                    w = 1 / (b - 1),
                    x = "Float32Array" in e;
                if (4 !== arguments.length) return !1;
                for (var k = 0; 4 > k; ++k)
                    if ("number" != typeof arguments[k] || isNaN(arguments[k]) || !isFinite(arguments[k])) return !1;
                t = Math.min(t, 1), n = Math.min(n, 1), t = Math.max(t, 0), n = Math.max(n, 0);
                var S = x ? new Float32Array(b) : new Array(b),
                    C = !1,
                    $ = function(e) {
                        return C || f(), t === i && n === a ? e : 0 === e ? 0 : 1 === e ? 1 : l(h(e), i, a)
                    };
                $.getControlPoints = function() {
                    return [{
                        x: t,
                        y: i
                    }, {
                        x: n,
                        y: a
                    }]
                };
                var T = "generateBezier(" + [t, i, n, a] + ")";
                return $.toString = function() {
                    return T
                }, $
            }

            function u(t, e) {
                var i = t;
                return g.isString(t) ? b.Easings[t] || (i = !1) : i = g.isArray(t) && 1 === t.length ? s.apply(null, t) : g.isArray(t) && 2 === t.length ? w.apply(null, t.concat([e])) : g.isArray(t) && 4 === t.length ? l.apply(null, t) : !1, i === !1 && (i = b.Easings[b.defaults.easing] ? b.defaults.easing : y), i
            }

            function c(t) {
                if (t) {
                    var e = (new Date).getTime(),
                        i = b.State.calls.length;
                    i > 1e4 && (b.State.calls = a(b.State.calls));
                    for (var o = 0; i > o; o++)
                        if (b.State.calls[o]) {
                            var s = b.State.calls[o],
                                l = s[0],
                                u = s[2],
                                h = s[3],
                                f = !!h,
                                v = null;
                            h || (h = b.State.calls[o][3] = e - 16);
                            for (var m = Math.min((e - h) / u.duration, 1), y = 0, w = l.length; w > y; y++) {
                                var k = l[y],
                                    C = k.element;
                                if (r(C)) {
                                    var $ = !1;
                                    if (u.display !== n && null !== u.display && "none" !== u.display) {
                                        if ("flex" === u.display) {
                                            var T = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
                                            p.each(T, function(t, e) {
                                                x.setPropertyValue(C, "display", e)
                                            })
                                        }
                                        x.setPropertyValue(C, "display", u.display)
                                    }
                                    u.visibility !== n && "hidden" !== u.visibility && x.setPropertyValue(C, "visibility", u.visibility);
                                    for (var P in k)
                                        if ("element" !== P) {
                                            var O, A = k[P],
                                                _ = g.isString(A.easing) ? b.Easings[A.easing] : A.easing;
                                            if (1 === m) O = A.endValue;
                                            else {
                                                var E = A.endValue - A.startValue;
                                                if (O = A.startValue + E * _(m, u, E), !f && O === A.currentValue) continue
                                            }
                                            if (A.currentValue = O, "tween" === P) v = O;
                                            else {
                                                if (x.Hooks.registered[P]) {
                                                    var M = x.Hooks.getRoot(P),
                                                        D = r(C).rootPropertyValueCache[M];
                                                    D && (A.rootPropertyValue = D)
                                                }
                                                var I = x.setPropertyValue(C, P, A.currentValue + (0 === parseFloat(O) ? "" : A.unitType), A.rootPropertyValue, A.scrollData);
                                                x.Hooks.registered[P] && (r(C).rootPropertyValueCache[M] = x.Normalizations.registered[M] ? x.Normalizations.registered[M]("extract", null, I[1]) : I[1]), "transform" === I[0] && ($ = !0)
                                            }
                                        }
                                    u.mobileHA && r(C).transformCache.translate3d === n && (r(C).transformCache.translate3d = "(0px, 0px, 0px)", $ = !0), $ && x.flushTransformCache(C)
                                }
                            }
                            u.display !== n && "none" !== u.display && (b.State.calls[o][2].display = !1), u.visibility !== n && "hidden" !== u.visibility && (b.State.calls[o][2].visibility = !1), u.progress && u.progress.call(s[1], s[1], m, Math.max(0, h + u.duration - e), h, v), 1 === m && d(o)
                        }
                }
                b.State.isTicking && S(c)
            }

            function d(t, e) {
                if (!b.State.calls[t]) return !1;
                for (var i = b.State.calls[t][0], a = b.State.calls[t][1], o = b.State.calls[t][2], s = b.State.calls[t][4], l = !1, u = 0, c = i.length; c > u; u++) {
                    var d = i[u].element;
                    if (e || o.loop || ("none" === o.display && x.setPropertyValue(d, "display", o.display), "hidden" === o.visibility && x.setPropertyValue(d, "visibility", o.visibility)), o.loop !== !0 && (p.queue(d)[1] === n || !/\.velocityQueueEntryFlag/i.test(p.queue(d)[1])) && r(d)) {
                        r(d).isAnimating = !1, r(d).rootPropertyValueCache = {};
                        var h = !1;
                        p.each(x.Lists.transforms3D, function(t, e) {
                            var i = /^scale/.test(e) ? 1 : 0,
                                a = r(d).transformCache[e];
                            r(d).transformCache[e] !== n && new RegExp("^\\(" + i + "[^.]").test(a) && (h = !0, delete r(d).transformCache[e])
                        }), o.mobileHA && (h = !0, delete r(d).transformCache.translate3d), h && x.flushTransformCache(d), x.Values.removeClass(d, "velocity-animating")
                    }
                    if (!e && o.complete && !o.loop && u === c - 1) try {
                        o.complete.call(a, a)
                    } catch (f) {
                        setTimeout(function() {
                            throw f
                        }, 1)
                    }
                    s && o.loop !== !0 && s(a), r(d) && o.loop === !0 && !e && (p.each(r(d).tweensContainer, function(t, e) {
                        /^rotate/.test(t) && 360 === parseFloat(e.endValue) && (e.endValue = 0, e.startValue = 360), /^backgroundPosition/.test(t) && 100 === parseFloat(e.endValue) && "%" === e.unitType && (e.endValue = 0, e.startValue = 100)
                    }), b(d, "reverse", {
                        loop: !0,
                        delay: o.delay
                    })), o.queue !== !1 && p.dequeue(d, o.queue)
                }
                b.State.calls[t] = !1;
                for (var g = 0, v = b.State.calls.length; v > g; g++)
                    if (b.State.calls[g] !== !1) {
                        l = !0;
                        break
                    }
                l === !1 && (b.State.isTicking = !1, delete b.State.calls, b.State.calls = [])
            }
            var p, h = function() {
                    if (i.documentMode) return i.documentMode;
                    for (var t = 7; t > 4; t--) {
                        var e = i.createElement("div");
                        if (e.innerHTML = "<!--[if IE " + t + "]><span></span><![endif]-->", e.getElementsByTagName("span").length) return e = null, t
                    }
                    return n
                }(),
                f = function() {
                    var t = 0;
                    return e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || function(e) {
                            var i, n = (new Date).getTime();
                            return i = Math.max(0, 16 - (n - t)), t = n + i, setTimeout(function() {
                                e(n + i)
                            }, i)
                        }
                }(),
                g = {
                    isString: function(t) {
                        return "string" == typeof t
                    },
                    isArray: Array.isArray || function(t) {
                        return "[object Array]" === Object.prototype.toString.call(t)
                    },
                    isFunction: function(t) {
                        return "[object Function]" === Object.prototype.toString.call(t)
                    },
                    isNode: function(t) {
                        return t && t.nodeType
                    },
                    isNodeList: function(t) {
                        return "object" == typeof t && /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(t)) && t.length !== n && (0 === t.length || "object" == typeof t[0] && t[0].nodeType > 0)
                    },
                    isWrapped: function(t) {
                        return t && (t.jquery || e.Zepto && e.Zepto.zepto.isZ(t))
                    },
                    isSVG: function(t) {
                        return e.SVGElement && t instanceof e.SVGElement
                    },
                    isEmptyObject: function(t) {
                        for (var e in t) return !1;
                        return !0
                    }
                },
                v = !1;
            if (t.fn && t.fn.jquery ? (p = t, v = !0) : p = e.Velocity.Utilities, 8 >= h && !v) throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
            if (7 >= h) return void(jQuery.fn.velocity = jQuery.fn.animate);
            var m = 400,
                y = "swing",
                b = {
                    State: {
                        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                        isAndroid: /Android/i.test(navigator.userAgent),
                        isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
                        isChrome: e.chrome,
                        isFirefox: /Firefox/i.test(navigator.userAgent),
                        prefixElement: i.createElement("div"),
                        prefixMatches: {},
                        scrollAnchor: null,
                        scrollPropertyLeft: null,
                        scrollPropertyTop: null,
                        isTicking: !1,
                        calls: []
                    },
                    CSS: {},
                    Utilities: p,
                    Redirects: {},
                    Easings: {},
                    Promise: e.Promise,
                    defaults: {
                        queue: "",
                        duration: m,
                        easing: y,
                        begin: n,
                        complete: n,
                        progress: n,
                        display: n,
                        visibility: n,
                        loop: !1,
                        delay: !1,
                        mobileHA: !0,
                        _cacheValues: !0
                    },
                    init: function(t) {
                        p.data(t, "velocity", {
                            isSVG: g.isSVG(t),
                            isAnimating: !1,
                            computedStyle: null,
                            tweensContainer: null,
                            rootPropertyValueCache: {},
                            transformCache: {}
                        })
                    },
                    hook: null,
                    mock: !1,
                    version: {
                        major: 1,
                        minor: 2,
                        patch: 2
                    },
                    debug: !1
                };
            e.pageYOffset !== n ? (b.State.scrollAnchor = e, b.State.scrollPropertyLeft = "pageXOffset", b.State.scrollPropertyTop = "pageYOffset") : (b.State.scrollAnchor = i.documentElement || i.body.parentNode || i.body, b.State.scrollPropertyLeft = "scrollLeft", b.State.scrollPropertyTop = "scrollTop");
            var w = function() {
                function t(t) {
                    return -t.tension * t.x - t.friction * t.v
                }

                function e(e, i, n) {
                    var a = {
                        x: e.x + n.dx * i,
                        v: e.v + n.dv * i,
                        tension: e.tension,
                        friction: e.friction
                    };
                    return {
                        dx: a.v,
                        dv: t(a)
                    }
                }

                function i(i, n) {
                    var a = {
                            dx: i.v,
                            dv: t(i)
                        },
                        o = e(i, .5 * n, a),
                        r = e(i, .5 * n, o),
                        s = e(i, n, r),
                        l = 1 / 6 * (a.dx + 2 * (o.dx + r.dx) + s.dx),
                        u = 1 / 6 * (a.dv + 2 * (o.dv + r.dv) + s.dv);
                    return i.x = i.x + l * n, i.v = i.v + u * n, i
                }
                return function n(t, e, a) {
                    var o, r, s, l = {
                            x: -1,
                            v: 0,
                            tension: null,
                            friction: null
                        },
                        u = [0],
                        c = 0,
                        d = 1e-4,
                        p = .016;
                    for (t = parseFloat(t) || 500, e = parseFloat(e) || 20, a = a || null, l.tension = t, l.friction = e, o = null !== a, o ? (c = n(t, e), r = c / a * p) : r = p; s = i(s || l, r), u.push(1 + s.x), c += 16, Math.abs(s.x) > d && Math.abs(s.v) > d;);
                    return o ? function(t) {
                        return u[t * (u.length - 1) | 0]
                    } : c
                }
            }();
            b.Easings = {
                linear: function(t) {
                    return t
                },
                swing: function(t) {
                    return .5 - Math.cos(t * Math.PI) / 2
                },
                spring: function(t) {
                    return 1 - Math.cos(4.5 * t * Math.PI) * Math.exp(6 * -t)
                }
            }, p.each([
                ["ease", [.25, .1, .25, 1]],
                ["ease-in", [.42, 0, 1, 1]],
                ["ease-out", [0, 0, .58, 1]],
                ["ease-in-out", [.42, 0, .58, 1]],
                ["easeInSine", [.47, 0, .745, .715]],
                ["easeOutSine", [.39, .575, .565, 1]],
                ["easeInOutSine", [.445, .05, .55, .95]],
                ["easeInQuad", [.55, .085, .68, .53]],
                ["easeOutQuad", [.25, .46, .45, .94]],
                ["easeInOutQuad", [.455, .03, .515, .955]],
                ["easeInCubic", [.55, .055, .675, .19]],
                ["easeOutCubic", [.215, .61, .355, 1]],
                ["easeInOutCubic", [.645, .045, .355, 1]],
                ["easeInQuart", [.895, .03, .685, .22]],
                ["easeOutQuart", [.165, .84, .44, 1]],
                ["easeInOutQuart", [.77, 0, .175, 1]],
                ["easeInQuint", [.755, .05, .855, .06]],
                ["easeOutQuint", [.23, 1, .32, 1]],
                ["easeInOutQuint", [.86, 0, .07, 1]],
                ["easeInExpo", [.95, .05, .795, .035]],
                ["easeOutExpo", [.19, 1, .22, 1]],
                ["easeInOutExpo", [1, 0, 0, 1]],
                ["easeInCirc", [.6, .04, .98, .335]],
                ["easeOutCirc", [.075, .82, .165, 1]],
                ["easeInOutCirc", [.785, .135, .15, .86]]
            ], function(t, e) {
                b.Easings[e[0]] = l.apply(null, e[1])
            });
            var x = b.CSS = {
                RegEx: {
                    isHex: /^#([A-f\d]{3}){1,2}$/i,
                    valueUnwrap: /^[A-z]+\((.*)\)$/i,
                    wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
                    valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
                },
                Lists: {
                    colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
                    transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
                    transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"]
                },
                Hooks: {
                    templates: {
                        textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
                        boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
                        clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
                        backgroundPosition: ["X Y", "0% 0%"],
                        transformOrigin: ["X Y Z", "50% 50% 0px"],
                        perspectiveOrigin: ["X Y", "50% 50%"]
                    },
                    registered: {},
                    register: function() {
                        for (var t = 0; t < x.Lists.colors.length; t++) {
                            var e = "color" === x.Lists.colors[t] ? "0 0 0 1" : "255 255 255 1";
                            x.Hooks.templates[x.Lists.colors[t]] = ["Red Green Blue Alpha", e]
                        }
                        var i, n, a;
                        if (h)
                            for (i in x.Hooks.templates) {
                                n = x.Hooks.templates[i], a = n[0].split(" ");
                                var o = n[1].match(x.RegEx.valueSplit);
                                "Color" === a[0] && (a.push(a.shift()), o.push(o.shift()), x.Hooks.templates[i] = [a.join(" "), o.join(" ")])
                            }
                        for (i in x.Hooks.templates) {
                            n = x.Hooks.templates[i], a = n[0].split(" ");
                            for (var t in a) {
                                var r = i + a[t],
                                    s = t;
                                x.Hooks.registered[r] = [i, s]
                            }
                        }
                    },
                    getRoot: function(t) {
                        var e = x.Hooks.registered[t];
                        return e ? e[0] : t
                    },
                    cleanRootPropertyValue: function(t, e) {
                        return x.RegEx.valueUnwrap.test(e) && (e = e.match(x.RegEx.valueUnwrap)[1]), x.Values.isCSSNullValue(e) && (e = x.Hooks.templates[t][1]), e
                    },
                    extractValue: function(t, e) {
                        var i = x.Hooks.registered[t];
                        if (i) {
                            var n = i[0],
                                a = i[1];
                            return e = x.Hooks.cleanRootPropertyValue(n, e), e.toString().match(x.RegEx.valueSplit)[a]
                        }
                        return e
                    },
                    injectValue: function(t, e, i) {
                        var n = x.Hooks.registered[t];
                        if (n) {
                            var a, o, r = n[0],
                                s = n[1];
                            return i = x.Hooks.cleanRootPropertyValue(r, i), a = i.toString().match(x.RegEx.valueSplit), a[s] = e, o = a.join(" ")
                        }
                        return i
                    }
                },
                Normalizations: {
                    registered: {
                        clip: function(t, e, i) {
                            switch (t) {
                                case "name":
                                    return "clip";
                                case "extract":
                                    var n;
                                    return x.RegEx.wrappedValueAlreadyExtracted.test(i) ? n = i : (n = i.toString().match(x.RegEx.valueUnwrap), n = n ? n[1].replace(/,(\s+)?/g, " ") : i), n;
                                case "inject":
                                    return "rect(" + i + ")"
                            }
                        },
                        blur: function(t, e, i) {
                            switch (t) {
                                case "name":
                                    return b.State.isFirefox ? "filter" : "-webkit-filter";
                                case "extract":
                                    var n = parseFloat(i);
                                    if (!n && 0 !== n) {
                                        var a = i.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
                                        n = a ? a[1] : 0
                                    }
                                    return n;
                                case "inject":
                                    return parseFloat(i) ? "blur(" + i + ")" : "none"
                            }
                        },
                        opacity: function(t, e, i) {
                            if (8 >= h) switch (t) {
                                case "name":
                                    return "filter";
                                case "extract":
                                    var n = i.toString().match(/alpha\(opacity=(.*)\)/i);
                                    return i = n ? n[1] / 100 : 1;
                                case "inject":
                                    return e.style.zoom = 1, parseFloat(i) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(i), 10) + ")"
                            } else switch (t) {
                                case "name":
                                    return "opacity";
                                case "extract":
                                    return i;
                                case "inject":
                                    return i
                            }
                        }
                    },
                    register: function() {
                        9 >= h || b.State.isGingerbread || (x.Lists.transformsBase = x.Lists.transformsBase.concat(x.Lists.transforms3D));
                        for (var t = 0; t < x.Lists.transformsBase.length; t++) ! function() {
                            var e = x.Lists.transformsBase[t];
                            x.Normalizations.registered[e] = function(t, i, a) {
                                switch (t) {
                                    case "name":
                                        return "transform";
                                    case "extract":
                                        return r(i) === n || r(i).transformCache[e] === n ? /^scale/i.test(e) ? 1 : 0 : r(i).transformCache[e].replace(/[()]/g, "");
                                    case "inject":
                                        var o = !1;
                                        switch (e.substr(0, e.length - 1)) {
                                            case "translate":
                                                o = !/(%|px|em|rem|vw|vh|\d)$/i.test(a);
                                                break;
                                            case "scal":
                                            case "scale":
                                                b.State.isAndroid && r(i).transformCache[e] === n && 1 > a && (a = 1), o = !/(\d)$/i.test(a);
                                                break;
                                            case "skew":
                                                o = !/(deg|\d)$/i.test(a);
                                                break;
                                            case "rotate":
                                                o = !/(deg|\d)$/i.test(a)
                                        }
                                        return o || (r(i).transformCache[e] = "(" + a + ")"), r(i).transformCache[e]
                                }
                            }
                        }();
                        for (var t = 0; t < x.Lists.colors.length; t++) ! function() {
                            var e = x.Lists.colors[t];
                            x.Normalizations.registered[e] = function(t, i, a) {
                                switch (t) {
                                    case "name":
                                        return e;
                                    case "extract":
                                        var o;
                                        if (x.RegEx.wrappedValueAlreadyExtracted.test(a)) o = a;
                                        else {
                                            var r, s = {
                                                black: "rgb(0, 0, 0)",
                                                blue: "rgb(0, 0, 255)",
                                                gray: "rgb(128, 128, 128)",
                                                green: "rgb(0, 128, 0)",
                                                red: "rgb(255, 0, 0)",
                                                white: "rgb(255, 255, 255)"
                                            };
                                            /^[A-z]+$/i.test(a) ? r = s[a] !== n ? s[a] : s.black : x.RegEx.isHex.test(a) ? r = "rgb(" + x.Values.hexToRgb(a).join(" ") + ")" : /^rgba?\(/i.test(a) || (r = s.black), o = (r || a).toString().match(x.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ")
                                        }
                                        return 8 >= h || 3 !== o.split(" ").length || (o += " 1"), o;
                                    case "inject":
                                        return 8 >= h ? 4 === a.split(" ").length && (a = a.split(/\s+/).slice(0, 3).join(" ")) : 3 === a.split(" ").length && (a += " 1"), (8 >= h ? "rgb" : "rgba") + "(" + a.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")"
                                }
                            }
                        }()
                    }
                },
                Names: {
                    camelCase: function(t) {
                        return t.replace(/-(\w)/g, function(t, e) {
                            return e.toUpperCase()
                        })
                    },
                    SVGAttribute: function(t) {
                        var e = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
                        return (h || b.State.isAndroid && !b.State.isChrome) && (e += "|transform"), new RegExp("^(" + e + ")$", "i").test(t)
                    },
                    prefixCheck: function(t) {
                        if (b.State.prefixMatches[t]) return [b.State.prefixMatches[t], !0];
                        for (var e = ["", "Webkit", "Moz", "ms", "O"], i = 0, n = e.length; n > i; i++) {
                            var a;
                            if (a = 0 === i ? t : e[i] + t.replace(/^\w/, function(t) {
                                    return t.toUpperCase()
                                }), g.isString(b.State.prefixElement.style[a])) return b.State.prefixMatches[t] = a, [a, !0]
                        }
                        return [t, !1]
                    }
                },
                Values: {
                    hexToRgb: function(t) {
                        var e, i = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
                            n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
                        return t = t.replace(i, function(t, e, i, n) {
                            return e + e + i + i + n + n
                        }), e = n.exec(t), e ? [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)] : [0, 0, 0]
                    },
                    isCSSNullValue: function(t) {
                        return 0 == t || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(t)
                    },
                    getUnitType: function(t) {
                        return /^(rotate|skew)/i.test(t) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(t) ? "" : "px"
                    },
                    getDisplayType: function(t) {
                        var e = t && t.tagName.toString().toLowerCase();
                        return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(e) ? "inline" : /^(li)$/i.test(e) ? "list-item" : /^(tr)$/i.test(e) ? "table-row" : /^(table)$/i.test(e) ? "table" : /^(tbody)$/i.test(e) ? "table-row-group" : "block"
                    },
                    addClass: function(t, e) {
                        t.classList ? t.classList.add(e) : t.className += (t.className.length ? " " : "") + e
                    },
                    removeClass: function(t, e) {
                        t.classList ? t.classList.remove(e) : t.className = t.className.toString().replace(new RegExp("(^|\\s)" + e.split(" ").join("|") + "(\\s|$)", "gi"), " ")
                    }
                },
                getPropertyValue: function(t, i, a, o) {
                    function s(t, i) {
                        function a() {
                            u && x.setPropertyValue(t, "display", "none")
                        }
                        var l = 0;
                        if (8 >= h) l = p.css(t, i);
                        else {
                            var u = !1;
                            if (/^(width|height)$/.test(i) && 0 === x.getPropertyValue(t, "display") && (u = !0, x.setPropertyValue(t, "display", x.Values.getDisplayType(t))), !o) {
                                if ("height" === i && "border-box" !== x.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                                    var c = t.offsetHeight - (parseFloat(x.getPropertyValue(t, "borderTopWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "borderBottomWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingTop")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingBottom")) || 0);
                                    return a(), c
                                }
                                if ("width" === i && "border-box" !== x.getPropertyValue(t, "boxSizing").toString().toLowerCase()) {
                                    var d = t.offsetWidth - (parseFloat(x.getPropertyValue(t, "borderLeftWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "borderRightWidth")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingLeft")) || 0) - (parseFloat(x.getPropertyValue(t, "paddingRight")) || 0);
                                    return a(), d
                                }
                            }
                            var f;
                            f = r(t) === n ? e.getComputedStyle(t, null) : r(t).computedStyle ? r(t).computedStyle : r(t).computedStyle = e.getComputedStyle(t, null), "borderColor" === i && (i = "borderTopColor"), l = 9 === h && "filter" === i ? f.getPropertyValue(i) : f[i], ("" === l || null === l) && (l = t.style[i]), a()
                        }
                        if ("auto" === l && /^(top|right|bottom|left)$/i.test(i)) {
                            var g = s(t, "position");
                            ("fixed" === g || "absolute" === g && /top|left/i.test(i)) && (l = p(t).position()[i] + "px")
                        }
                        return l
                    }
                    var l;
                    if (x.Hooks.registered[i]) {
                        var u = i,
                            c = x.Hooks.getRoot(u);
                        a === n && (a = x.getPropertyValue(t, x.Names.prefixCheck(c)[0])), x.Normalizations.registered[c] && (a = x.Normalizations.registered[c]("extract", t, a)), l = x.Hooks.extractValue(u, a)
                    } else if (x.Normalizations.registered[i]) {
                        var d, f;
                        d = x.Normalizations.registered[i]("name", t), "transform" !== d && (f = s(t, x.Names.prefixCheck(d)[0]), x.Values.isCSSNullValue(f) && x.Hooks.templates[i] && (f = x.Hooks.templates[i][1])), l = x.Normalizations.registered[i]("extract", t, f)
                    }
                    if (!/^[\d-]/.test(l))
                        if (r(t) && r(t).isSVG && x.Names.SVGAttribute(i))
                            if (/^(height|width)$/i.test(i)) try {
                                l = t.getBBox()[i]
                            } catch (g) {
                                l = 0
                            } else l = t.getAttribute(i);
                        else l = s(t, x.Names.prefixCheck(i)[0]);
                    return x.Values.isCSSNullValue(l) && (l = 0), b.debug >= 2 && console.log("Get " + i + ": " + l), l
                },
                setPropertyValue: function(t, i, n, a, o) {
                    var s = i;
                    if ("scroll" === i) o.container ? o.container["scroll" + o.direction] = n : "Left" === o.direction ? e.scrollTo(n, o.alternateValue) : e.scrollTo(o.alternateValue, n);
                    else if (x.Normalizations.registered[i] && "transform" === x.Normalizations.registered[i]("name", t)) x.Normalizations.registered[i]("inject", t, n), s = "transform", n = r(t).transformCache[i];
                    else {
                        if (x.Hooks.registered[i]) {
                            var l = i,
                                u = x.Hooks.getRoot(i);
                            a = a || x.getPropertyValue(t, u), n = x.Hooks.injectValue(l, n, a), i = u
                        }
                        if (x.Normalizations.registered[i] && (n = x.Normalizations.registered[i]("inject", t, n), i = x.Normalizations.registered[i]("name", t)), s = x.Names.prefixCheck(i)[0], 8 >= h) try {
                            t.style[s] = n
                        } catch (c) {
                            b.debug && console.log("Browser does not support [" + n + "] for [" + s + "]")
                        } else r(t) && r(t).isSVG && x.Names.SVGAttribute(i) ? t.setAttribute(i, n) : t.style[s] = n;
                        b.debug >= 2 && console.log("Set " + i + " (" + s + "): " + n)
                    }
                    return [s, n]
                },
                flushTransformCache: function(t) {
                    function e(e) {
                        return parseFloat(x.getPropertyValue(t, e))
                    }
                    var i = "";
                    if ((h || b.State.isAndroid && !b.State.isChrome) && r(t).isSVG) {
                        var n = {
                            translate: [e("translateX"), e("translateY")],
                            skewX: [e("skewX")],
                            skewY: [e("skewY")],
                            scale: 1 !== e("scale") ? [e("scale"), e("scale")] : [e("scaleX"), e("scaleY")],
                            rotate: [e("rotateZ"), 0, 0]
                        };
                        p.each(r(t).transformCache, function(t) {
                            /^translate/i.test(t) ? t = "translate" : /^scale/i.test(t) ? t = "scale" : /^rotate/i.test(t) && (t = "rotate"), n[t] && (i += t + "(" + n[t].join(" ") + ") ", delete n[t])
                        })
                    } else {
                        var a, o;
                        p.each(r(t).transformCache, function(e) {
                            return a = r(t).transformCache[e], "transformPerspective" === e ? (o = a, !0) : (9 === h && "rotateZ" === e && (e = "rotate"), void(i += e + a + " "))
                        }), o && (i = "perspective" + o + " " + i)
                    }
                    x.setPropertyValue(t, "transform", i)
                }
            };
            x.Hooks.register(), x.Normalizations.register(), b.hook = function(t, e, i) {
                var a = n;
                return t = o(t), p.each(t, function(t, o) {
                    if (r(o) === n && b.init(o), i === n) a === n && (a = b.CSS.getPropertyValue(o, e));
                    else {
                        var s = b.CSS.setPropertyValue(o, e, i);
                        "transform" === s[0] && b.CSS.flushTransformCache(o), a = s
                    }
                }), a
            };
            var k = function() {
                function t() {
                    return s ? P.promise || null : l
                }

                function a() {
                    function t() {
                        function t(t, e) {
                            var i = n,
                                a = n,
                                r = n;
                            return g.isArray(t) ? (i = t[0], !g.isArray(t[1]) && /^[\d-]/.test(t[1]) || g.isFunction(t[1]) || x.RegEx.isHex.test(t[1]) ? r = t[1] : (g.isString(t[1]) && !x.RegEx.isHex.test(t[1]) || g.isArray(t[1])) && (a = e ? t[1] : u(t[1], s.duration), t[2] !== n && (r = t[2]))) : i = t, e || (a = a || s.easing), g.isFunction(i) && (i = i.call(o, C, S)), g.isFunction(r) && (r = r.call(o, C, S)), [i || 0, a, r]
                        }

                        function d(t, e) {
                            var i, n;
                            return n = (e || "0").toString().toLowerCase().replace(/[%A-z]+$/, function(t) {
                                return i = t, ""
                            }), i || (i = x.Values.getUnitType(t)), [n, i]
                        }

                        function h() {
                            var t = {
                                    myParent: o.parentNode || i.body,
                                    position: x.getPropertyValue(o, "position"),
                                    fontSize: x.getPropertyValue(o, "fontSize")
                                },
                                n = t.position === I.lastPosition && t.myParent === I.lastParent,
                                a = t.fontSize === I.lastFontSize;
                            I.lastParent = t.myParent, I.lastPosition = t.position, I.lastFontSize = t.fontSize;
                            var s = 100,
                                l = {};
                            if (a && n) l.emToPx = I.lastEmToPx, l.percentToPxWidth = I.lastPercentToPxWidth, l.percentToPxHeight = I.lastPercentToPxHeight;
                            else {
                                var u = r(o).isSVG ? i.createElementNS("http://www.w3.org/2000/svg", "rect") : i.createElement("div");
                                b.init(u), t.myParent.appendChild(u), p.each(["overflow", "overflowX", "overflowY"], function(t, e) {
                                    b.CSS.setPropertyValue(u, e, "hidden")
                                }), b.CSS.setPropertyValue(u, "position", t.position), b.CSS.setPropertyValue(u, "fontSize", t.fontSize), b.CSS.setPropertyValue(u, "boxSizing", "content-box"), p.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(t, e) {
                                    b.CSS.setPropertyValue(u, e, s + "%")
                                }), b.CSS.setPropertyValue(u, "paddingLeft", s + "em"), l.percentToPxWidth = I.lastPercentToPxWidth = (parseFloat(x.getPropertyValue(u, "width", null, !0)) || 1) / s, l.percentToPxHeight = I.lastPercentToPxHeight = (parseFloat(x.getPropertyValue(u, "height", null, !0)) || 1) / s, l.emToPx = I.lastEmToPx = (parseFloat(x.getPropertyValue(u, "paddingLeft")) || 1) / s, t.myParent.removeChild(u)
                            }
                            return null === I.remToPx && (I.remToPx = parseFloat(x.getPropertyValue(i.body, "fontSize")) || 16), null === I.vwToPx && (I.vwToPx = parseFloat(e.innerWidth) / 100, I.vhToPx = parseFloat(e.innerHeight) / 100), l.remToPx = I.remToPx, l.vwToPx = I.vwToPx, l.vhToPx = I.vhToPx, b.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(l), o), l
                        }
                        if (s.begin && 0 === C) try {
                            s.begin.call(f, f)
                        } catch (m) {
                            setTimeout(function() {
                                throw m
                            }, 1)
                        }
                        if ("scroll" === O) {
                            var w, k, $, T = /^x$/i.test(s.axis) ? "Left" : "Top",
                                A = parseFloat(s.offset) || 0;
                            s.container ? g.isWrapped(s.container) || g.isNode(s.container) ? (s.container = s.container[0] || s.container, w = s.container["scroll" + T], $ = w + p(o).position()[T.toLowerCase()] + A) : s.container = null : (w = b.State.scrollAnchor[b.State["scrollProperty" + T]], k = b.State.scrollAnchor[b.State["scrollProperty" + ("Left" === T ? "Top" : "Left")]], $ = p(o).offset()[T.toLowerCase()] + A), l = {
                                scroll: {
                                    rootPropertyValue: !1,
                                    startValue: w,
                                    currentValue: w,
                                    endValue: $,
                                    unitType: "",
                                    easing: s.easing,
                                    scrollData: {
                                        container: s.container,
                                        direction: T,
                                        alternateValue: k
                                    }
                                },
                                element: o
                            }, b.debug && console.log("tweensContainer (scroll): ", l.scroll, o)
                        } else if ("reverse" === O) {
                            if (!r(o).tweensContainer) return void p.dequeue(o, s.queue);
                            "none" === r(o).opts.display && (r(o).opts.display = "auto"), "hidden" === r(o).opts.visibility && (r(o).opts.visibility = "visible"), r(o).opts.loop = !1, r(o).opts.begin = null, r(o).opts.complete = null, y.easing || delete s.easing, y.duration || delete s.duration, s = p.extend({}, r(o).opts, s);
                            var _ = p.extend(!0, {}, r(o).tweensContainer);
                            for (var E in _)
                                if ("element" !== E) {
                                    var M = _[E].startValue;
                                    _[E].startValue = _[E].currentValue = _[E].endValue, _[E].endValue = M, g.isEmptyObject(y) || (_[E].easing = s.easing), b.debug && console.log("reverse tweensContainer (" + E + "): " + JSON.stringify(_[E]), o)
                                }
                            l = _
                        } else if ("start" === O) {
                            var _;
                            r(o).tweensContainer && r(o).isAnimating === !0 && (_ = r(o).tweensContainer), p.each(v, function(e, i) {
                                if (RegExp("^" + x.Lists.colors.join("$|^") + "$").test(e)) {
                                    var a = t(i, !0),
                                        o = a[0],
                                        r = a[1],
                                        s = a[2];
                                    if (x.RegEx.isHex.test(o)) {
                                        for (var l = ["Red", "Green", "Blue"], u = x.Values.hexToRgb(o), c = s ? x.Values.hexToRgb(s) : n, d = 0; d < l.length; d++) {
                                            var p = [u[d]];
                                            r && p.push(r), c !== n && p.push(c[d]), v[e + l[d]] = p
                                        }
                                        delete v[e]
                                    }
                                }
                            });
                            for (var D in v) {
                                var q = t(v[D]),
                                    z = q[0],
                                    L = q[1],
                                    V = q[2];
                                D = x.Names.camelCase(D);
                                var N = x.Hooks.getRoot(D),
                                    F = !1;
                                if (r(o).isSVG || "tween" === N || x.Names.prefixCheck(N)[1] !== !1 || x.Normalizations.registered[N] !== n) {
                                    (s.display !== n && null !== s.display && "none" !== s.display || s.visibility !== n && "hidden" !== s.visibility) && /opacity|filter/.test(D) && !V && 0 !== z && (V = 0), s._cacheValues && _ && _[D] ? (V === n && (V = _[D].endValue + _[D].unitType), F = r(o).rootPropertyValueCache[N]) : x.Hooks.registered[D] ? V === n ? (F = x.getPropertyValue(o, N), V = x.getPropertyValue(o, D, F)) : F = x.Hooks.templates[N][1] : V === n && (V = x.getPropertyValue(o, D));
                                    var W, Q, R, H = !1;
                                    if (W = d(D, V), V = W[0], R = W[1], W = d(D, z), z = W[0].replace(/^([+-\/*])=/, function(t, e) {
                                            return H = e, ""
                                        }), Q = W[1], V = parseFloat(V) || 0, z = parseFloat(z) || 0, "%" === Q && (/^(fontSize|lineHeight)$/.test(D) ? (z /= 100, Q = "em") : /^scale/.test(D) ? (z /= 100, Q = "") : /(Red|Green|Blue)$/i.test(D) && (z = z / 100 * 255, Q = "")), /[\/*]/.test(H)) Q = R;
                                    else if (R !== Q && 0 !== V)
                                        if (0 === z) Q = R;
                                        else {
                                            a = a || h();
                                            var X = /margin|padding|left|right|width|text|word|letter/i.test(D) || /X$/.test(D) || "x" === D ? "x" : "y";
                                            switch (R) {
                                                case "%":
                                                    V *= "x" === X ? a.percentToPxWidth : a.percentToPxHeight;
                                                    break;
                                                case "px":
                                                    break;
                                                default:
                                                    V *= a[R + "ToPx"]
                                            }
                                            switch (Q) {
                                                case "%":
                                                    V *= 1 / ("x" === X ? a.percentToPxWidth : a.percentToPxHeight);
                                                    break;
                                                case "px":
                                                    break;
                                                default:
                                                    V *= 1 / a[Q + "ToPx"]
                                            }
                                        }
                                    switch (H) {
                                        case "+":
                                            z = V + z;
                                            break;
                                        case "-":
                                            z = V - z;
                                            break;
                                        case "*":
                                            z = V * z;
                                            break;
                                        case "/":
                                            z = V / z
                                    }
                                    l[D] = {
                                        rootPropertyValue: F,
                                        startValue: V,
                                        currentValue: V,
                                        endValue: z,
                                        unitType: Q,
                                        easing: L
                                    }, b.debug && console.log("tweensContainer (" + D + "): " + JSON.stringify(l[D]), o)
                                } else b.debug && console.log("Skipping [" + N + "] due to a lack of browser support.")
                            }
                            l.element = o
                        }
                        l.element && (x.Values.addClass(o, "velocity-animating"), j.push(l), "" === s.queue && (r(o).tweensContainer = l, r(o).opts = s), r(o).isAnimating = !0, C === S - 1 ? (b.State.calls.push([j, f, s, null, P.resolver]), b.State.isTicking === !1 && (b.State.isTicking = !0, c())) : C++)
                    }
                    var a, o = this,
                        s = p.extend({}, b.defaults, y),
                        l = {};
                    switch (r(o) === n && b.init(o), parseFloat(s.delay) && s.queue !== !1 && p.queue(o, s.queue, function(t) {
                        b.velocityQueueEntryFlag = !0, r(o).delayTimer = {
                            setTimeout: setTimeout(t, parseFloat(s.delay)),
                            next: t
                        }
                    }), s.duration.toString().toLowerCase()) {
                        case "fast":
                            s.duration = 200;
                            break;
                        case "normal":
                            s.duration = m;
                            break;
                        case "slow":
                            s.duration = 600;
                            break;
                        default:
                            s.duration = parseFloat(s.duration) || 1
                    }
                    b.mock !== !1 && (b.mock === !0 ? s.duration = s.delay = 1 : (s.duration *= parseFloat(b.mock) || 1, s.delay *= parseFloat(b.mock) || 1)), s.easing = u(s.easing, s.duration), s.begin && !g.isFunction(s.begin) && (s.begin = null), s.progress && !g.isFunction(s.progress) && (s.progress = null), s.complete && !g.isFunction(s.complete) && (s.complete = null), s.display !== n && null !== s.display && (s.display = s.display.toString().toLowerCase(), "auto" === s.display && (s.display = b.CSS.Values.getDisplayType(o))), s.visibility !== n && null !== s.visibility && (s.visibility = s.visibility.toString().toLowerCase()), s.mobileHA = s.mobileHA && b.State.isMobile && !b.State.isGingerbread, s.queue === !1 ? s.delay ? setTimeout(t, s.delay) : t() : p.queue(o, s.queue, function(e, i) {
                        return i === !0 ? (P.promise && P.resolver(f), !0) : (b.velocityQueueEntryFlag = !0, void t(e))
                    }), "" !== s.queue && "fx" !== s.queue || "inprogress" === p.queue(o)[0] || p.dequeue(o)
                }
                var s, l, h, f, v, y, w = arguments[0] && (arguments[0].p || p.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || g.isString(arguments[0].properties));
                if (g.isWrapped(this) ? (s = !1, h = 0, f = this, l = this) : (s = !0, h = 1, f = w ? arguments[0].elements || arguments[0].e : arguments[0]), f = o(f)) {
                    w ? (v = arguments[0].properties || arguments[0].p, y = arguments[0].options || arguments[0].o) : (v = arguments[h], y = arguments[h + 1]);
                    var S = f.length,
                        C = 0;
                    if (!/^(stop|finish)$/i.test(v) && !p.isPlainObject(y)) {
                        var $ = h + 1;
                        y = {};
                        for (var T = $; T < arguments.length; T++) g.isArray(arguments[T]) || !/^(fast|normal|slow)$/i.test(arguments[T]) && !/^\d/.test(arguments[T]) ? g.isString(arguments[T]) || g.isArray(arguments[T]) ? y.easing = arguments[T] : g.isFunction(arguments[T]) && (y.complete = arguments[T]) : y.duration = arguments[T]
                    }
                    var P = {
                        promise: null,
                        resolver: null,
                        rejecter: null
                    };
                    s && b.Promise && (P.promise = new b.Promise(function(t, e) {
                        P.resolver = t, P.rejecter = e
                    }));
                    var O;
                    switch (v) {
                        case "scroll":
                            O = "scroll";
                            break;
                        case "reverse":
                            O = "reverse";
                            break;
                        case "finish":
                        case "stop":
                            p.each(f, function(t, e) {
                                r(e) && r(e).delayTimer && (clearTimeout(r(e).delayTimer.setTimeout), r(e).delayTimer.next && r(e).delayTimer.next(), delete r(e).delayTimer)
                            });
                            var A = [];
                            return p.each(b.State.calls, function(t, e) {
                                e && p.each(e[1], function(i, a) {
                                    var o = y === n ? "" : y;
                                    return o === !0 || e[2].queue === o || y === n && e[2].queue === !1 ? void p.each(f, function(i, n) {
                                        n === a && ((y === !0 || g.isString(y)) && (p.each(p.queue(n, g.isString(y) ? y : ""), function(t, e) {
                                            g.isFunction(e) && e(null, !0)
                                        }), p.queue(n, g.isString(y) ? y : "", [])), "stop" === v ? (r(n) && r(n).tweensContainer && o !== !1 && p.each(r(n).tweensContainer, function(t, e) {
                                            e.endValue = e.currentValue
                                        }), A.push(t)) : "finish" === v && (e[2].duration = 1))
                                    }) : !0
                                })
                            }), "stop" === v && (p.each(A, function(t, e) {
                                d(e, !0)
                            }), P.promise && P.resolver(f)), t();
                        default:
                            if (!p.isPlainObject(v) || g.isEmptyObject(v)) {
                                if (g.isString(v) && b.Redirects[v]) {
                                    var _ = p.extend({}, y),
                                        E = _.duration,
                                        M = _.delay || 0;
                                    return _.backwards === !0 && (f = p.extend(!0, [], f).reverse()), p.each(f, function(t, e) {
                                        parseFloat(_.stagger) ? _.delay = M + parseFloat(_.stagger) * t : g.isFunction(_.stagger) && (_.delay = M + _.stagger.call(e, t, S)), _.drag && (_.duration = parseFloat(E) || (/^(callout|transition)/.test(v) ? 1e3 : m), _.duration = Math.max(_.duration * (_.backwards ? 1 - t / S : (t + 1) / S), .75 * _.duration, 200)), b.Redirects[v].call(e, e, _ || {}, t, S, f, P.promise ? P : n)
                                    }), t()
                                }
                                var D = "Velocity: First argument (" + v + ") was not a property map, a known action, or a registered redirect. Aborting.";
                                return P.promise ? P.rejecter(new Error(D)) : console.log(D), t()
                            }
                            O = "start"
                    }
                    var I = {
                            lastParent: null,
                            lastPosition: null,
                            lastFontSize: null,
                            lastPercentToPxWidth: null,
                            lastPercentToPxHeight: null,
                            lastEmToPx: null,
                            remToPx: null,
                            vwToPx: null,
                            vhToPx: null
                        },
                        j = [];
                    p.each(f, function(t, e) {
                        g.isNode(e) && a.call(e)
                    });
                    var q, _ = p.extend({}, b.defaults, y);
                    if (_.loop = parseInt(_.loop), q = 2 * _.loop - 1, _.loop)
                        for (var z = 0; q > z; z++) {
                            var L = {
                                delay: _.delay,
                                progress: _.progress
                            };
                            z === q - 1 && (L.display = _.display, L.visibility = _.visibility, L.complete = _.complete), k(f, "reverse", L)
                        }
                    return t()
                }
            };
            b = p.extend(k, b), b.animate = k;
            var S = e.requestAnimationFrame || f;
            return b.State.isMobile || i.hidden === n || i.addEventListener("visibilitychange", function() {
                i.hidden ? (S = function(t) {
                    return setTimeout(function() {
                        t(!0)
                    }, 16)
                }, c()) : S = e.requestAnimationFrame || f
            }), t.Velocity = b, t !== e && (t.fn.velocity = k, t.fn.velocity.defaults = b.defaults), p.each(["Down", "Up"], function(t, e) {
                b.Redirects["slide" + e] = function(t, i, a, o, r, s) {
                    var l = p.extend({}, i),
                        u = l.begin,
                        c = l.complete,
                        d = {
                            height: "",
                            marginTop: "",
                            marginBottom: "",
                            paddingTop: "",
                            paddingBottom: ""
                        },
                        h = {};
                    l.display === n && (l.display = "Down" === e ? "inline" === b.CSS.Values.getDisplayType(t) ? "inline-block" : "block" : "none"), l.begin = function() {
                        u && u.call(r, r);
                        for (var i in d) {
                            h[i] = t.style[i];
                            var n = b.CSS.getPropertyValue(t, i);
                            d[i] = "Down" === e ? [n, 0] : [0, n]
                        }
                        h.overflow = t.style.overflow, t.style.overflow = "hidden"
                    }, l.complete = function() {
                        for (var e in h) t.style[e] = h[e];
                        c && c.call(r, r), s && s.resolver(r)
                    }, b(t, d, l)
                }
            }), p.each(["In", "Out"], function(t, e) {
                b.Redirects["fade" + e] = function(t, i, a, o, r, s) {
                    var l = p.extend({}, i),
                        u = {
                            opacity: "In" === e ? 1 : 0
                        },
                        c = l.complete;
                    l.complete = a !== o - 1 ? l.begin = null : function() {
                        c && c.call(r, r), s && s.resolver(r)
                    }, l.display === n && (l.display = "In" === e ? "auto" : "none"), b(this, u, l)
                }
            }), b
        }(window.jQuery || window.Zepto || window, window, document)
    }), jQuery.extend(jQuery.easing, {
    easeInOutMaterial: function(t, e, i, n, a) {
        return (e /= a / 2) < 1 ? n / 2 * e * e + i : n / 4 * ((e -= 2) * e * e + 2) + i
    }
}),
    function(t) {
        t(document).ready(function() {
            t.fn.reverse = [].reverse, t(document).on("mouseenter.fixedActionBtn", ".fixed-action-btn", function() {
                var i = t(this);
                e(i)
            }), t(document).on("mouseleave.fixedActionBtn", ".fixed-action-btn", function() {
                var e = t(this);
                i(e)
            })
        }), t.fn.extend({
            openFAB: function() {
                var i = t(this);
                e(i)
            },
            closeFAB: function() {
                i($this)
            }
        });
        var e = function(e) {
                if ($this = e, $this.hasClass("active") === !1) {
                    $this.addClass("active"), $this.find("ul .btn-floating").velocity({
                        scaleY: ".4",
                        scaleX: ".4",
                        translateY: "40px"
                    }, {
                        duration: 0
                    });
                    var i = 0;
                    $this.find("ul .btn-floating").reverse().each(function() {
                        t(this).velocity({
                            opacity: "1",
                            scaleX: "1",
                            scaleY: "1",
                            translateY: "0"
                        }, {
                            duration: 80,
                            delay: i
                        }), i += 40
                    })
                }
            },
            i = function(t) {
                $this = t, $this.removeClass("active");
                $this.find("ul .btn-floating").velocity("stop", !0), $this.find("ul .btn-floating").velocity({
                    opacity: "0",
                    scaleX: ".4",
                    scaleY: ".4",
                    translateY: "40px"
                }, {
                    duration: 80
                })
            }
    }(jQuery),
    function(t) {
        t(document).ready(function() {
            t(document).on("click.card", ".card", function(e) {
                t(this).find(".card-reveal").length && (t(e.target).is(t(".card-reveal .card-title")) || t(e.target).is(t(".card-reveal .card-title i")) ? t(this).find(".card-reveal").velocity({
                    translateY: 0
                }, {
                    duration: 225,
                    queue: !1,
                    easing: "easeInOutQuad",
                    complete: function() {
                        t(this).css({
                            display: "none"
                        })
                    }
                }) : (t(e.target).is(t(".card .activator")) || t(e.target).is(t(".card .activator i"))) && t(this).find(".card-reveal").css({
                    display: "block"
                }).velocity("stop", !1).velocity({
                    translateY: "-100%"
                }, {
                    duration: 300,
                    queue: !1,
                    easing: "easeInOutQuad"
                }))
            })
        })
    }(jQuery),
    function(t) {
        function e() {
            var e = +t(this).attr("length"),
                i = +t(this).val().length,
                n = e >= i;
            t(this).parent().find('span[class="character-counter"]').html(i + "/" + e), a(n, t(this))
        }

        function i(e) {
            var i = t("<span/>").addClass("character-counter").css("float", "right").css("font-size", "12px").css("height", 1);
            e.parent().append(i)
        }

        function n() {
            t(this).parent().find('span[class="character-counter"]').html("")
        }

        function a(t, e) {
            var i = e.hasClass("invalid");
            t && i ? e.removeClass("invalid") : t || i || (e.removeClass("valid"), e.addClass("invalid"))
        }
        t.fn.characterCounter = function() {
            return this.each(function() {
                var a = void 0 !== t(this).attr("length");
                a && (t(this).on("input", e), t(this).on("focus", e), t(this).on("blur", n), i(t(this)))
            })
        }, t(document).ready(function() {
            t("input, textarea").characterCounter()
        })
    }(jQuery),
    function(t) {
        t(document).ready(function() {
            t(document).on("click.chip", ".chip .material-icons", function() {
                t(this).parent().remove()
            })
        })
    }(jQuery),
    function(t) {
        t.fn.collapsible = function(e) {
            var i = {
                accordion: void 0
            };
            return e = t.extend(i, e), this.each(function() {
                function i(e) {
                    s = r.find("> li > .collapsible-header"), e.hasClass("active") ? e.parent().addClass("active") : e.parent().removeClass("active"), e.parent().hasClass("active") ? e.siblings(".collapsible-body").stop(!0, !1).slideDown({
                        duration: 350,
                        easing: "easeOutQuart",
                        queue: !1,
                        complete: function() {
                            t(this).css("height", "")
                        }
                    }) : e.siblings(".collapsible-body").stop(!0, !1).slideUp({
                        duration: 350,
                        easing: "easeOutQuart",
                        queue: !1,
                        complete: function() {
                            t(this).css("height", "")
                        }
                    }), s.not(e).removeClass("active").parent().removeClass("active"), s.not(e).parent().children(".collapsible-body").stop(!0, !1).slideUp({
                        duration: 350,
                        easing: "easeOutQuart",
                        queue: !1,
                        complete: function() {
                            t(this).css("height", "")
                        }
                    })
                }

                function n(e) {
                    e.hasClass("active") ? e.parent().addClass("active") : e.parent().removeClass("active"), e.parent().hasClass("active") ? e.siblings(".collapsible-body").stop(!0, !1).slideDown({
                        duration: 350,
                        easing: "easeOutQuart",
                        queue: !1,
                        complete: function() {
                            t(this).css("height", "")
                        }
                    }) : e.siblings(".collapsible-body").stop(!0, !1).slideUp({
                        duration: 350,
                        easing: "easeOutQuart",
                        queue: !1,
                        complete: function() {
                            t(this).css("height", "")
                        }
                    })
                }

                function a(t) {
                    var e = o(t);
                    return e.length > 0
                }

                function o(t) {
                    return t.closest("li > .collapsible-header")
                }
                var r = t(this),
                    s = t(this).find("> li > .collapsible-header"),
                    l = r.data("collapsible");
                r.off("click.collapse", ".collapsible-header"), s.off("click.collapse"), e.accordion || "accordion" === l || void 0 === l ? (s = r.find("> li > .collapsible-header"), s.on("click.collapse", function(e) {
                    var n = t(e.target);
                    a(n) && (n = o(n)), n.toggleClass("active"), i(n)
                }), i(s.filter(".active").first())) : s.each(function() {
                    t(this).on("click.collapse", function(e) {
                        var i = t(e.target);
                        a(i) && (i = o(i)), i.toggleClass("active"), n(i)
                    }), t(this).hasClass("active") && n(t(this))
                })
            })
        }, t(document).ready(function() {
            t(".collapsible").collapsible()
        })
    }(jQuery),
    function(t) {
        t.fn.scrollTo = function(e) {
            return t(this).scrollTop(t(this).scrollTop() - t(this).offset().top + t(e).offset().top), this
        }, t.fn.dropdown = function(e) {
            var i = {
                inDuration: 300,
                outDuration: 225,
                constrain_width: !0,
                hover: !1,
                gutter: 0,
                belowOrigin: !1
            };
            this.each(function() {
                function n() {
                    void 0 != r.data("induration") && (s.inDuration = r.data("inDuration")), void 0 != r.data("outduration") && (s.outDuration = r.data("outDuration")), void 0 != r.data("constrainwidth") && (s.constrain_width = r.data("constrainwidth")), void 0 != r.data("hover") && (s.hover = r.data("hover")), void 0 != r.data("gutter") && (s.gutter = r.data("gutter")), void 0 != r.data("beloworigin") && (s.belowOrigin = r.data("beloworigin"))
                }

                function a() {
                    n(), l.addClass("active"), 1 == s.constrain_width && l.css("width", r.outerWidth());
                    var e = 0;
                    1 == s.belowOrigin && (e = r.height());
                    var i = r.offset().left,
                        a = 0,
                        o = s.gutter;
                    i + l.innerWidth() > t(window).width() && (a = r.innerWidth() - l.innerWidth(), o = -1 * o), l.css({
                        position: "absolute",
                        top: r.position().top + e,
                        left: r.position().left + a + o
                    }), l.stop(!0, !0).css("opacity", 0).slideDown({
                        queue: !1,
                        duration: s.inDuration,
                        easing: "easeOutCubic",
                        complete: function() {
                            t(this).css("height", "")
                        }
                    }).animate({
                        opacity: 1
                    }, {
                        queue: !1,
                        duration: s.inDuration,
                        easing: "easeOutSine"
                    })
                }

                function o() {
                    l.fadeOut(s.outDuration), l.removeClass("active")
                }
                var r = t(this),
                    s = t.extend({}, i, e),
                    l = t("#" + r.attr("data-activates"));
                if (n(), r.after(l), s.hover) {
                    var u = !1;
                    r.unbind("click." + r.attr("id")), r.on("mouseenter", function() {
                        u === !1 && (a(), u = !0)
                    }), r.on("mouseleave", function(e) {
                        t(e.toElement).closest(".dropdown-content").is(l) || (l.stop(!0, !0), o(), u = !1)
                    }), l.on("mouseleave", function(e) {
                        t(e.toElement).closest(".dropdown-button").is(r) || (l.stop(!0, !0), o(), u = !1)
                    })
                } else r.parent(".btn-group")[0] && (r = r.parent(".btn-group")), r.unbind("click." + r.attr("id")), r.bind("click." + r.attr("id"), function(e) {
                    r[0] == e.currentTarget && 0 === t(e.target).closest(".dropdown-content").length ? (e.preventDefault(), a()) : r.hasClass("active") && (o(), t(document).unbind("click." + l.attr("id"))), l.hasClass("active") && t(document).bind("click." + l.attr("id"), function(e) {
                        !l.is(e.target) && !r.is(e.target) && !r.find(e.target).length > 0 && (o(), t(document).unbind("click." + l.attr("id")))
                    })
                });
                r.on("open", a), r.on("close", o)
            })
        }, t(document).ready(function() {
            t(".dropdown-button").dropdown()
        })
    }(jQuery),
    function(t) {
        t(document).ready(function() {
            function e(e) {
                var i = e.css("font-family"),
                    a = e.css("font-size");
                a && n.css("font-size", a), i && n.css("font-family", i), "off" === e.attr("wrap") && n.css("overflow-wrap", "normal").css("white-space", "pre"), n.text(e.val() + "\n");
                var o = n.html().replace(/\n/g, "<br>");
                n.html(o), e.is(":visible") ? n.css("width", e.width()) : n.css("width", t(window).width() / 2), e.css("height", n.height())
            }
            Materialize.updateTextFields = function() {
                var e = "input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea";
                t(e).each(function(e, i) {
                    t(i).val().length > 0 || void 0 !== t(this).attr("placeholder") || t(i)[0].validity.badInput === !0 ? t(this).siblings("label").addClass("active") : t(this).siblings("label, i").removeClass("active")
                })
            };
            var i = "input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea";
            t("input[autofocus]").siblings("label, i").addClass("active"), t(document).on("change", i, function() {
                (0 !== t(this).val().length || void 0 !== t(this).attr("placeholder")) && t(this).siblings("label").addClass("active"), validate_field(t(this))
            }), t(document).ready(function() {
                Materialize.updateTextFields()
            }), t(document).on("reset", function(e) {
                var n = t(e.target);
                n.is("form") && (n.find(i).removeClass("valid").removeClass("invalid"), n.find(i).each(function() {
                    "" === t(this).attr("value") && t(this).siblings("label, i").removeClass("active")
                }), n.find("select.initialized").each(function() {
                    var t = n.find("option[selected]").text();
                    n.siblings("input.select-dropdown").val(t)
                }))
            }), t(document).on("focus", i, function() {
                t(this).siblings("label, i").addClass("active")
            }), t(document).on("blur", i, function() {
                var e = t(this);
                0 === e.val().length && e[0].validity.badInput !== !0 && void 0 === e.attr("placeholder") && e.siblings("label, i").removeClass("active"), 0 === e.val().length && e[0].validity.badInput !== !0 && void 0 !== e.attr("placeholder") && e.siblings("i").removeClass("active"), validate_field(e)
            }), validate_field = function(t) {
                var e = void 0 !== t.attr("length"),
                    i = parseInt(t.attr("length")),
                    n = t.val().length;
                0 === t.val().length && t[0].validity.badInput === !1 ? t.hasClass("validate") && (t.removeClass("valid"), t.removeClass("invalid")) : t.hasClass("validate") && (t.is(":valid") && e && i > n || t.is(":valid") && !e ? (t.removeClass("invalid"), t.addClass("valid")) : (t.removeClass("valid"), t.addClass("invalid")))
            };
            var n = t(".hiddendiv").first();
            n.length || (n = t('<div class="hiddendiv common"></div>'), t("body").append(n));
            var a = ".materialize-textarea";
            t(a).each(function() {
                var i = t(this);
                i.val().length && e(i)
            }), t("body").on("keyup keydown autoresize", a, function() {
                e(t(this))
            }), t(document).on("change", '.file-field input[type="file"]', function() {
                for (var e = t(this).closest(".file-field"), i = e.find("input.file-path"), n = t(this)[0].files, a = [], o = 0; o < n.length; o++) a.push(n[o].name);
                i.val(a.join(", ")), i.trigger("change")
            });
            var o, r = "input[type=range]",
                s = !1;
            t(r).each(function() {
                var e = t('<span class="thumb"><span class="value"></span></span>');
                t(this).after(e)
            });
            var l = ".range-field";
            t(document).on("change", r, function() {
                var e = t(this).siblings(".thumb");
                e.find(".value").html(t(this).val())
            }), t(document).on("input mousedown touchstart", r, function(e) {
                var i = t(this).siblings(".thumb");
                i.length <= 0 && (i = t('<span class="thumb"><span class="value"></span></span>'), t(this).append(i)), i.find(".value").html(t(this).val()), s = !0, t(this).addClass("active"), i.hasClass("active") || i.velocity({
                    height: "30px",
                    width: "30px",
                    top: "-20px",
                    marginLeft: "-15px"
                }, {
                    duration: 300,
                    easing: "easeOutExpo"
                }), o = void 0 === e.pageX || null === e.pageX ? e.originalEvent.touches[0].pageX - t(this).offset().left : e.pageX - t(this).offset().left;
                var n = t(this).outerWidth();
                0 > o ? o = 0 : o > n && (o = n), i.addClass("active").css("left", o), i.find(".value").html(t(this).val())
            }), t(document).on("mouseup touchend", l, function() {
                s = !1, t(this).removeClass("active")
            }), t(document).on("mousemove touchmove", l, function(e) {
                var i, n = t(this).children(".thumb");
                if (s) {
                    n.hasClass("active") || n.velocity({
                        height: "30px",
                        width: "30px",
                        top: "-20px",
                        marginLeft: "-15px"
                    }, {
                        duration: 300,
                        easing: "easeOutExpo"
                    }), i = void 0 === e.pageX || null === e.pageX ? e.originalEvent.touches[0].pageX - t(this).offset().left : e.pageX - t(this).offset().left;
                    var a = t(this).outerWidth();
                    0 > i ? i = 0 : i > a && (i = a), n.addClass("active").css("left", i), n.find(".value").html(n.siblings(r).val())
                }
            }), t(document).on("mouseout touchleave", l, function() {
                if (!s) {
                    var e = t(this).children(".thumb");
                    e.hasClass("active") && e.velocity({
                        height: "0",
                        width: "0",
                        top: "10px",
                        marginLeft: "-6px"
                    }, {
                        duration: 100
                    }), e.removeClass("active")
                }
            })
        }), t.fn.material_select = function(e) {
            t(this).each(function() {
                if ($select = t(this), !$select.hasClass("browser-default")) {
                    var i = $select.data("select-id");
                    if (i && ($select.parent().find("span.caret").remove(), $select.parent().find("input").remove(), $select.unwrap(), t("ul#select-options-" + i).remove()), "destroy" === e) return void $select.data("select-id", null).removeClass("initialized");
                    var n = Materialize.guid();
                    $select.data("select-id", n);
                    var a = t('<div class="select-wrapper"></div>');
                    a.addClass($select.attr("class"));
                    var o, r = t('<ul id="select-options-' + n + '" class="dropdown-content select-dropdown"></ul>'),
                        s = $select.children("option");
                    o = void 0 !== $select.find("option:selected") ? $select.find("option:selected") : r.first(), s.each(function() {
                        r.append(t('<li class="' + (t(this).is(":disabled") ? "disabled" : "") + '"><span>' + t(this).html() + "</span></li>"))
                    }), r.find("li").each(function(i) {
                        var n = $select;
                        t(this).click(function() {
                            t(this).hasClass("disabled") || (n.find("option").eq(i).prop("selected", !0), n.trigger("change"), n.siblings("input.select-dropdown").val(t(this).text()), "undefined" != typeof e && e())
                        })
                    }), $select.wrap(a);
                    var l = t('<span class="caret">&#9660;</span>');
                    $select.is(":disabled") && l.addClass("disabled");
                    var u,
                        c;

                    if (o.length > 0) {
                        u = o.html().replace(/"/g, "&quot;")
                    }

                    c = t('<input type="text" class="select-dropdown" readonly="true" ' + ($select.is(":disabled") ? "disabled" : "") + ' data-activates="select-options-' + n + '" value="' + u + '"/>');


                    $select.before(c), c.before(l), t("body").append(r), $select.is(":disabled") || c.dropdown({
                        hover: !1
                    }), $select.attr("tabindex") && t(c[0]).attr("tabindex", $select.attr("tabindex")), $select.addClass("initialized"), c.on("focus", function() {
                        t(this).trigger("open"), o = t(this).val(), selectedOption = r.find("li").filter(function() {
                            return t(this).text().toLowerCase() === o.toLowerCase()
                        })[0], activateOption(r, selectedOption)
                    }), c.on("blur", function() {
                        t(this).trigger("close")
                    }), activateOption = function(e, i) {
                        e.find("li.active").removeClass("active"), t(i).addClass("active"), e.scrollTo(i)
                    }, filterQuery = [], onKeyDown = function(e) {
                        if (9 == e.which) return void c.trigger("close");
                        if (40 == e.which && !r.is(":visible")) return void c.trigger("open");
                        if (13 != e.which || r.is(":visible")) {
                            e.preventDefault(), letter = String.fromCharCode(e.which).toLowerCase();
                            var i = [9, 13, 27, 38, 40];
                            letter && -1 === i.indexOf(e.which) && (filterQuery.push(letter), string = filterQuery.join(""), newOption = r.find("li").filter(function() {
                                return 0 === t(this).text().toLowerCase().indexOf(string)
                            })[0], newOption && activateOption(r, newOption)), 13 == e.which && (activeOption = r.find("li.active:not(.disabled)")[0], activeOption && (t(activeOption).trigger("click"), c.trigger("close"))), 40 == e.which && (newOption = r.find("li.active").next("li:not(.disabled)")[0], newOption && activateOption(r, newOption)), 27 == e.which && c.trigger("close"), 38 == e.which && (newOption = r.find("li.active").prev("li:not(.disabled)")[0], newOption && activateOption(r, newOption)), setTimeout(function() {
                                filterQuery = []
                            }, 1e3)
                        }
                    }, c.on("keydown", onKeyDown)
                }
            })
        }
    }(jQuery), Materialize = {}, Materialize.guid = function() {
    function t() {
        return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)
    }
    return function() {
        return t() + t() + "-" + t() + "-" + t() + "-" + t() + "-" + t() + t() + t()
    }
}(), Materialize.elementOrParentIsFixed = function(t) {
    var e = $(t),
        i = e.add(e.parents()),
        n = !1;
    return i.each(function() {
        return "fixed" === $(this).css("position") ? (n = !0, !1) : void 0
    }), n
};
var Vel;
Vel = $ ? $.Velocity : Velocity, ! function(t, e, i, n) {
    "use strict";

    function a(t, e, i) {
        return setTimeout(c(t, i), e)
    }

    function o(t, e, i) {
        return Array.isArray(t) ? (r(t, i[e], i), !0) : !1
    }

    function r(t, e, i) {
        var a;
        if (t)
            if (t.forEach) t.forEach(e, i);
            else if (t.length !== n)
                for (a = 0; a < t.length;) e.call(i, t[a], a, t), a++;
            else
                for (a in t) t.hasOwnProperty(a) && e.call(i, t[a], a, t)
    }

    function s(t, e, i) {
        for (var a = Object.keys(e), o = 0; o < a.length;)(!i || i && t[a[o]] === n) && (t[a[o]] = e[a[o]]), o++;
        return t
    }

    function l(t, e) {
        return s(t, e, !0)
    }

    function u(t, e, i) {
        var n, a = e.prototype;
        n = t.prototype = Object.create(a), n.constructor = t, n._super = a, i && s(n, i)
    }

    function c(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }

    function d(t, e) {
        return typeof t == ce ? t.apply(e ? e[0] || n : n, e) : t
    }

    function p(t, e) {
        return t === n ? e : t
    }

    function h(t, e, i) {
        r(m(e), function(e) {
            t.addEventListener(e, i, !1)
        })
    }

    function f(t, e, i) {
        r(m(e), function(e) {
            t.removeEventListener(e, i, !1)
        })
    }

    function g(t, e) {
        for (; t;) {
            if (t == e) return !0;
            t = t.parentNode
        }
        return !1
    }

    function v(t, e) {
        return t.indexOf(e) > -1
    }

    function m(t) {
        return t.trim().split(/\s+/g)
    }

    function y(t, e, i) {
        if (t.indexOf && !i) return t.indexOf(e);
        for (var n = 0; n < t.length;) {
            if (i && t[n][i] == e || !i && t[n] === e) return n;
            n++
        }
        return -1
    }

    function b(t) {
        return Array.prototype.slice.call(t, 0)
    }

    function w(t, e, i) {
        for (var n = [], a = [], o = 0; o < t.length;) {
            var r = e ? t[o][e] : t[o];
            y(a, r) < 0 && n.push(t[o]), a[o] = r, o++
        }
        return i && (n = e ? n.sort(function(t, i) {
            return t[e] > i[e]
        }) : n.sort()), n
    }

    function x(t, e) {
        for (var i, a, o = e[0].toUpperCase() + e.slice(1), r = 0; r < le.length;) {
            if (i = le[r], a = i ? i + o : e, a in t) return a;
            r++
        }
        return n
    }

    function k() {
        return fe++
    }

    function S(t) {
        var e = t.ownerDocument;
        return e.defaultView || e.parentWindow
    }

    function C(t, e) {
        var i = this;
        this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function(e) {
            d(t.options.enable, [t]) && i.handler(e)
        }, this.init()
    }

    function $(t) {
        var e, i = t.options.inputClass;
        return new(e = i ? i : me ? V : ye ? W : ve ? R : L)(t, T)
    }

    function T(t, e, i) {
        var n = i.pointers.length,
            a = i.changedPointers.length,
            o = e & Ce && 0 === n - a,
            r = e & (Te | Pe) && 0 === n - a;
        i.isFirst = !!o, i.isFinal = !!r, o && (t.session = {}), i.eventType = e, P(t, i), t.emit("hammer.input", i), t.recognize(i), t.session.prevInput = i
    }

    function P(t, e) {
        var i = t.session,
            n = e.pointers,
            a = n.length;
        i.firstInput || (i.firstInput = _(e)), a > 1 && !i.firstMultiple ? i.firstMultiple = _(e) : 1 === a && (i.firstMultiple = !1);
        var o = i.firstInput,
            r = i.firstMultiple,
            s = r ? r.center : o.center,
            l = e.center = E(n);
        e.timeStamp = he(), e.deltaTime = e.timeStamp - o.timeStamp, e.angle = j(s, l), e.distance = I(s, l), O(i, e), e.offsetDirection = D(e.deltaX, e.deltaY), e.scale = r ? z(r.pointers, n) : 1, e.rotation = r ? q(r.pointers, n) : 0, A(i, e);
        var u = t.element;
        g(e.srcEvent.target, u) && (u = e.srcEvent.target), e.target = u
    }

    function O(t, e) {
        var i = e.center,
            n = t.offsetDelta || {},
            a = t.prevDelta || {},
            o = t.prevInput || {};
        (e.eventType === Ce || o.eventType === Te) && (a = t.prevDelta = {
            x: o.deltaX || 0,
            y: o.deltaY || 0
        }, n = t.offsetDelta = {
            x: i.x,
            y: i.y
        }), e.deltaX = a.x + (i.x - n.x), e.deltaY = a.y + (i.y - n.y)
    }

    function A(t, e) {
        var i, a, o, r, s = t.lastInterval || e,
            l = e.timeStamp - s.timeStamp;
        if (e.eventType != Pe && (l > Se || s.velocity === n)) {
            var u = s.deltaX - e.deltaX,
                c = s.deltaY - e.deltaY,
                d = M(l, u, c);
            a = d.x, o = d.y, i = pe(d.x) > pe(d.y) ? d.x : d.y, r = D(u, c), t.lastInterval = e
        } else i = s.velocity, a = s.velocityX, o = s.velocityY, r = s.direction;
        e.velocity = i, e.velocityX = a, e.velocityY = o, e.direction = r
    }

    function _(t) {
        for (var e = [], i = 0; i < t.pointers.length;) e[i] = {
            clientX: de(t.pointers[i].clientX),
            clientY: de(t.pointers[i].clientY)
        }, i++;
        return {
            timeStamp: he(),
            pointers: e,
            center: E(e),
            deltaX: t.deltaX,
            deltaY: t.deltaY
        }
    }

    function E(t) {
        var e = t.length;
        if (1 === e) return {
            x: de(t[0].clientX),
            y: de(t[0].clientY)
        };
        for (var i = 0, n = 0, a = 0; e > a;) i += t[a].clientX, n += t[a].clientY, a++;
        return {
            x: de(i / e),
            y: de(n / e)
        }
    }

    function M(t, e, i) {
        return {
            x: e / t || 0,
            y: i / t || 0
        }
    }

    function D(t, e) {
        return t === e ? Oe : pe(t) >= pe(e) ? t > 0 ? Ae : _e : e > 0 ? Ee : Me
    }

    function I(t, e, i) {
        i || (i = qe);
        var n = e[i[0]] - t[i[0]],
            a = e[i[1]] - t[i[1]];
        return Math.sqrt(n * n + a * a)
    }

    function j(t, e, i) {
        i || (i = qe);
        var n = e[i[0]] - t[i[0]],
            a = e[i[1]] - t[i[1]];
        return 180 * Math.atan2(a, n) / Math.PI
    }

    function q(t, e) {
        return j(e[1], e[0], ze) - j(t[1], t[0], ze)
    }

    function z(t, e) {
        return I(e[0], e[1], ze) / I(t[0], t[1], ze)
    }

    function L() {
        this.evEl = Ve, this.evWin = Ne, this.allow = !0, this.pressed = !1, C.apply(this, arguments)
    }

    function V() {
        this.evEl = Qe, this.evWin = Re, C.apply(this, arguments), this.store = this.manager.session.pointerEvents = []
    }

    function N() {
        this.evTarget = Xe, this.evWin = Ye, this.started = !1, C.apply(this, arguments)
    }

    function F(t, e) {
        var i = b(t.touches),
            n = b(t.changedTouches);
        return e & (Te | Pe) && (i = w(i.concat(n), "identifier", !0)), [i, n]
    }

    function W() {
        this.evTarget = Ue, this.targetIds = {}, C.apply(this, arguments)
    }

    function Q(t, e) {
        var i = b(t.touches),
            n = this.targetIds;
        if (e & (Ce | $e) && 1 === i.length) return n[i[0].identifier] = !0, [i, i];
        var a, o, r = b(t.changedTouches),
            s = [],
            l = this.target;
        if (o = i.filter(function(t) {
                return g(t.target, l)
            }), e === Ce)
            for (a = 0; a < o.length;) n[o[a].identifier] = !0, a++;
        for (a = 0; a < r.length;) n[r[a].identifier] && s.push(r[a]), e & (Te | Pe) && delete n[r[a].identifier], a++;
        return s.length ? [w(o.concat(s), "identifier", !0), s] : void 0
    }

    function R() {
        C.apply(this, arguments);
        var t = c(this.handler, this);
        this.touch = new W(this.manager, t), this.mouse = new L(this.manager, t)
    }

    function H(t, e) {
        this.manager = t, this.set(e)
    }

    function X(t) {
        if (v(t, ei)) return ei;
        var e = v(t, ii),
            i = v(t, ni);
        return e && i ? ii + " " + ni : e || i ? e ? ii : ni : v(t, ti) ? ti : Ke
    }

    function Y(t) {
        this.id = k(), this.manager = null, this.options = l(t || {}, this.defaults), this.options.enable = p(this.options.enable, !0), this.state = ai, this.simultaneous = {}, this.requireFail = []
    }

    function B(t) {
        return t & ui ? "cancel" : t & si ? "end" : t & ri ? "move" : t & oi ? "start" : ""
    }

    function U(t) {
        return t == Me ? "down" : t == Ee ? "up" : t == Ae ? "left" : t == _e ? "right" : ""
    }

    function G(t, e) {
        var i = e.manager;
        return i ? i.get(t) : t
    }

    function Z() {
        Y.apply(this, arguments)
    }

    function J() {
        Z.apply(this, arguments), this.pX = null, this.pY = null
    }

    function K() {
        Z.apply(this, arguments)
    }

    function te() {
        Y.apply(this, arguments), this._timer = null, this._input = null
    }

    function ee() {
        Z.apply(this, arguments)
    }

    function ie() {
        Z.apply(this, arguments)
    }

    function ne() {
        Y.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0
    }

    function ae(t, e) {
        return e = e || {}, e.recognizers = p(e.recognizers, ae.defaults.preset), new oe(t, e)
    }

    function oe(t, e) {
        e = e || {}, this.options = l(e, ae.defaults), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.element = t, this.input = $(this), this.touchAction = new H(this, this.options.touchAction), re(this, !0), r(e.recognizers, function(t) {
            var e = this.add(new t[0](t[1]));
            t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3])
        }, this)
    }

    function re(t, e) {
        var i = t.element;
        r(t.options.cssProps, function(t, n) {
            i.style[x(i.style, n)] = e ? t : ""
        })
    }

    function se(t, i) {
        var n = e.createEvent("Event");
        n.initEvent(t, !0, !0), n.gesture = i, i.target.dispatchEvent(n)
    }
    var le = ["", "webkit", "moz", "MS", "ms", "o"],
        ue = e.createElement("div"),
        ce = "function",
        de = Math.round,
        pe = Math.abs,
        he = Date.now,
        fe = 1,
        ge = /mobile|tablet|ip(ad|hone|od)|android/i,
        ve = "ontouchstart" in t,
        me = x(t, "PointerEvent") !== n,
        ye = ve && ge.test(navigator.userAgent),
        be = "touch",
        we = "pen",
        xe = "mouse",
        ke = "kinect",
        Se = 25,
        Ce = 1,
        $e = 2,
        Te = 4,
        Pe = 8,
        Oe = 1,
        Ae = 2,
        _e = 4,
        Ee = 8,
        Me = 16,
        De = Ae | _e,
        Ie = Ee | Me,
        je = De | Ie,
        qe = ["x", "y"],
        ze = ["clientX", "clientY"];
    C.prototype = {
        handler: function() {},
        init: function() {
            this.evEl && h(this.element, this.evEl, this.domHandler), this.evTarget && h(this.target, this.evTarget, this.domHandler), this.evWin && h(S(this.element), this.evWin, this.domHandler)
        },
        destroy: function() {
            this.evEl && f(this.element, this.evEl, this.domHandler), this.evTarget && f(this.target, this.evTarget, this.domHandler), this.evWin && f(S(this.element), this.evWin, this.domHandler)
        }
    };
    var Le = {
            mousedown: Ce,
            mousemove: $e,
            mouseup: Te
        },
        Ve = "mousedown",
        Ne = "mousemove mouseup";
    u(L, C, {
        handler: function(t) {
            var e = Le[t.type];
            e & Ce && 0 === t.button && (this.pressed = !0), e & $e && 1 !== t.which && (e = Te), this.pressed && this.allow && (e & Te && (this.pressed = !1), this.callback(this.manager, e, {
                pointers: [t],
                changedPointers: [t],
                pointerType: xe,
                srcEvent: t
            }))
        }
    });
    var Fe = {
            pointerdown: Ce,
            pointermove: $e,
            pointerup: Te,
            pointercancel: Pe,
            pointerout: Pe
        },
        We = {
            2: be,
            3: we,
            4: xe,
            5: ke
        },
        Qe = "pointerdown",
        Re = "pointermove pointerup pointercancel";
    t.MSPointerEvent && (Qe = "MSPointerDown", Re = "MSPointerMove MSPointerUp MSPointerCancel"), u(V, C, {
        handler: function(t) {
            var e = this.store,
                i = !1,
                n = t.type.toLowerCase().replace("ms", ""),
                a = Fe[n],
                o = We[t.pointerType] || t.pointerType,
                r = o == be,
                s = y(e, t.pointerId, "pointerId");
            a & Ce && (0 === t.button || r) ? 0 > s && (e.push(t), s = e.length - 1) : a & (Te | Pe) && (i = !0), 0 > s || (e[s] = t, this.callback(this.manager, a, {
                pointers: e,
                changedPointers: [t],
                pointerType: o,
                srcEvent: t
            }), i && e.splice(s, 1))
        }
    });
    var He = {
            touchstart: Ce,
            touchmove: $e,
            touchend: Te,
            touchcancel: Pe
        },
        Xe = "touchstart",
        Ye = "touchstart touchmove touchend touchcancel";
    u(N, C, {
        handler: function(t) {
            var e = He[t.type];
            if (e === Ce && (this.started = !0), this.started) {
                var i = F.call(this, t, e);
                e & (Te | Pe) && 0 === i[0].length - i[1].length && (this.started = !1), this.callback(this.manager, e, {
                    pointers: i[0],
                    changedPointers: i[1],
                    pointerType: be,
                    srcEvent: t
                })
            }
        }
    });
    var Be = {
            touchstart: Ce,
            touchmove: $e,
            touchend: Te,
            touchcancel: Pe
        },
        Ue = "touchstart touchmove touchend touchcancel";
    u(W, C, {
        handler: function(t) {
            var e = Be[t.type],
                i = Q.call(this, t, e);
            i && this.callback(this.manager, e, {
                pointers: i[0],
                changedPointers: i[1],
                pointerType: be,
                srcEvent: t
            })
        }
    }), u(R, C, {
        handler: function(t, e, i) {
            var n = i.pointerType == be,
                a = i.pointerType == xe;
            if (n) this.mouse.allow = !1;
            else if (a && !this.mouse.allow) return;
            e & (Te | Pe) && (this.mouse.allow = !0), this.callback(t, e, i)
        },
        destroy: function() {
            this.touch.destroy(), this.mouse.destroy()
        }
    });
    var Ge = x(ue.style, "touchAction"),
        Ze = Ge !== n,
        Je = "compute",
        Ke = "auto",
        ti = "manipulation",
        ei = "none",
        ii = "pan-x",
        ni = "pan-y";
    H.prototype = {
        set: function(t) {
            t == Je && (t = this.compute()), Ze && (this.manager.element.style[Ge] = t), this.actions = t.toLowerCase().trim()
        },
        update: function() {
            this.set(this.manager.options.touchAction)
        },
        compute: function() {
            var t = [];
            return r(this.manager.recognizers, function(e) {
                d(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()))
            }), X(t.join(" "))
        },
        preventDefaults: function(t) {
            if (!Ze) {
                var e = t.srcEvent,
                    i = t.offsetDirection;
                if (this.manager.session.prevented) return void e.preventDefault();
                var n = this.actions,
                    a = v(n, ei),
                    o = v(n, ni),
                    r = v(n, ii);
                return a || o && i & De || r && i & Ie ? this.preventSrc(e) : void 0
            }
        },
        preventSrc: function(t) {
            this.manager.session.prevented = !0, t.preventDefault()
        }
    };
    var ai = 1,
        oi = 2,
        ri = 4,
        si = 8,
        li = si,
        ui = 16,
        ci = 32;
    Y.prototype = {
        defaults: {},
        set: function(t) {
            return s(this.options, t), this.manager && this.manager.touchAction.update(), this
        },
        recognizeWith: function(t) {
            if (o(t, "recognizeWith", this)) return this;
            var e = this.simultaneous;
            return t = G(t, this), e[t.id] || (e[t.id] = t, t.recognizeWith(this)), this
        },
        dropRecognizeWith: function(t) {
            return o(t, "dropRecognizeWith", this) ? this : (t = G(t, this), delete this.simultaneous[t.id], this)
        },
        requireFailure: function(t) {
            if (o(t, "requireFailure", this)) return this;
            var e = this.requireFail;
            return t = G(t, this), -1 === y(e, t) && (e.push(t), t.requireFailure(this)), this
        },
        dropRequireFailure: function(t) {
            if (o(t, "dropRequireFailure", this)) return this;
            t = G(t, this);
            var e = y(this.requireFail, t);
            return e > -1 && this.requireFail.splice(e, 1), this
        },
        hasRequireFailures: function() {
            return this.requireFail.length > 0
        },
        canRecognizeWith: function(t) {
            return !!this.simultaneous[t.id]
        },
        emit: function(t) {
            function e(e) {
                i.manager.emit(i.options.event + (e ? B(n) : ""), t)
            }
            var i = this,
                n = this.state;
            si > n && e(!0), e(), n >= si && e(!0)
        },
        tryEmit: function(t) {
            return this.canEmit() ? this.emit(t) : void(this.state = ci)
        },
        canEmit: function() {
            for (var t = 0; t < this.requireFail.length;) {
                if (!(this.requireFail[t].state & (ci | ai))) return !1;
                t++
            }
            return !0
        },
        recognize: function(t) {
            var e = s({}, t);
            return d(this.options.enable, [this, e]) ? (this.state & (li | ui | ci) && (this.state = ai), this.state = this.process(e), void(this.state & (oi | ri | si | ui) && this.tryEmit(e))) : (this.reset(), void(this.state = ci))
        },
        process: function() {},
        getTouchAction: function() {},
        reset: function() {}
    }, u(Z, Y, {
        defaults: {
            pointers: 1
        },
        attrTest: function(t) {
            var e = this.options.pointers;
            return 0 === e || t.pointers.length === e
        },
        process: function(t) {
            var e = this.state,
                i = t.eventType,
                n = e & (oi | ri),
                a = this.attrTest(t);
            return n && (i & Pe || !a) ? e | ui : n || a ? i & Te ? e | si : e & oi ? e | ri : oi : ci
        }
    }), u(J, Z, {
        defaults: {
            event: "pan",
            threshold: 10,
            pointers: 1,
            direction: je
        },
        getTouchAction: function() {
            var t = this.options.direction,
                e = [];
            return t & De && e.push(ni), t & Ie && e.push(ii), e
        },
        directionTest: function(t) {
            var e = this.options,
                i = !0,
                n = t.distance,
                a = t.direction,
                o = t.deltaX,
                r = t.deltaY;
            return a & e.direction || (e.direction & De ? (a = 0 === o ? Oe : 0 > o ? Ae : _e, i = o != this.pX, n = Math.abs(t.deltaX)) : (a = 0 === r ? Oe : 0 > r ? Ee : Me, i = r != this.pY, n = Math.abs(t.deltaY))), t.direction = a, i && n > e.threshold && a & e.direction
        },
        attrTest: function(t) {
            return Z.prototype.attrTest.call(this, t) && (this.state & oi || !(this.state & oi) && this.directionTest(t))
        },
        emit: function(t) {
            this.pX = t.deltaX, this.pY = t.deltaY;
            var e = U(t.direction);
            e && this.manager.emit(this.options.event + e, t), this._super.emit.call(this, t)
        }
    }), u(K, Z, {
        defaults: {
            event: "pinch",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [ei]
        },
        attrTest: function(t) {
            return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & oi)
        },
        emit: function(t) {
            if (this._super.emit.call(this, t), 1 !== t.scale) {
                var e = t.scale < 1 ? "in" : "out";
                this.manager.emit(this.options.event + e, t)
            }
        }
    }), u(te, Y, {
        defaults: {
            event: "press",
            pointers: 1,
            time: 500,
            threshold: 5
        },
        getTouchAction: function() {
            return [Ke]
        },
        process: function(t) {
            var e = this.options,
                i = t.pointers.length === e.pointers,
                n = t.distance < e.threshold,
                o = t.deltaTime > e.time;
            if (this._input = t, !n || !i || t.eventType & (Te | Pe) && !o) this.reset();
            else if (t.eventType & Ce) this.reset(), this._timer = a(function() {
                this.state = li, this.tryEmit()
            }, e.time, this);
            else if (t.eventType & Te) return li;
            return ci
        },
        reset: function() {
            clearTimeout(this._timer)
        },
        emit: function(t) {
            this.state === li && (t && t.eventType & Te ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = he(), this.manager.emit(this.options.event, this._input)))
        }
    }), u(ee, Z, {
        defaults: {
            event: "rotate",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [ei]
        },
        attrTest: function(t) {
            return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & oi)
        }
    }), u(ie, Z, {
        defaults: {
            event: "swipe",
            threshold: 10,
            velocity: .65,
            direction: De | Ie,
            pointers: 1
        },
        getTouchAction: function() {
            return J.prototype.getTouchAction.call(this)
        },
        attrTest: function(t) {
            var e, i = this.options.direction;
            return i & (De | Ie) ? e = t.velocity : i & De ? e = t.velocityX : i & Ie && (e = t.velocityY), this._super.attrTest.call(this, t) && i & t.direction && t.distance > this.options.threshold && pe(e) > this.options.velocity && t.eventType & Te
        },
        emit: function(t) {
            var e = U(t.direction);
            e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t)
        }
    }), u(ne, Y, {
        defaults: {
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 2,
            posThreshold: 10
        },
        getTouchAction: function() {
            return [ti]
        },
        process: function(t) {
            var e = this.options,
                i = t.pointers.length === e.pointers,
                n = t.distance < e.threshold,
                o = t.deltaTime < e.time;
            if (this.reset(), t.eventType & Ce && 0 === this.count) return this.failTimeout();
            if (n && o && i) {
                if (t.eventType != Te) return this.failTimeout();
                var r = this.pTime ? t.timeStamp - this.pTime < e.interval : !0,
                    s = !this.pCenter || I(this.pCenter, t.center) < e.posThreshold;
                this.pTime = t.timeStamp, this.pCenter = t.center, s && r ? this.count += 1 : this.count = 1, this._input = t;
                var l = this.count % e.taps;
                if (0 === l) return this.hasRequireFailures() ? (this._timer = a(function() {
                    this.state = li, this.tryEmit()
                }, e.interval, this), oi) : li
            }
            return ci
        },
        failTimeout: function() {
            return this._timer = a(function() {
                this.state = ci
            }, this.options.interval, this), ci
        },
        reset: function() {
            clearTimeout(this._timer)
        },
        emit: function() {
            this.state == li && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input))
        }
    }), ae.VERSION = "2.0.4", ae.defaults = {
        domEvents: !1,
        touchAction: Je,
        enable: !0,
        inputTarget: null,
        inputClass: null,
        preset: [
            [ee, {
                enable: !1
            }],
            [K, {
                enable: !1
            },
                ["rotate"]
            ],
            [ie, {
                direction: De
            }],
            [J, {
                direction: De
            },
                ["swipe"]
            ],
            [ne],
            [ne, {
                event: "doubletap",
                taps: 2
            },
                ["tap"]
            ],
            [te]
        ],
        cssProps: {
            userSelect: "default",
            touchSelect: "none",
            touchCallout: "none",
            contentZooming: "none",
            userDrag: "none",
            tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    var di = 1,
        pi = 2;
    oe.prototype = {
        set: function(t) {
            return s(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this
        },
        stop: function(t) {
            this.session.stopped = t ? pi : di
        },
        recognize: function(t) {
            var e = this.session;
            if (!e.stopped) {
                this.touchAction.preventDefaults(t);
                var i, n = this.recognizers,
                    a = e.curRecognizer;
                (!a || a && a.state & li) && (a = e.curRecognizer = null);
                for (var o = 0; o < n.length;) i = n[o], e.stopped === pi || a && i != a && !i.canRecognizeWith(a) ? i.reset() : i.recognize(t), !a && i.state & (oi | ri | si) && (a = e.curRecognizer = i), o++
            }
        },
        get: function(t) {
            if (t instanceof Y) return t;
            for (var e = this.recognizers, i = 0; i < e.length; i++)
                if (e[i].options.event == t) return e[i];
            return null
        },
        add: function(t) {
            if (o(t, "add", this)) return this;
            var e = this.get(t.options.event);
            return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t
        },
        remove: function(t) {
            if (o(t, "remove", this)) return this;
            var e = this.recognizers;
            return t = this.get(t), e.splice(y(e, t), 1), this.touchAction.update(), this
        },
        on: function(t, e) {
            var i = this.handlers;
            return r(m(t), function(t) {
                i[t] = i[t] || [], i[t].push(e)
            }), this
        },
        off: function(t, e) {
            var i = this.handlers;
            return r(m(t), function(t) {
                e ? i[t].splice(y(i[t], e), 1) : delete i[t]
            }), this
        },
        emit: function(t, e) {
            this.options.domEvents && se(t, e);
            var i = this.handlers[t] && this.handlers[t].slice();
            if (i && i.length) {
                e.type = t, e.preventDefault = function() {
                    e.srcEvent.preventDefault()
                };
                for (var n = 0; n < i.length;) i[n](e), n++
            }
        },
        destroy: function() {
            this.element && re(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null
        }
    }, s(ae, {
        INPUT_START: Ce,
        INPUT_MOVE: $e,
        INPUT_END: Te,
        INPUT_CANCEL: Pe,
        STATE_POSSIBLE: ai,
        STATE_BEGAN: oi,
        STATE_CHANGED: ri,
        STATE_ENDED: si,
        STATE_RECOGNIZED: li,
        STATE_CANCELLED: ui,
        STATE_FAILED: ci,
        DIRECTION_NONE: Oe,
        DIRECTION_LEFT: Ae,
        DIRECTION_RIGHT: _e,
        DIRECTION_UP: Ee,
        DIRECTION_DOWN: Me,
        DIRECTION_HORIZONTAL: De,
        DIRECTION_VERTICAL: Ie,
        DIRECTION_ALL: je,
        Manager: oe,
        Input: C,
        TouchAction: H,
        TouchInput: W,
        MouseInput: L,
        PointerEventInput: V,
        TouchMouseInput: R,
        SingleTouchInput: N,
        Recognizer: Y,
        AttrRecognizer: Z,
        Tap: ne,
        Pan: J,
        Swipe: ie,
        Pinch: K,
        Rotate: ee,
        Press: te,
        on: h,
        off: f,
        each: r,
        merge: l,
        extend: s,
        inherit: u,
        bindFn: c,
        prefixed: x
    }), typeof define == ce && define.amd ? define(function() {
        return ae
    }) : "undefined" != typeof module && module.exports ? module.exports = ae : t[i] = ae
}(window, document, "Hammer"), jQuery.easing.jswing = jQuery.easing.swing, jQuery.extend(jQuery.easing, {
    def: "easeOutQuad",
    swing: function(t, e, i, n, a) {
        return jQuery.easing[jQuery.easing.def](t, e, i, n, a)
    },
    easeInQuad: function(t, e, i, n, a) {
        return n * (e /= a) * e + i
    },
    easeOutQuad: function(t, e, i, n, a) {
        return -n * (e /= a) * (e - 2) + i
    },
    easeInOutQuad: function(t, e, i, n, a) {
        return (e /= a / 2) < 1 ? n / 2 * e * e + i : -n / 2 * (--e * (e - 2) - 1) + i
    },
    easeInCubic: function(t, e, i, n, a) {
        return n * (e /= a) * e * e + i
    },
    easeOutCubic: function(t, e, i, n, a) {
        return n * ((e = e / a - 1) * e * e + 1) + i
    },
    easeInOutCubic: function(t, e, i, n, a) {
        return (e /= a / 2) < 1 ? n / 2 * e * e * e + i : n / 2 * ((e -= 2) * e * e + 2) + i
    },
    easeInQuart: function(t, e, i, n, a) {
        return n * (e /= a) * e * e * e + i
    },
    easeOutQuart: function(t, e, i, n, a) {
        return -n * ((e = e / a - 1) * e * e * e - 1) + i
    },
    easeInOutQuart: function(t, e, i, n, a) {
        return (e /= a / 2) < 1 ? n / 2 * e * e * e * e + i : -n / 2 * ((e -= 2) * e * e * e - 2) + i
    },
    easeInQuint: function(t, e, i, n, a) {
        return n * (e /= a) * e * e * e * e + i
    },
    easeOutQuint: function(t, e, i, n, a) {
        return n * ((e = e / a - 1) * e * e * e * e + 1) + i
    },
    easeInOutQuint: function(t, e, i, n, a) {
        return (e /= a / 2) < 1 ? n / 2 * e * e * e * e * e + i : n / 2 * ((e -= 2) * e * e * e * e + 2) + i
    },
    easeInSine: function(t, e, i, n, a) {
        return -n * Math.cos(e / a * (Math.PI / 2)) + n + i
    },
    easeOutSine: function(t, e, i, n, a) {
        return n * Math.sin(e / a * (Math.PI / 2)) + i
    },
    easeInOutSine: function(t, e, i, n, a) {
        return -n / 2 * (Math.cos(Math.PI * e / a) - 1) + i
    },
    easeInExpo: function(t, e, i, n, a) {
        return 0 == e ? i : n * Math.pow(2, 10 * (e / a - 1)) + i
    },
    easeOutExpo: function(t, e, i, n, a) {
        return e == a ? i + n : n * (-Math.pow(2, -10 * e / a) + 1) + i
    },
    easeInOutExpo: function(t, e, i, n, a) {
        return 0 == e ? i : e == a ? i + n : (e /= a / 2) < 1 ? n / 2 * Math.pow(2, 10 * (e - 1)) + i : n / 2 * (-Math.pow(2, -10 * --e) + 2) + i
    },
    easeInCirc: function(t, e, i, n, a) {
        return -n * (Math.sqrt(1 - (e /= a) * e) - 1) + i
    },
    easeOutCirc: function(t, e, i, n, a) {
        return n * Math.sqrt(1 - (e = e / a - 1) * e) + i
    },
    easeInOutCirc: function(t, e, i, n, a) {
        return (e /= a / 2) < 1 ? -n / 2 * (Math.sqrt(1 - e * e) - 1) + i : n / 2 * (Math.sqrt(1 - (e -= 2) * e) + 1) + i
    },
    easeInElastic: function(t, e, i, n, a) {
        var o = 1.70158,
            r = 0,
            s = n;
        if (0 == e) return i;
        if (1 == (e /= a)) return i + n;
        if (r || (r = .3 * a), s < Math.abs(n)) {
            s = n;
            var o = r / 4
        } else var o = r / (2 * Math.PI) * Math.asin(n / s);
        return -(s * Math.pow(2, 10 * (e -= 1)) * Math.sin(2 * (e * a - o) * Math.PI / r)) + i
    },
    easeOutElastic: function(t, e, i, n, a) {
        var o = 1.70158,
            r = 0,
            s = n;
        if (0 == e) return i;
        if (1 == (e /= a)) return i + n;
        if (r || (r = .3 * a), s < Math.abs(n)) {
            s = n;
            var o = r / 4
        } else var o = r / (2 * Math.PI) * Math.asin(n / s);
        return s * Math.pow(2, -10 * e) * Math.sin(2 * (e * a - o) * Math.PI / r) + n + i
    },
    easeInOutElastic: function(t, e, i, n, a) {
        var o = 1.70158,
            r = 0,
            s = n;
        if (0 == e) return i;
        if (2 == (e /= a / 2)) return i + n;
        if (r || (r = .3 * a * 1.5), s < Math.abs(n)) {
            s = n;
            var o = r / 4
        } else var o = r / (2 * Math.PI) * Math.asin(n / s);
        return 1 > e ? -.5 * s * Math.pow(2, 10 * (e -= 1)) * Math.sin(2 * (e * a - o) * Math.PI / r) + i : s * Math.pow(2, -10 * (e -= 1)) * Math.sin(2 * (e * a - o) * Math.PI / r) * .5 + n + i
    },
    easeInBack: function(t, e, i, n, a, o) {
        return void 0 == o && (o = 1.70158), n * (e /= a) * e * ((o + 1) * e - o) + i
    },
    easeOutBack: function(t, e, i, n, a, o) {
        return void 0 == o && (o = 1.70158), n * ((e = e / a - 1) * e * ((o + 1) * e + o) + 1) + i
    },
    easeInOutBack: function(t, e, i, n, a, o) {
        return void 0 == o && (o = 1.70158), (e /= a / 2) < 1 ? n / 2 * e * e * (((o *= 1.525) + 1) * e - o) + i : n / 2 * ((e -= 2) * e * (((o *= 1.525) + 1) * e + o) + 2) + i
    },
    easeInBounce: function(t, e, i, n, a) {
        return n - jQuery.easing.easeOutBounce(t, a - e, 0, n, a) + i
    },
    easeOutBounce: function(t, e, i, n, a) {
        return (e /= a) < 1 / 2.75 ? 7.5625 * n * e * e + i : 2 / 2.75 > e ? n * (7.5625 * (e -= 1.5 / 2.75) * e + .75) + i : 2.5 / 2.75 > e ? n * (7.5625 * (e -= 2.25 / 2.75) * e + .9375) + i : n * (7.5625 * (e -= 2.625 / 2.75) * e + .984375) + i
    },
    easeInOutBounce: function(t, e, i, n, a) {
        return a / 2 > e ? .5 * jQuery.easing.easeInBounce(t, 2 * e, 0, n, a) + i : .5 * jQuery.easing.easeOutBounce(t, 2 * e - a, 0, n, a) + .5 * n + i
    }
}),
    function(t) {
        "function" == typeof define && define.amd ? define(["jquery", "hammerjs"], t) : "object" == typeof exports ? t(require("jquery"), require("hammerjs")) : t(jQuery, Hammer)
    }(function(t, e) {
        function i(i, n) {
            var a = t(i);
            a.data("hammer") || a.data("hammer", new e(a[0], n))
        }
        t.fn.hammer = function(t) {
            return this.each(function() {
                i(this, t)
            })
        }, e.Manager.prototype.emit = function(e) {
            return function(i, n) {
                e.call(this, i, n), t(this.element).trigger({
                    type: i,
                    gesture: n
                })
            }
        }(e.Manager.prototype.emit)
    }), ! function(t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : t(jQuery)
}(function(t) {
    function e() {
        var e = i(this),
            r = o.settings;
        return isNaN(e.datetime) || (0 == r.cutoff || Math.abs(a(e.datetime)) < r.cutoff) && t(this).text(n(e.datetime)), this
    }

    function i(e) {
        if (e = t(e), !e.data("timeago")) {
            e.data("timeago", {
                datetime: o.datetime(e)
            });
            var i = t.trim(e.text());
            o.settings.localeTitle ? e.attr("title", e.data("timeago").datetime.toLocaleString()) : !(i.length > 0) || o.isTime(e) && e.attr("title") || e.attr("title", i)
        }
        return e.data("timeago")
    }

    function n(t) {
        return o.inWords(a(t))
    }

    function a(t) {
        return (new Date).getTime() - t.getTime()
    }
    t.timeago = function(e) {
        return n(e instanceof Date ? e : "string" == typeof e ? t.timeago.parse(e) : "number" == typeof e ? new Date(e) : t.timeago.datetime(e))
    };
    var o = t.timeago;
    t.extend(t.timeago, {
        settings: {
            refreshMillis: 6e4,
            allowPast: !0,
            allowFuture: !1,
            localeTitle: !1,
            cutoff: 0,
            strings: {
                prefixAgo: null,
                prefixFromNow: null,
                suffixAgo: "ago",
                suffixFromNow: "from now",
                inPast: "any moment now",
                seconds: "less than a minute",
                minute: "about a minute",
                minutes: "%d minutes",
                hour: "about an hour",
                hours: "about %d hours",
                day: "a day",
                days: "%d days",
                month: "about a month",
                months: "%d months",
                year: "about a year",
                years: "%d years",
                wordSeparator: " ",
                numbers: []
            }
        },
        inWords: function(e) {
            function i(i, a) {
                var o = t.isFunction(i) ? i(a, e) : i,
                    r = n.numbers && n.numbers[a] || a;
                return o.replace(/%d/i, r)
            }
            if (!this.settings.allowPast && !this.settings.allowFuture) throw "timeago allowPast and allowFuture settings can not both be set to false.";
            var n = this.settings.strings,
                a = n.prefixAgo,
                o = n.suffixAgo;
            if (this.settings.allowFuture && 0 > e && (a = n.prefixFromNow, o = n.suffixFromNow), !this.settings.allowPast && e >= 0) return this.settings.strings.inPast;
            var r = Math.abs(e) / 1e3,
                s = r / 60,
                l = s / 60,
                u = l / 24,
                c = u / 365,
                d = 45 > r && i(n.seconds, Math.round(r)) || 90 > r && i(n.minute, 1) || 45 > s && i(n.minutes, Math.round(s)) || 90 > s && i(n.hour, 1) || 24 > l && i(n.hours, Math.round(l)) || 42 > l && i(n.day, 1) || 30 > u && i(n.days, Math.round(u)) || 45 > u && i(n.month, 1) || 365 > u && i(n.months, Math.round(u / 30)) || 1.5 > c && i(n.year, 1) || i(n.years, Math.round(c)),
                p = n.wordSeparator || "";
            return void 0 === n.wordSeparator && (p = " "), t.trim([a, d, o].join(p))
        },
        parse: function(e) {
            var i = t.trim(e);
            return i = i.replace(/\.\d+/, ""), i = i.replace(/-/, "/").replace(/-/, "/"), i = i.replace(/T/, " ").replace(/Z/, " UTC"), i = i.replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2"), i = i.replace(/([\+\-]\d\d)$/, " $100"), new Date(i)
        },
        datetime: function(e) {
            var i = t(e).attr(o.isTime(e) ? "datetime" : "title");
            return o.parse(i)
        },
        isTime: function(e) {
            return "time" === t(e).get(0).tagName.toLowerCase()
        }
    });
    var r = {
        init: function() {
            var i = t.proxy(e, this);
            i();
            var n = o.settings;
            n.refreshMillis > 0 && (this._timeagoInterval = setInterval(i, n.refreshMillis))
        },
        update: function(i) {
            var n = o.parse(i);
            t(this).data("timeago", {
                datetime: n
            }), o.settings.localeTitle && t(this).attr("title", n.toLocaleString()), e.apply(this)
        },
        updateFromDOM: function() {
            t(this).data("timeago", {
                datetime: o.parse(t(this).attr(o.isTime(this) ? "datetime" : "title"))
            }), e.apply(this)
        },
        dispose: function() {
            this._timeagoInterval && (window.clearInterval(this._timeagoInterval), this._timeagoInterval = null)
        }
    };
    t.fn.timeago = function(t, e) {
        var i = t ? r[t] : r.init;
        if (!i) throw new Error("Unknown function name '" + t + "' for timeago");
        return this.each(function() {
            i.call(this, e)
        }), this
    }, document.createElement("abbr"), document.createElement("time")
}),
    function(t) {
        var e = 0,
            i = 0,
            n = function() {
                return i++, "materialize-lean-overlay-" + i
            };
        t.fn.extend({
            openModal: function(i) {
                t("body").css("overflow", "hidden");
                var a = {
                        opacity: .5,
                        in_duration: 350,
                        out_duration: 250,
                        ready: void 0,
                        complete: void 0,
                        dismissible: !0,
                        starting_top: "4%"
                    },
                    o = n(),
                    r = t(this),
                    s = t('<div class="lean-overlay"></div>'),
                    l = ++e;
                s.attr("id", o).css("z-index", 1e3 + 2 * l), r.data("overlay-id", o).css("z-index", 1e3 + 2 * l + 1), t("body").append(s), i = t.extend(a, i), i.dismissible && (s.click(function() {

                    console.log(i);
                    console.log('CLOSE MODAL!');
                    r.closeModal(i)
                }), t(document).on("keyup.leanModal" + o, function(t) {
                    27 === t.keyCode && r.closeModal(i)
                })), r.find(".modal-close").on("click.close", function() {
                    r.closeModal(i)
                }), s.css({
                    display: "block",
                    opacity: 0
                }), r.css({
                    display: "block",
                    opacity: 0
                }), s.velocity({
                    opacity: i.opacity
                }, {
                    duration: i.in_duration,
                    queue: !1,
                    ease: "easeOutCubic"
                }), r.data("associated-overlay", s[0]), r.hasClass("bottom-sheet") ? r.velocity({
                    bottom: "0",
                    opacity: 1
                }, {
                    duration: i.in_duration,
                    queue: !1,
                    ease: "easeOutCubic",
                    complete: function() {
                        "function" == typeof i.ready && i.ready()
                    }
                }) : (t.Velocity.hook(r, "scaleX", .7), r.css({
                    top: i.starting_top
                }), r.velocity({
                    top: "10%",
                    opacity: 1,
                    scaleX: "1"
                }, {
                    duration: i.in_duration,
                    queue: !1,
                    ease: "easeOutCubic",
                    complete: function() {
                        "function" == typeof i.ready && i.ready()
                    }
                }))
            }
        }), t.fn.extend({
            closeModal: function(i) {
                var n = {
                        out_duration: 250,
                        complete: void 0
                    },
                    a = t(this),
                    o = a.data("overlay-id"),
                    r = t("#" + o);
                i = t.extend(n, i), t("body").css("overflow", ""), a.find(".modal-close").off("click.close"), t(document).off("keyup.leanModal" + o), r.velocity({
                    opacity: 0
                }, {
                    duration: i.out_duration,
                    queue: !1,
                    ease: "easeOutQuart"
                }), a.hasClass("bottom-sheet") ? a.velocity({
                    bottom: "-100%",
                    opacity: 0
                }, {
                    duration: i.out_duration,
                    queue: !1,
                    ease: "easeOutCubic",
                    complete: function() {
                        r.css({
                            display: "none"
                        }), "function" == typeof i.complete && i.complete(), r.remove(), e--
                    }
                }) : a.velocity({
                    top: i.starting_top,
                    opacity: 0,
                    scaleX: .7
                }, {
                    duration: i.out_duration,
                    complete: function() {
                        t(this).css("display", "none"), "function" == typeof i.complete && i.complete(), r.remove(), e--
                    }
                })
            }
        }), t.fn.extend({
            leanModal: function(e) {
                return this.each(function() {
                    var i = {
                            starting_top: "4%"
                        },
                        n = t.extend(i, e);
                    t(this).click(function(e) {
                        n.starting_top = (t(this).offset().top - t(window).scrollTop()) / 1.15;
                        var i = t(this).attr("href") || "#" + t(this).data("target");
                        t(i).openModal(n), e.preventDefault()
                    })
                })
            }
        })
    }(jQuery),
    function(t) {
        t.fn.materialbox = function() {
            return this.each(function() {
                function e() {
                    n = !1;
                    var e = r.parent(".material-placeholder"),
                        a = (window.innerWidth, window.innerHeight, r.data("width")),
                        s = r.data("height");
                    r.velocity("stop", !0), t("#materialbox-overlay").velocity("stop", !0), t(".materialbox-caption").velocity("stop", !0), t("#materialbox-overlay").velocity({
                        opacity: 0
                    }, {
                        duration: o,
                        queue: !1,
                        easing: "easeOutQuad",
                        complete: function() {
                            i = !1, t(this).remove()
                        }
                    }), r.velocity({
                        width: a,
                        height: s,
                        left: 0,
                        top: 0
                    }, {
                        duration: o,
                        queue: !1,
                        easing: "easeOutQuad"
                    }), t(".materialbox-caption").velocity({
                        opacity: 0
                    }, {
                        duration: o,
                        queue: !1,
                        easing: "easeOutQuad",
                        complete: function() {
                            e.css({
                                height: "",
                                width: "",
                                position: "",
                                top: "",
                                left: ""
                            }), r.css({
                                height: "",
                                top: "",
                                left: "",
                                width: "",
                                "max-width": "",
                                position: "",
                                "z-index": ""
                            }), r.removeClass("active"), n = !0, t(this).remove()
                        }
                    })
                }
                if (!t(this).hasClass("intialized")) {
                    t(this).addClass("intialized");
                    var i = !1,
                        n = !0,
                        a = 275,
                        o = 200,
                        r = t(this),
                        s = t("<div></div>").addClass("material-placeholder");
                    r.wrap(s), r.on("click", function() {
                        var o = r.parent(".material-placeholder"),
                            s = window.innerWidth,
                            l = window.innerHeight,
                            u = r.width(),
                            c = r.height();
                        if (n === !1) return e(), !1;
                        if (i && n === !0) return e(), !1;
                        n = !1, r.addClass("active"), i = !0, o.css({
                            width: o[0].getBoundingClientRect().width,
                            height: o[0].getBoundingClientRect().height,
                            position: "relative",
                            top: 0,
                            left: 0
                        }), r.css({
                            position: "absolute",
                            "z-index": 1101
                        }).data("width", u).data("height", c);
                        var d = t('<div id="materialbox-overlay"></div>').css({
                            opacity: 0
                        }).click(function() {
                            n === !0 && e()
                        });
                        if (t("body").append(d), d.velocity({
                                opacity: 1
                            }, {
                                duration: a,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), "" !== r.data("caption")) {
                            var p = t('<div class="materialbox-caption"></div>');
                            p.text(r.data("caption")), t("body").append(p), p.css({
                                display: "inline"
                            }), p.velocity({
                                opacity: 1
                            }, {
                                duration: a,
                                queue: !1,
                                easing: "easeOutQuad"
                            })
                        }
                        var h = 0,
                            f = u / s,
                            g = c / l,
                            v = 0,
                            m = 0;
                        f > g ? (h = c / u, v = .9 * s, m = .9 * s * h) : (h = u / c, v = .9 * l * h, m = .9 * l), r.hasClass("responsive-img") ? r.velocity({
                            "max-width": v,
                            width: u
                        }, {
                            duration: 0,
                            queue: !1,
                            complete: function() {
                                r.css({
                                    left: 0,
                                    top: 0
                                }).velocity({
                                    height: m,
                                    width: v,
                                    left: t(document).scrollLeft() + s / 2 - r.parent(".material-placeholder").offset().left - v / 2,
                                    top: t(document).scrollTop() + l / 2 - r.parent(".material-placeholder").offset().top - m / 2
                                }, {
                                    duration: a,
                                    queue: !1,
                                    easing: "easeOutQuad",
                                    complete: function() {
                                        n = !0
                                    }
                                })
                            }
                        }) : r.css("left", 0).css("top", 0).velocity({
                            height: m,
                            width: v,
                            left: t(document).scrollLeft() + s / 2 - r.parent(".material-placeholder").offset().left - v / 2,
                            top: t(document).scrollTop() + l / 2 - r.parent(".material-placeholder").offset().top - m / 2
                        }, {
                            duration: a,
                            queue: !1,
                            easing: "easeOutQuad",
                            complete: function() {
                                n = !0
                            }
                        })
                    }), t(window).scroll(function() {
                        i && e()
                    }), t(document).keyup(function(t) {
                        27 === t.keyCode && n === !0 && i && e()
                    })
                }
            })
        }, t(document).ready(function() {
            t(".materialboxed").materialbox()
        })
    }(jQuery),
    function(t) {
        t.fn.parallax = function() {
            var e = t(window).width();
            return this.each(function() {
                function i(i) {
                    var a;
                    a = 601 > e ? n.height() > 0 ? n.height() : n.children("img").height() : n.height() > 0 ? n.height() : 500;
                    var o = n.children("img").first(),
                        r = o.height(),
                        s = r - a,
                        l = n.offset().top + a,
                        u = n.offset().top,
                        c = t(window).scrollTop(),
                        d = window.innerHeight,
                        p = c + d,
                        h = (p - u) / (a + d),
                        f = Math.round(s * h);
                    i && o.css("display", "block"), l > c && c + d > u && o.css("transform", "translate3D(-50%," + f + "px, 0)")
                }
                var n = t(this);
                n.addClass("parallax"), n.children("img").one("load", function() {
                    i(!0)
                }).each(function() {
                    this.complete && t(this).load()
                }), t(window).scroll(function() {
                    e = t(window).width(), i(!1)
                }), t(window).resize(function() {
                    e = t(window).width(), i(!1)
                })
            })
        }
    }(jQuery), self = "undefined" != typeof window ? window : "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {};
var Prism = function() {
    var t = /\blang(?:uage)?-(?!\*)(\w+)\b/i,
        e = self.Prism = {
            util: {
                encode: function(t) {
                    return t instanceof i ? new i(t.type, e.util.encode(t.content), t.alias) : "Array" === e.util.type(t) ? t.map(e.util.encode) : t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ")
                },
                type: function(t) {
                    return Object.prototype.toString.call(t).match(/\[object (\w+)\]/)[1]
                },
                clone: function(t) {
                    var i = e.util.type(t);
                    switch (i) {
                        case "Object":
                            var n = {};
                            for (var a in t) t.hasOwnProperty(a) && (n[a] = e.util.clone(t[a]));
                            return n;
                        case "Array":
                            return t.slice()
                    }
                    return t
                }
            },
            languages: {
                extend: function(t, i) {
                    var n = e.util.clone(e.languages[t]);
                    for (var a in i) n[a] = i[a];
                    return n
                },
                insertBefore: function(t, i, n, a) {
                    a = a || e.languages;
                    var o = a[t];
                    if (2 == arguments.length) {
                        n = arguments[1];
                        for (var r in n) n.hasOwnProperty(r) && (o[r] = n[r]);
                        return o
                    }
                    var s = {};
                    for (var l in o)
                        if (o.hasOwnProperty(l)) {
                            if (l == i)
                                for (var r in n) n.hasOwnProperty(r) && (s[r] = n[r]);
                            s[l] = o[l]
                        }
                    return e.languages.DFS(e.languages, function(e, i) {
                        i === a[t] && e != t && (this[e] = s)
                    }), a[t] = s
                },
                DFS: function(t, i, n) {
                    for (var a in t) t.hasOwnProperty(a) && (i.call(t, a, t[a], n || a), "Object" === e.util.type(t[a]) ? e.languages.DFS(t[a], i) : "Array" === e.util.type(t[a]) && e.languages.DFS(t[a], i, a))
                }
            },
            highlightAll: function(t, i) {
                for (var n, a = document.querySelectorAll('code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'), o = 0; n = a[o++];) e.highlightElement(n, t === !0, i)
            },
            highlightElement: function(n, a, o) {
                for (var r, s, l = n; l && !t.test(l.className);) l = l.parentNode;
                if (l && (r = (l.className.match(t) || [, ""])[1], s = e.languages[r]), s) {
                    n.className = n.className.replace(t, "").replace(/\s+/g, " ") + " language-" + r, l = n.parentNode, /pre/i.test(l.nodeName) && (l.className = l.className.replace(t, "").replace(/\s+/g, " ") + " language-" + r);
                    var u = n.textContent;
                    if (u) {
                        var c = {
                            element: n,
                            language: r,
                            grammar: s,
                            code: u
                        };
                        if (e.hooks.run("before-highlight", c), a && self.Worker) {
                            var d = new Worker(e.filename);
                            d.onmessage = function(t) {
                                c.highlightedCode = i.stringify(JSON.parse(t.data), r), e.hooks.run("before-insert", c), c.element.innerHTML = c.highlightedCode, o && o.call(c.element), e.hooks.run("after-highlight", c)
                            }, d.postMessage(JSON.stringify({
                                language: c.language,
                                code: c.code
                            }))
                        } else c.highlightedCode = e.highlight(c.code, c.grammar, c.language), e.hooks.run("before-insert", c), c.element.innerHTML = c.highlightedCode, o && o.call(n), e.hooks.run("after-highlight", c)
                    }
                }
            },
            highlight: function(t, n, a) {
                var o = e.tokenize(t, n);
                return i.stringify(e.util.encode(o), a)
            },
            tokenize: function(t, i) {
                var n = e.Token,
                    a = [t],
                    o = i.rest;
                if (o) {
                    for (var r in o) i[r] = o[r];
                    delete i.rest
                }
                t: for (var r in i)
                    if (i.hasOwnProperty(r) && i[r]) {
                        var s = i[r];
                        s = "Array" === e.util.type(s) ? s : [s];
                        for (var l = 0; l < s.length; ++l) {
                            var u = s[l],
                                c = u.inside,
                                d = !!u.lookbehind,
                                p = 0,
                                h = u.alias;
                            u = u.pattern || u;
                            for (var f = 0; f < a.length; f++) {
                                var g = a[f];
                                if (a.length > t.length) break t;
                                if (!(g instanceof n)) {
                                    u.lastIndex = 0;
                                    var v = u.exec(g);
                                    if (v) {
                                        d && (p = v[1].length);
                                        var m = v.index - 1 + p,
                                            v = v[0].slice(p),
                                            y = v.length,
                                            b = m + y,
                                            w = g.slice(0, m + 1),
                                            x = g.slice(b + 1),
                                            k = [f, 1];
                                        w && k.push(w);
                                        var S = new n(r, c ? e.tokenize(v, c) : v, h);
                                        k.push(S), x && k.push(x), Array.prototype.splice.apply(a, k)
                                    }
                                }
                            }
                        }
                    }
                return a
            },
            hooks: {
                all: {},
                add: function(t, i) {
                    var n = e.hooks.all;
                    n[t] = n[t] || [], n[t].push(i)
                },
                run: function(t, i) {
                    var n = e.hooks.all[t];
                    if (n && n.length)
                        for (var a, o = 0; a = n[o++];) a(i)
                }
            }
        },
        i = e.Token = function(t, e, i) {
            this.type = t, this.content = e, this.alias = i
        };
    if (i.stringify = function(t, n, a) {
            if ("string" == typeof t) return t;
            if ("[object Array]" == Object.prototype.toString.call(t)) return t.map(function(e) {
                return i.stringify(e, n, t)
            }).join("");
            var o = {
                type: t.type,
                content: i.stringify(t.content, n, a),
                tag: "span",
                classes: ["token", t.type],
                attributes: {},
                language: n,
                parent: a
            };
            if ("comment" == o.type && (o.attributes.spellcheck = "true"), t.alias) {
                var r = "Array" === e.util.type(t.alias) ? t.alias : [t.alias];
                Array.prototype.push.apply(o.classes, r)
            }
            e.hooks.run("wrap", o);
            var s = "";
            for (var l in o.attributes) s += l + '="' + (o.attributes[l] || "") + '"';
            return "<" + o.tag + ' class="' + o.classes.join(" ") + '" ' + s + ">" + o.content + "</" + o.tag + ">"
        }, !self.document) return self.addEventListener ? (self.addEventListener("message", function(t) {
        var i = JSON.parse(t.data),
            n = i.language,
            a = i.code;
        self.postMessage(JSON.stringify(e.util.encode(e.tokenize(a, e.languages[n])))), self.close()
    }, !1), self.Prism) : self.Prism;
    var n = document.getElementsByTagName("script");
    return n = n[n.length - 1], n && (e.filename = n.src, document.addEventListener && !n.hasAttribute("data-manual") && document.addEventListener("DOMContentLoaded", e.highlightAll)), self.Prism
}();
"undefined" != typeof module && module.exports && (module.exports = Prism), Prism.languages.markup = {
    comment: /<!--[\w\W]*?-->/g,
    prolog: /<\?.+?\?>/,
    doctype: /<!DOCTYPE.+?>/,
    cdata: /<!\[CDATA\[[\w\W]*?]]>/i,
    tag: {
        pattern: /<\/?[\w:-]+\s*(?:\s+[\w:-]+(?:=(?:("|')(\\?[\w\W])*?\1|[^\s'">=]+))?\s*)*\/?>/gi,
        inside: {
            tag: {
                pattern: /^<\/?[\w:-]+/i,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[\w-]+?:/
                }
            },
            "attr-value": {
                pattern: /=(?:('|")[\w\W]*?(\1)|[^\s>]+)/gi,
                inside: {
                    punctuation: /=|>|"/g
                }
            },
            punctuation: /\/?>/g,
            "attr-name": {
                pattern: /[\w:-]+/g,
                inside: {
                    namespace: /^[\w-]+?:/
                }
            }
        }
    },
    entity: /\&#?[\da-z]{1,8};/gi
}, Prism.hooks.add("wrap", function(t) {
    "entity" === t.type && (t.attributes.title = t.content.replace(/&amp;/, "&"))
}), Prism.languages.css = {
    comment: /\/\*[\w\W]*?\*\//g,
    atrule: {
        pattern: /@[\w-]+?.*?(;|(?=\s*{))/gi,
        inside: {
            punctuation: /[;:]/g
        }
    },
    url: /url\((["']?).*?\1\)/gi,
    selector: /[^\{\}\s][^\{\};]*(?=\s*\{)/g,
    property: /(\b|\B)[\w-]+(?=\s*:)/gi,
    string: /("|')(\\?.)*?\1/g,
    important: /\B!important\b/gi,
    punctuation: /[\{\};:]/g,
    "function": /[-a-z0-9]+(?=\()/gi
}, Prism.languages.markup && (Prism.languages.insertBefore("markup", "tag", {
    style: {
        pattern: /<style[\w\W]*?>[\w\W]*?<\/style>/gi,
        inside: {
            tag: {
                pattern: /<style[\w\W]*?>|<\/style>/gi,
                inside: Prism.languages.markup.tag.inside
            },
            rest: Prism.languages.css
        },
        alias: "language-css"
    }
}), Prism.languages.insertBefore("inside", "attr-value", {
    "style-attr": {
        pattern: /\s*style=("|').+?\1/gi,
        inside: {
            "attr-name": {
                pattern: /^\s*style/gi,
                inside: Prism.languages.markup.tag.inside
            },
            punctuation: /^\s*=\s*['"]|['"]\s*$/,
            "attr-value": {
                pattern: /.+/gi,
                inside: Prism.languages.css
            }
        },
        alias: "language-css"
    }
}, Prism.languages.markup.tag)), Prism.languages.clike = {
    comment: [{
        pattern: /(^|[^\\])\/\*[\w\W]*?\*\//g,
        lookbehind: !0
    }, {
        pattern: /(^|[^\\:])\/\/.*?(\r?\n|$)/g,
        lookbehind: !0
    }],
    string: /("|')(\\?.)*?\1/g,
    "class-name": {
        pattern: /((?:(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[a-z0-9_\.\\]+/gi,
        lookbehind: !0,
        inside: {
            punctuation: /(\.|\\)/
        }
    },
    keyword: /\b(if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/g,
    "boolean": /\b(true|false)\b/g,
    "function": {
        pattern: /[a-z0-9_]+\(/gi,
        inside: {
            punctuation: /\(/
        }
    },
    number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee]-?\d+)?)\b/g,
    operator: /[-+]{1,2}|!|<=?|>=?|={1,3}|&{1,2}|\|?\||\?|\*|\/|\~|\^|\%/g,
    ignore: /&(lt|gt|amp);/gi,
    punctuation: /[{}[\];(),.:]/g
}, Prism.languages.javascript = Prism.languages.extend("clike", {
    keyword: /\b(break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|false|finally|for|function|get|if|implements|import|in|instanceof|interface|let|new|null|package|private|protected|public|return|set|static|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/g,
    number: /\b-?(0x[\dA-Fa-f]+|\d*\.?\d+([Ee][+-]?\d+)?|NaN|-?Infinity)\b/g,
    "function": /(?!\d)[a-z0-9_$]+(?=\()/gi
}), Prism.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: /(^|[^/])\/(?!\/)(\[.+?]|\\.|[^/\r\n])+\/[gim]{0,3}(?=\s*($|[\r\n,.;})]))/g,
        lookbehind: !0
    }
}), Prism.languages.markup && Prism.languages.insertBefore("markup", "tag", {
    script: {
        pattern: /<script[\w\W]*?>[\w\W]*?<\/script>/gi,
        inside: {
            tag: {
                pattern: /<script[\w\W]*?>|<\/script>/gi,
                inside: Prism.languages.markup.tag.inside
            },
            rest: Prism.languages.javascript
        },
        alias: "language-javascript"
    }
}), Prism.languages.scss = Prism.languages.extend("css", {
    comment: {
        pattern: /(^|[^\\])(\/\*[\w\W]*?\*\/|\/\/.*?(\r?\n|$))/g,
        lookbehind: !0
    },
    atrule: /@[\w-]+(?=\s+(\(|\{|;))/gi,
    url: /([-a-z]+-)*url(?=\()/gi,
    selector: /([^@;\{\}\(\)]?([^@;\{\}\(\)]|&|\#\{\$[-_\w]+\})+)(?=\s*\{(\}|\s|[^\}]+(:|\{)[^\}]+))/gm
}), Prism.languages.insertBefore("scss", "atrule", {
    keyword: /@(if|else if|else|for|each|while|import|extend|debug|warn|mixin|include|function|return|content)|(?=@for\s+\$[-_\w]+\s)+from/i
}), Prism.languages.insertBefore("scss", "property", {
    variable: /((\$[-_\w]+)|(#\{\$[-_\w]+\}))/i
}), Prism.languages.insertBefore("scss", "ignore", {
    placeholder: /%[-_\w]+/i,
    statement: /\B!(default|optional)\b/gi,
    "boolean": /\b(true|false)\b/g,
    "null": /\b(null)\b/g,
    operator: /\s+([-+]{1,2}|={1,2}|!=|\|?\||\?|\*|\/|\%)\s+/g
}), Prism.languages.bash = Prism.languages.extend("clike", {
    comment: {
        pattern: /(^|[^"{\\])(#.*?(\r?\n|$))/g,
        lookbehind: !0
    },
    string: {
        pattern: /("|')(\\?[\s\S])*?\1/g,
        inside: {
            property: /\$([a-zA-Z0-9_#\?\-\*!@]+|\{[^\}]+\})/g
        }
    },
    keyword: /\b(if|then|else|elif|fi|for|break|continue|while|in|case|function|select|do|done|until|echo|exit|return|set|declare)\b/g
}), Prism.languages.insertBefore("bash", "keyword", {
    property: /\$([a-zA-Z0-9_#\?\-\*!@]+|\{[^}]+\})/g
}), Prism.languages.insertBefore("bash", "comment", {
    important: /(^#!\s*\/bin\/bash)|(^#!\s*\/bin\/sh)/g
}),
    function(t) {
        t(document).ready(function() {
            t.fn.pushpin = function(e) {
                var i = {
                    top: 0,
                    bottom: 1 / 0,
                    offset: 0
                };
                return e = t.extend(i, e), $index = 0, this.each(function() {
                    function i(t) {
                        t.removeClass("pin-top"), t.removeClass("pinned"), t.removeClass("pin-bottom")
                    }

                    function n(n, a) {
                        n.each(function() {
                            e.top <= a && e.bottom >= a && !t(this).hasClass("pinned") && (i(t(this)), t(this).css("top", e.offset), t(this).addClass("pinned")), a < e.top && !t(this).hasClass("pin-top") && (i(t(this)), t(this).css("top", 0), t(this).addClass("pin-top")), a > e.bottom && !t(this).hasClass("pin-bottom") && (i(t(this)), t(this).addClass("pin-bottom"), t(this).css("top", e.bottom - r))
                        })
                    }
                    var a = Materialize.guid(),
                        o = t(this),
                        r = t(this).offset().top;
                    n(o, t(window).scrollTop()), t(window).on("scroll." + a, function() {
                        var i = t(window).scrollTop() + e.offset;
                        n(o, i)
                    })
                })
            }
        })
    }(jQuery),
    function() {
        Materialize.scrollFire = function(t) {
            var e = !1;
            window.addEventListener("scroll", function() {
                e = !0
            }), setInterval(function() {
                if (e) {
                    e = !1;
                    for (var i = window.pageYOffset + window.innerHeight, n = 0; n < t.length; n++) {
                        var a = t[n],
                            o = a.selector,
                            r = a.offset,
                            s = a.callback,
                            l = document.querySelector(o);
                        if (null !== l) {
                            var u = l.getBoundingClientRect().top + document.body.scrollTop;
                            if (i > u + r && a.done !== !0) {
                                var c = new Function(s);
                                c(), a.done = !0
                            }
                        }
                    }
                }
            }, 100)
        }
    }(jQuery),
    function(t) {
        function e(e, i, n, a) {
            var o = t();
            return t.each(r, function(t, r) {
                if (r.height() > 0) {
                    var s = r.offset().top,
                        l = r.offset().left,
                        u = l + r.width(),
                        c = s + r.height(),
                        d = !(l > i || a > u || s > n || e > c);
                    d && o.push(r)
                }
            }), o
        }

        function i() {
            ++u;
            var i = o.scrollTop(),
                n = o.scrollLeft(),
                a = n + o.width(),
                r = i + o.height(),
                l = e(i + c.top + 200, a + c.right, r + c.bottom, n + c.left);
            t.each(l, function(t, e) {
                var i = e.data("scrollSpy:ticks");
                "number" != typeof i && e.triggerHandler("scrollSpy:enter"), e.data("scrollSpy:ticks", u)
            }), t.each(s, function(t, e) {
                var i = e.data("scrollSpy:ticks");
                "number" == typeof i && i !== u && (e.triggerHandler("scrollSpy:exit"), e.data("scrollSpy:ticks", null))
            }), s = l
        }

        function n() {
            o.trigger("scrollSpy:winSize")
        }

        function a(t, e, i) {
            var n, a, o, r = null,
                s = 0;
            i || (i = {});
            var l = function() {
                s = i.leading === !1 ? 0 : d(), r = null, o = t.apply(n, a), n = a = null
            };
            return function() {
                var u = d();
                s || i.leading !== !1 || (s = u);
                var c = e - (u - s);
                return n = this, a = arguments, 0 >= c ? (clearTimeout(r), r = null, s = u, o = t.apply(n, a), n = a = null) : r || i.trailing === !1 || (r = setTimeout(l, c)), o
            }
        }
        var o = t(window),
            r = [],
            s = [],
            l = !1,
            u = 0,
            c = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            d = Date.now || function() {
                    return (new Date).getTime()
                };
        t.scrollSpy = function(e, n) {
            var s = [];
            e = t(e), e.each(function(e, i) {
                r.push(t(i)), t(i).data("scrollSpy:id", e), t("a[href=#" + t(i).attr("id") + "]").click(function(e) {
                    e.preventDefault();
                    var i = t(this.hash).offset().top + 1;
                    t("html, body").animate({
                        scrollTop: i - 200
                    }, {
                        duration: 400,
                        queue: !1,
                        easing: "easeOutCubic"
                    })
                })
            }), n = n || {
                    throttle: 100
                }, c.top = n.offsetTop || 0, c.right = n.offsetRight || 0, c.bottom = n.offsetBottom || 0, c.left = n.offsetLeft || 0;
            var u = a(i, n.throttle || 100),
                d = function() {
                    t(document).ready(u)
                };
            return l || (o.on("scroll", d), o.on("resize", d), l = !0), setTimeout(d, 0), e.on("scrollSpy:enter", function() {
                s = t.grep(s, function(t) {
                    return 0 != t.height()
                });
                var e = t(this);
                s[0] ? (t("a[href=#" + s[0].attr("id") + "]").removeClass("active"), e.data("scrollSpy:id") < s[0].data("scrollSpy:id") ? s.unshift(t(this)) : s.push(t(this))) : s.push(t(this)), t("a[href=#" + s[0].attr("id") + "]").addClass("active")
            }), e.on("scrollSpy:exit", function() {
                if (s = t.grep(s, function(t) {
                        return 0 != t.height()
                    }), s[0]) {
                    t("a[href=#" + s[0].attr("id") + "]").removeClass("active");
                    var e = t(this);
                    s = t.grep(s, function(t) {
                        return t.attr("id") != e.attr("id")
                    }), s[0] && t("a[href=#" + s[0].attr("id") + "]").addClass("active")
                }
            }), e
        }, t.winSizeSpy = function(e) {
            return t.winSizeSpy = function() {
                return o
            }, e = e || {
                    throttle: 100
                }, o.on("resize", a(n, e.throttle || 100))
        }, t.fn.scrollSpy = function(e) {
            return t.scrollSpy(t(this), e)
        }
    }(jQuery),
    function(t) {
        var e = {
            init: function(e) {
                var i = {
                    menuWidth: 240,
                    edge: "left",
                    closeOnClick: !1
                };
                e = t.extend(i, e), t(this).each(function() {
                    function i(i) {
                        r = !1, s = !1, t("body").css("overflow", ""), t("#sidenav-overlay").velocity({
                            opacity: 0
                        }, {
                            duration: 200,
                            queue: !1,
                            easing: "easeOutQuad",
                            complete: function() {
                                t(this).remove()
                            }
                        }), "left" === e.edge ? (o.css({
                            width: "",
                            right: "",
                            left: "0"
                        }), a.velocity({
                            left: -1 * (e.menuWidth + 10)
                        }, {
                            duration: 200,
                            queue: !1,
                            easing: "easeOutCubic",
                            complete: function() {
                                i === !0 && (a.removeAttr("style"), a.css("width", e.menuWidth))
                            }
                        })) : (o.css({
                            width: "",
                            right: "0",
                            left: ""
                        }), a.velocity({
                            right: -1 * (e.menuWidth + 10)
                        }, {
                            duration: 200,
                            queue: !1,
                            easing: "easeOutCubic",
                            complete: function() {
                                i === !0 && (a.removeAttr("style"), a.css("width", e.menuWidth))
                            }
                        }))
                    }
                    var n = t(this),
                        a = t("#" + n.attr("data-activates"));
                    240 != e.menuWidth && a.css("width", e.menuWidth);
                    var o = t('<div class="drag-target"></div>');
                    t("body").append(o), "left" == e.edge ? (a.css("left", -1 * (e.menuWidth + 10)), o.css({
                        left: 0
                    })) : (a.addClass("right-aligned").css("right", -1 * (e.menuWidth + 10)).css("left", ""), o.css({
                        right: 0
                    })), a.hasClass("fixed") && window.innerWidth > 992 && a.css("left", 0), a.hasClass("fixed") && t(window).resize(function() {
                        window.innerWidth > 992 ? 0 !== t("#sidenav-overlay").css("opacity") && s ? i(!0) : (a.removeAttr("style"), a.css("width", e.menuWidth)) : s === !1 && ("left" === e.edge ? a.css("left", -1 * (e.menuWidth + 10)) : a.css("right", -1 * (e.menuWidth + 10)))
                    }), e.closeOnClick === !0 && a.on("click.itemclick", "a:not(.collapsible-header)", function() {
                        i()
                    });
                    var r = !1,
                        s = !1;
                    o.on("click", function() {
                        i()
                    }), o.hammer({
                        prevent_default: !1
                    }).bind("pan", function(n) {
                        if ("touch" == n.gesture.pointerType) {
                            {
                                var o = (n.gesture.direction, n.gesture.center.x);
                                n.gesture.center.y, n.gesture.velocityX
                            }
                            if (t("body").css("overflow", "hidden"), 0 === t("#sidenav-overlay").length) {
                                var r = t('<div id="sidenav-overlay"></div>');
                                r.css("opacity", 0).click(function() {
                                    i()
                                }), t("body").append(r)
                            }
                            if ("left" === e.edge && (o > e.menuWidth ? o = e.menuWidth : 0 > o && (o = 0)), "left" === e.edge) o < e.menuWidth / 2 ? s = !1 : o >= e.menuWidth / 2 && (s = !0), a.css("left", o - e.menuWidth);
                            else {
                                o < window.innerWidth - e.menuWidth / 2 ? s = !0 : o >= window.innerWidth - e.menuWidth / 2 && (s = !1);
                                var l = -1 * (o - e.menuWidth / 2);
                                l > 0 && (l = 0), a.css("right", l)
                            }
                            var u;
                            "left" === e.edge ? (u = o / e.menuWidth, t("#sidenav-overlay").velocity({
                                opacity: u
                            }, {
                                duration: 50,
                                queue: !1,
                                easing: "easeOutQuad"
                            })) : (u = Math.abs((o - window.innerWidth) / e.menuWidth), t("#sidenav-overlay").velocity({
                                opacity: u
                            }, {
                                duration: 50,
                                queue: !1,
                                easing: "easeOutQuad"
                            }))
                        }
                    }).bind("panend", function(i) {
                        if ("touch" == i.gesture.pointerType) {
                            var n = i.gesture.velocityX;
                            r = !1, "left" === e.edge ? s && .3 >= n || -.5 > n ? (a.velocity({
                                left: 0
                            }, {
                                duration: 300,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), t("#sidenav-overlay").velocity({
                                opacity: 1
                            }, {
                                duration: 50,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), o.css({
                                width: "50%",
                                right: 0,
                                left: ""
                            })) : (!s || n > .3) && (t("body").css("overflow", ""), a.velocity({
                                left: -1 * (e.menuWidth + 10)
                            }, {
                                duration: 200,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), t("#sidenav-overlay").velocity({
                                opacity: 0
                            }, {
                                duration: 200,
                                queue: !1,
                                easing: "easeOutQuad",
                                complete: function() {
                                    t(this).remove()
                                }
                            }), o.css({
                                width: "10px",
                                right: "",
                                left: 0
                            })) : s && n >= -.3 || n > .5 ? (a.velocity({
                                right: 0
                            }, {
                                duration: 300,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), t("#sidenav-overlay").velocity({
                                opacity: 1
                            }, {
                                duration: 50,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), o.css({
                                width: "50%",
                                right: "",
                                left: 0
                            })) : (!s || -.3 > n) && (t("body").css("overflow", ""), a.velocity({
                                right: -1 * (e.menuWidth + 10)
                            }, {
                                duration: 200,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), t("#sidenav-overlay").velocity({
                                opacity: 0
                            }, {
                                duration: 200,
                                queue: !1,
                                easing: "easeOutQuad",
                                complete: function() {
                                    t(this).remove()
                                }
                            }), o.css({
                                width: "10px",
                                right: 0,
                                left: ""
                            }))
                        }
                    }), n.click(function() {
                        if (s === !0) s = !1, r = !1, i();
                        else {
                            t("body").css("overflow", "hidden"), t("body").append(o), "left" === e.edge ? (o.css({
                                width: "50%",
                                right: 0,
                                left: ""
                            }), a.velocity({
                                left: 0
                            }, {
                                duration: 300,
                                queue: !1,
                                easing: "easeOutQuad"
                            })) : (o.css({
                                width: "50%",
                                right: "",
                                left: 0
                            }), a.velocity({
                                right: 0
                            }, {
                                duration: 300,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), a.css("left", ""));
                            var n = t('<div id="sidenav-overlay"></div>');
                            n.css("opacity", 0).click(function() {
                                s = !1, r = !1, i(), n.velocity({
                                    opacity: 0
                                }, {
                                    duration: 300,
                                    queue: !1,
                                    easing: "easeOutQuad",
                                    complete: function() {
                                        t(this).remove()
                                    }
                                })
                            }), t("body").append(n), n.velocity({
                                opacity: 1
                            }, {
                                duration: 300,
                                queue: !1,
                                easing: "easeOutQuad",
                                complete: function() {
                                    s = !0, r = !1
                                }
                            })
                        }
                        return !1
                    })
                })
            },
            show: function() {
                this.trigger("click")
            },
            hide: function() {
                t("#sidenav-overlay").trigger("click")
            }
        };
        t.fn.sideNav = function(i) {
            return e[i] ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof i && i ? void t.error("Method " + i + " does not exist on jQuery.sideNav") : e.init.apply(this, arguments)
        }
    }(jQuery),
    function(t) {
        var e = {
            init: function(e) {
                var i = {
                    indicators: !0,
                    height: 400,
                    transition: 500,
                    interval: 6e3
                };
                return e = t.extend(i, e), this.each(function() {
                    function i(t, e) {
                        t.hasClass("center-align") ? t.velocity({
                            opacity: 0,
                            translateY: -100
                        }, {
                            duration: e,
                            queue: !1
                        }) : t.hasClass("right-align") ? t.velocity({
                            opacity: 0,
                            translateX: 100
                        }, {
                            duration: e,
                            queue: !1
                        }) : t.hasClass("left-align") && t.velocity({
                            opacity: 0,
                            translateX: -100
                        }, {
                            duration: e,
                            queue: !1
                        })
                    }

                    function n(t) {
                        t >= s.length ? t = 0 : 0 > t && (t = s.length - 1), l = r.find(".active").index(), l != t && (a = s.eq(l), $caption = a.find(".caption"), a.removeClass("active"), a.velocity({
                            opacity: 0
                        }, {
                            duration: e.transition,
                            queue: !1,
                            easing: "easeOutQuad",
                            complete: function() {
                                s.not(".active").velocity({
                                    opacity: 0,
                                    translateX: 0,
                                    translateY: 0
                                }, {
                                    duration: 0,
                                    queue: !1
                                })
                            }
                        }), i($caption, e.transition), e.indicators && u.eq(l).removeClass("active"), s.eq(t).velocity({
                            opacity: 1
                        }, {
                            duration: e.transition,
                            queue: !1,
                            easing: "easeOutQuad"
                        }), s.eq(t).find(".caption").velocity({
                            opacity: 1,
                            translateX: 0,
                            translateY: 0
                        }, {
                            duration: e.transition,
                            delay: e.transition,
                            queue: !1,
                            easing: "easeOutQuad"
                        }), s.eq(t).addClass("active"), e.indicators && u.eq(t).addClass("active"))
                    }
                    var a, o = t(this),
                        r = o.find("ul.slides").first(),
                        s = r.find("li"),
                        l = r.find(".active").index();
                    if (-1 != l && (a = s.eq(l)), o.hasClass("fullscreen") || (o.height(e.indicators ? e.height + 40 : e.height), r.height(e.height)), s.find(".caption").each(function() {
                            i(t(this), 0)
                        }), s.find("img").each(function() {
                            t(this).css("background-image", "url(" + t(this).attr("src") + ")"), t(this).attr("src", "data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==")
                        }), e.indicators) {
                        var u = t('<ul class="indicators"></ul>');
                        s.each(function() {
                            var i = t('<li class="indicator-item"></li>');
                            i.click(function() {
                                var i = r.parent(),
                                    a = i.find(t(this)).index();
                                n(a), clearInterval($interval), $interval = setInterval(function() {
                                    l = r.find(".active").index(), s.length == l + 1 ? l = 0 : l += 1, n(l)
                                }, e.transition + e.interval)
                            }), u.append(i)
                        }), o.append(u), u = o.find("ul.indicators").find("li.indicator-item")
                    }
                    a ? a.show() : (s.first().addClass("active").velocity({
                        opacity: 1
                    }, {
                        duration: e.transition,
                        queue: !1,
                        easing: "easeOutQuad"
                    }), l = 0, a = s.eq(l), e.indicators && u.eq(l).addClass("active")), a.find("img").each(function() {
                        a.find(".caption").velocity({
                            opacity: 1,
                            translateX: 0,
                            translateY: 0
                        }, {
                            duration: e.transition,
                            queue: !1,
                            easing: "easeOutQuad"
                        })
                    }), $interval = setInterval(function() {
                        l = r.find(".active").index(), n(l + 1)
                    }, e.transition + e.interval);
                    var c = !1,
                        d = !1,
                        p = !1;
                    o.hammer({
                        prevent_default: !1
                    }).bind("pan", function(t) {
                        if ("touch" === t.gesture.pointerType) {
                            clearInterval($interval);
                            var e = t.gesture.direction,
                                i = t.gesture.deltaX,
                                n = t.gesture.velocityX;
                            $curr_slide = r.find(".active"), $curr_slide.velocity({
                                translateX: i
                            }, {
                                duration: 50,
                                queue: !1,
                                easing: "easeOutQuad"
                            }), 4 === e && (i > o.innerWidth() / 2 || -.65 > n) ? p = !0 : 2 === e && (i < -1 * o.innerWidth() / 2 || n > .65) && (d = !0);
                            var a;
                            d && (a = $curr_slide.next(), 0 === a.length && (a = s.first()), a.velocity({
                                opacity: 1
                            }, {
                                duration: 300,
                                queue: !1,
                                easing: "easeOutQuad"
                            })), p && (a = $curr_slide.prev(), 0 === a.length && (a = s.last()), a.velocity({
                                opacity: 1
                            }, {
                                duration: 300,
                                queue: !1,
                                easing: "easeOutQuad"
                            }))
                        }
                    }).bind("panend", function(t) {
                        "touch" === t.gesture.pointerType && ($curr_slide = r.find(".active"), c = !1, curr_index = r.find(".active").index(), p || d ? d ? (n(curr_index + 1), $curr_slide.velocity({
                            translateX: -1 * o.innerWidth()
                        }, {
                            duration: 300,
                            queue: !1,
                            easing: "easeOutQuad",
                            complete: function() {
                                $curr_slide.velocity({
                                    opacity: 0,
                                    translateX: 0
                                }, {
                                    duration: 0,
                                    queue: !1
                                })
                            }
                        })) : p && (n(curr_index - 1), $curr_slide.velocity({
                            translateX: o.innerWidth()
                        }, {
                            duration: 300,
                            queue: !1,
                            easing: "easeOutQuad",
                            complete: function() {
                                $curr_slide.velocity({
                                    opacity: 0,
                                    translateX: 0
                                }, {
                                    duration: 0,
                                    queue: !1
                                })
                            }
                        })) : $curr_slide.velocity({
                            translateX: 0
                        }, {
                            duration: 300,
                            queue: !1,
                            easing: "easeOutQuad"
                        }), d = !1, p = !1, clearInterval($interval), $interval = setInterval(function() {
                            l = r.find(".active").index(), s.length == l + 1 ? l = 0 : l += 1, n(l)
                        }, e.transition + e.interval))
                    }), o.on("sliderPause", function() {
                        clearInterval($interval)
                    }), o.on("sliderStart", function() {
                        clearInterval($interval), $interval = setInterval(function() {
                            l = r.find(".active").index(), s.length == l + 1 ? l = 0 : l += 1, n(l)
                        }, e.transition + e.interval)
                    })
                })
            },
            pause: function() {
                t(this).trigger("sliderPause")
            },
            start: function() {
                t(this).trigger("sliderStart")
            }
        };
        t.fn.slider = function(i) {
            return e[i] ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof i && i ? void t.error("Method " + i + " does not exist on jQuery.tooltip") : e.init.apply(this, arguments)
        }
    }(jQuery),
    function(t) {
        var e = {
            init: function() {
                return this.each(function() {
                    function e() {
                        return c = p.hasClass("rtl"), c ? {
                            right: u * l,
                            left: s - (u + 1) * l
                        } : {
                            right: s - (u + 1) * l,
                            left: u * l
                        }
                    } {
                        var i = t(this);
                        t(window).width()
                    }
                    i.width("100%");
                    var n = t(this).children("li").length;
                    i.children("li").each(function() {
                        t(this).width(100 / n + "%")
                    });
                    var a, o, r = i.find("li.tab a"),
                        s = i.width(),
                        l = i.find("li").first().outerWidth(),
                        u = 0,
                        c = !1;
                    a = t(r.filter('[href="' + location.hash + '"]')), 0 === a.length && (a = t(this).find("li.tab a.active").first()), 0 === a.length && (a = t(this).find("li.tab a").first()), a.addClass("active"), u = r.index(a), 0 > u && (u = 0), o = t(a[0].hash), i.append('<div class="indicator"></div>');
                    var d = i.find(".indicator"),
                        p = t("html");
                    i.is(":visible") && (d.css({
                        right: s - (u + 1) * l
                    }), d.css({
                        left: u * l
                    })), t(window).resize(function() {
                        s = i.width(), l = i.find("li").first().outerWidth(), 0 > u && (u = 0), 0 !== l && 0 !== s && (d.css({
                            right: s - (u + 1) * l
                        }), d.css({
                            left: u * l
                        }))
                    }), r.not(a).each(function() {
                        t(this.hash).hide()
                    }), i.on("click", "a", function(n) {
                        if (t(this).parent().hasClass("disabled")) return void n.preventDefault();
                        s = i.width(), l = i.find("li").first().outerWidth(), a.removeClass("active"), o.hide(), a = t(this), o = t(this.hash), r = i.find("li.tab a"), a.addClass("active");
                        var p = u;
                        u = r.index(t(this)), 0 > u && (u = 0), o.show();
                        var h = e();
                        !c && u - p >= 0 || c && 0 > u - p ? (d.velocity({
                            right: h.right
                        }, {
                            duration: 300,
                            queue: !1,
                            easing: "easeOutQuad"
                        }), d.velocity({
                            left: h.left
                        }, {
                            duration: 300,
                            queue: !1,
                            easing: "easeOutQuad",
                            delay: 90
                        })) : (d.velocity({
                            left: h.left
                        }, {
                            duration: 300,
                            queue: !1,
                            easing: "easeOutQuad"
                        }), d.velocity({
                            right: h.right
                        }, {
                            duration: 300,
                            queue: !1,
                            easing: "easeOutQuad",
                            delay: 90
                        })), n.preventDefault()
                    })
                })
            },
            select_tab: function(t) {
                this.find('a[href="#' + t + '"]').trigger("click")
            }
        };
        t.fn.tabs = function(i) {
            return e[i] ? e[i].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof i && i ? void t.error("Method " + i + " does not exist on jQuery.tooltip") : e.init.apply(this, arguments)
        }, t(document).ready(function() {
            t(".tabs").tabs()
        })
    }(jQuery), Materialize.toast = function(t, e, i, n) {
    function a(t) {
        var e = document.createElement("div");
        if (e.classList.add("toast"), i)
            for (var a = i.split(" "), o = 0, r = a.length; r > o; o++) e.classList.add(a[o]);
        ("object" == typeof HTMLElement ? t instanceof HTMLElement : t && "object" == typeof t && null !== t && 1 === t.nodeType && "string" == typeof t.nodeName) ? e.appendChild(t): t instanceof jQuery ? e.appendChild(t[0]) : e.innerHTML = t;
        var s = new Hammer(e, {
            prevent_default: !1
        });
        return s.on("pan", function(t) {
            var i = t.deltaX,
                n = 80;
            e.classList.contains("panning") || e.classList.add("panning");
            var a = 1 - Math.abs(i / n);
            0 > a && (a = 0), Vel(e, {
                left: i,
                opacity: a
            }, {
                duration: 50,
                queue: !1,
                easing: "easeOutQuad"
            })
        }), s.on("panend", function(t) {
            var i = t.deltaX,
                a = 80;
            Math.abs(i) > a ? Vel(e, {
                marginTop: "-40px"
            }, {
                duration: 375,
                easing: "easeOutExpo",
                queue: !1,
                complete: function() {
                    "function" == typeof n && n(), e.parentNode.removeChild(e)
                }
            }) : (e.classList.remove("panning"), Vel(e, {
                left: 0,
                opacity: 1
            }, {
                duration: 300,
                easing: "easeOutExpo",
                queue: !1
            }))
        }), e
    }
    i = i || "";
    var o = document.getElementById("toast-container");
    null === o && (o = document.createElement("div"), o.id = "toast-container", document.body.appendChild(o));
    var r = a(t);
    t && o.appendChild(r), r.style.top = "35px", r.style.opacity = 0, Vel(r, {
        top: "0px",
        opacity: 1
    }, {
        duration: 300,
        easing: "easeOutCubic",
        queue: !1
    });
    var s = e,
        l = setInterval(function() {
            null === r.parentNode && window.clearInterval(l), r.classList.contains("panning") || (s -= 20), 0 >= s && (Vel(r, {
                opacity: 0,
                marginTop: "-40px"
            }, {
                duration: 375,
                easing: "easeOutExpo",
                queue: !1,
                complete: function() {
                    "function" == typeof n && n(), this[0].parentNode.removeChild(this[0])
                }
            }), window.clearInterval(l))
        }, 20)
},
    function(t) {
        t.fn.tooltip = function(e) {
            var i = null,
                n = !1,
                a = null,
                o = 5,
                r = {
                    delay: 350
                };
            return "remove" === e ? (this.each(function() {
                t("#" + t(this).attr("data-tooltip-id")).remove()
            }), !1) : (e = t.extend(r, e), this.each(function() {
                var r = Materialize.guid(),
                    s = t(this);
                s.attr("data-tooltip-id", r);
                var l = t("<span></span>").text(s.attr("data-tooltip")),
                    u = t("<div></div>");
                u.addClass("material-tooltip").append(l).appendTo(t("body")).attr("id", r);
                var c = t("<div></div>").addClass("backdrop");
                c.appendTo(u), c.css({
                    top: 0,
                    left: 0
                }), s.off("mouseenter.tooltip mouseleave.tooltip"), s.on({
                    "mouseenter.tooltip": function() {
                        var t = s.data("delay");
                        t = void 0 === t || "" === t ? e.delay : t, i = 0, a = setInterval(function() {
                            if (i += 10, i >= t && n === !1) {
                                n = !0, u.css({
                                    display: "block",
                                    left: "0px",
                                    top: "0px"
                                }), u.children("span").text(s.attr("data-tooltip"));
                                var e = s.outerWidth(),
                                    a = s.outerHeight(),
                                    r = s.attr("data-position"),
                                    l = u.outerHeight(),
                                    d = u.outerWidth(),
                                    p = "0px",
                                    h = "0px",
                                    f = 8;
                                "top" === r ? (u.css({
                                    top: s.offset().top - l - o,
                                    left: s.offset().left + e / 2 - d / 2
                                }), p = "-10px", c.css({
                                    borderRadius: "14px 14px 0 0",
                                    transformOrigin: "50% 90%",
                                    marginTop: l,
                                    marginLeft: d / 2 - c.width() / 2
                                })) : "left" === r ? (u.css({
                                    top: s.offset().top + a / 2 - l / 2,
                                    left: s.offset().left - d - o
                                }), h = "-10px", c.css({
                                    width: "14px",
                                    height: "14px",
                                    borderRadius: "14px 0 0 14px",
                                    transformOrigin: "95% 50%",
                                    marginTop: l / 2,
                                    marginLeft: d
                                })) : "right" === r ? (u.css({
                                    top: s.offset().top + a / 2 - l / 2,
                                    left: s.offset().left + e + o
                                }), h = "+10px", c.css({
                                    width: "14px",
                                    height: "14px",
                                    borderRadius: "0 14px 14px 0",
                                    transformOrigin: "5% 50%",
                                    marginTop: l / 2,
                                    marginLeft: "0px"
                                })) : (u.css({
                                    top: s.offset().top + s.outerHeight() + o,
                                    left: s.offset().left + e / 2 - d / 2
                                }), p = "+10px", c.css({
                                    marginLeft: d / 2 - c.width() / 2
                                })), f = d / 8, 8 > f && (f = 8), ("right" === r || "left" === r) && (f = d / 10, 6 > f && (f = 6)), u.velocity({
                                    marginTop: p,
                                    marginLeft: h
                                }, {
                                    duration: 350,
                                    queue: !1
                                }).velocity({
                                    opacity: 1
                                }, {
                                    duration: 300,
                                    delay: 50,
                                    queue: !1
                                }), c.css({
                                    display: "block"
                                }).velocity({
                                    opacity: 1
                                }, {
                                    duration: 55,
                                    delay: 0,
                                    queue: !1
                                }).velocity({
                                    scale: f
                                }, {
                                    duration: 300,
                                    delay: 0,
                                    queue: !1,
                                    easing: "easeInOutQuad"
                                })
                            }
                        }, 10)
                    },
                    "mouseleave.tooltip": function() {
                        clearInterval(a), i = 0, u.velocity({
                            opacity: 0,
                            marginTop: 0,
                            marginLeft: 0
                        }, {
                            duration: 225,
                            queue: !1,
                            delay: 225
                        }), c.velocity({
                            opacity: 0,
                            scale: 1
                        }, {
                            duration: 225,
                            delay: 275,
                            queue: !1,
                            complete: function() {
                                c.css("display", "none"), u.css("display", "none"), n = !1
                            }
                        })
                    }
                })
            }))
        }, t(document).ready(function() {
            t(".tooltipped").tooltip()
        })
    }(jQuery),
    function(t) {
        Materialize.fadeInImage = function(e) {
            var i = t(e);
            i.css({
                opacity: 0
            }), t(i).velocity({
                opacity: 1
            }, {
                duration: 650,
                queue: !1,
                easing: "easeOutSine"
            }), t(i).velocity({
                opacity: 1
            }, {
                duration: 1300,
                queue: !1,
                easing: "swing",
                step: function(e, i) {
                    i.start = 100;
                    var n = e / 100,
                        a = 150 - (100 - e) / 1.75;
                    100 > a && (a = 100), e >= 0 && t(this).css({
                        "-webkit-filter": "grayscale(" + n + ")brightness(" + a + "%)",
                        filter: "grayscale(" + n + ")brightness(" + a + "%)"
                    })
                }
            })
        }, Materialize.showStaggeredList = function(e) {
            var i = 0;
            t(e).find("li").velocity({
                translateX: "-100px"
            }, {
                duration: 0
            }), t(e).find("li").each(function() {
                t(this).velocity({
                    opacity: "1",
                    translateX: "0"
                }, {
                    duration: 800,
                    delay: i,
                    easing: [60, 10]
                }), i += 120
            })
        }, t(document).ready(function() {
            var e = !1,
                i = !1;
            t(".dismissable").each(function() {
                t(this).hammer({
                    prevent_default: !1
                }).bind("pan", function(n) {
                    if ("touch" === n.gesture.pointerType) {
                        var a = t(this),
                            o = n.gesture.direction,
                            r = n.gesture.deltaX,
                            s = n.gesture.velocityX;
                        a.velocity({
                            translateX: r
                        }, {
                            duration: 50,
                            queue: !1,
                            easing: "easeOutQuad"
                        }), 4 === o && (r > a.innerWidth() / 2 || -.75 > s) && (e = !0), 2 === o && (r < -1 * a.innerWidth() / 2 || s > .75) && (i = !0)
                    }
                }).bind("panend", function(n) {
                    if (Math.abs(n.gesture.deltaX) < t(this).innerWidth() / 2 && (i = !1, e = !1), "touch" === n.gesture.pointerType) {
                        var a = t(this);
                        if (e || i) {
                            var o;
                            o = e ? a.innerWidth() : -1 * a.innerWidth(), a.velocity({
                                translateX: o
                            }, {
                                duration: 100,
                                queue: !1,
                                easing: "easeOutQuad",
                                complete: function() {
                                    a.css("border", "none"), a.velocity({
                                        height: 0,
                                        padding: 0
                                    }, {
                                        duration: 200,
                                        queue: !1,
                                        easing: "easeOutQuad",
                                        complete: function() {
                                            a.remove()
                                        }
                                    })
                                }
                            })
                        } else a.velocity({
                            translateX: 0
                        }, {
                            duration: 100,
                            queue: !1,
                            easing: "easeOutQuad"
                        });
                        e = !1, i = !1
                    }
                })
            })
        })
    }(jQuery),
    function(t) {
        "use strict";

        function e(t) {
            return null !== t && t === t.window
        }

        function i(t) {
            return e(t) ? t : 9 === t.nodeType && t.defaultView
        }

        function n(t) {
            var e, n, a = {
                    top: 0,
                    left: 0
                },
                o = t && t.ownerDocument;
            return e = o.documentElement, "undefined" != typeof t.getBoundingClientRect && (a = t.getBoundingClientRect()), n = i(o), {
                top: a.top + n.pageYOffset - e.clientTop,
                left: a.left + n.pageXOffset - e.clientLeft
            }
        }

        function a(t) {
            var e = "";
            for (var i in t) t.hasOwnProperty(i) && (e += i + ":" + t[i] + ";");
            return e
        }

        function o(t) {
            if (c.allowEvent(t) === !1) return null;

            for (var e = null, i = t.target || t.srcElement; i !== undefined && null !== i.parentElement;) {
                if (!(i instanceof SVGElement || -1 === i.className.indexOf("waves-effect"))) {
                    e = i;
                    break
                }
                if (i.classList && i.classList.contains("waves-effect")) {
                    e = i;
                    break
                }
                i = i.parentElement
            }
            return e
        }

        function r(e) {
            var i = o(e);
            null !== i && (u.show(e, i), "ontouchstart" in t && (i.addEventListener("touchend", u.hide, !1), i.addEventListener("touchcancel", u.hide, !1)), i.addEventListener("mouseup", u.hide, !1), i.addEventListener("mouseleave", u.hide, !1))
        }
        var s = s || {},
            l = document.querySelectorAll.bind(document),
            u = {
                duration: 750,
                show: function(t, e) {
                    if (2 === t.button) return !1;
                    var i = e || this,
                        o = document.createElement("div");
                    o.className = "waves-ripple", i.appendChild(o);
                    var r = n(i),
                        s = t.pageY - r.top,
                        l = t.pageX - r.left,
                        c = "scale(" + i.clientWidth / 100 * 10 + ")";
                    "touches" in t && (s = t.touches[0].pageY - r.top, l = t.touches[0].pageX - r.left), o.setAttribute("data-hold", Date.now()), o.setAttribute("data-scale", c), o.setAttribute("data-x", l), o.setAttribute("data-y", s);
                    var d = {
                        top: s + "px",
                        left: l + "px"
                    };
                    o.className = o.className + " waves-notransition", o.setAttribute("style", a(d)), o.className = o.className.replace("waves-notransition", ""), d["-webkit-transform"] = c, d["-moz-transform"] = c, d["-ms-transform"] = c, d["-o-transform"] = c, d.transform = c, d.opacity = "1", d["-webkit-transition-duration"] = u.duration + "ms", d["-moz-transition-duration"] = u.duration + "ms", d["-o-transition-duration"] = u.duration + "ms", d["transition-duration"] = u.duration + "ms", d["-webkit-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", d["-moz-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", d["-o-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", d["transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)", o.setAttribute("style", a(d))
                },
                hide: function(t) {
                    c.touchup(t);
                    var e = this,
                        i = (1.4 * e.clientWidth, null),
                        n = e.getElementsByClassName("waves-ripple");
                    if (!(n.length > 0)) return !1;
                    i = n[n.length - 1];
                    var o = i.getAttribute("data-x"),
                        r = i.getAttribute("data-y"),
                        s = i.getAttribute("data-scale"),
                        l = Date.now() - Number(i.getAttribute("data-hold")),
                        d = 350 - l;
                    0 > d && (d = 0), setTimeout(function() {
                        var t = {
                            top: r + "px",
                            left: o + "px",
                            opacity: "0",
                            "-webkit-transition-duration": u.duration + "ms",
                            "-moz-transition-duration": u.duration + "ms",
                            "-o-transition-duration": u.duration + "ms",
                            "transition-duration": u.duration + "ms",
                            "-webkit-transform": s,
                            "-moz-transform": s,
                            "-ms-transform": s,
                            "-o-transform": s,
                            transform: s
                        };
                        i.setAttribute("style", a(t)), setTimeout(function() {
                            try {
                                e.removeChild(i)
                            } catch (t) {
                                return !1
                            }
                        }, u.duration)
                    }, d)
                },
                wrapInput: function(t) {
                    for (var e = 0; e < t.length; e++) {
                        var i = t[e];
                        if ("input" === i.tagName.toLowerCase()) {
                            var n = i.parentNode;
                            if ("i" === n.tagName.toLowerCase() && -1 !== n.className.indexOf("waves-effect")) continue;
                            var a = document.createElement("i");
                            a.className = i.className + " waves-input-wrapper";
                            var o = i.getAttribute("style");
                            o || (o = ""), a.setAttribute("style", o), i.className = "waves-button-input", i.removeAttribute("style"), n.replaceChild(a, i), a.appendChild(i)
                        }
                    }
                }
            },
            c = {
                touches: 0,
                allowEvent: function(t) {
                    var e = !0;
                    return "touchstart" === t.type ? c.touches += 1 : "touchend" === t.type || "touchcancel" === t.type ? setTimeout(function() {
                        c.touches > 0 && (c.touches -= 1)
                    }, 500) : "mousedown" === t.type && c.touches > 0 && (e = !1), e
                },
                touchup: function(t) {
                    c.allowEvent(t)
                }
            };
        s.displayEffect = function(e) {
            e = e || {}, "duration" in e && (u.duration = e.duration), u.wrapInput(l(".waves-effect")), "ontouchstart" in t && document.body.addEventListener("touchstart", r, !1), document.body.addEventListener("mousedown", r, !1)
        }, s.attach = function(e) {
            "input" === e.tagName.toLowerCase() && (u.wrapInput([e]), e = e.parentElement), "ontouchstart" in t && e.addEventListener("touchstart", r, !1), e.addEventListener("mousedown", r, !1)
        }, t.Waves = s, document.addEventListener("DOMContentLoaded", function() {
            s.displayEffect()
        }, !1)
    }(window),
    function(t) {
        "function" == typeof define && define.amd ? define("picker", ["jquery"], t) : "object" == typeof exports ? module.exports = t(require("jquery")) : this.Picker = t(jQuery)
    }(function(t) {
        function e(o, r, l, d) {
            function p() {
                return e._.node("div", e._.node("div", e._.node("div", e._.node("div", C.component.nodes(b.open), x.box), x.wrap), x.frame), x.holder)
            }

            function h() {
                k.data(r, C).addClass(x.input).attr("tabindex", -1).val(k.data("value") ? C.get("select", w.format) : o.value), w.editable || k.on("focus." + b.id + " click." + b.id, function(t) {
                    t.preventDefault(), C.$root[0].focus()
                }).on("keydown." + b.id, v), a(o, {
                    haspopup: !0,
                    expanded: !1,
                    readonly: !1,
                    owns: o.id + "_root"
                })
            }

            function f() {
                C.$root.on({
                    keydown: v,
                    focusin: function(t) {
                        C.$root.removeClass(x.focused), t.stopPropagation()
                    },
                    "mousedown click": function(e) {
                        var i = e.target;
                        i != C.$root.children()[0] && (e.stopPropagation(), "mousedown" != e.type || t(i).is("input, select, textarea, button, option") || (e.preventDefault(), C.$root[0].focus()))
                    }
                }).on({
                    focus: function() {
                        k.addClass(x.target)
                    },
                    blur: function() {
                        k.removeClass(x.target)
                    }
                }).on("focus.toOpen", m).on("click", "[data-pick], [data-nav], [data-clear], [data-close]", function() {
                    var e = t(this),
                        i = e.data(),
                        n = e.hasClass(x.navDisabled) || e.hasClass(x.disabled),
                        a = s();
                    a = a && (a.type || a.href), (n || a && !t.contains(C.$root[0], a)) && C.$root[0].focus(), !n && i.nav ? C.set("highlight", C.component.item.highlight, {
                        nav: i.nav
                    }) : !n && "pick" in i ? C.set("select", i.pick) : i.clear ? C.clear().close(!0) : i.close && C.close(!0)
                }), a(C.$root[0], "hidden", !0)
            }

            function g() {
                var e;
                w.hiddenName === !0 ? (e = o.name, o.name = "") : (e = ["string" == typeof w.hiddenPrefix ? w.hiddenPrefix : "", "string" == typeof w.hiddenSuffix ? w.hiddenSuffix : "_submit"], e = e[0] + o.name + e[1]), C._hidden = t('<input type=hidden name="' + e + '"' + (k.data("value") || o.value ? ' value="' + C.get("select", w.formatSubmit) + '"' : "") + ">")[0], k.on("change." + b.id, function() {
                    C._hidden.value = o.value ? C.get("select", w.formatSubmit) : ""
                }), w.container ? t(w.container).append(C._hidden) : k.after(C._hidden)
            }

            function v(t) {
                var e = t.keyCode,
                    i = /^(8|46)$/.test(e);
                return 27 == e ? (C.close(), !1) : void((32 == e || i || !b.open && C.component.key[e]) && (t.preventDefault(), t.stopPropagation(), i ? C.clear().close() : C.open()))
            }

            function m(t) {
                t.stopPropagation(), "focus" == t.type && C.$root.addClass(x.focused), C.open()
            }
            if (!o) return e;
            var y = !1,
                b = {
                    id: o.id || "P" + Math.abs(~~(Math.random() * new Date))
                },
                w = l ? t.extend(!0, {}, l.defaults, d) : d || {},
                x = t.extend({}, e.klasses(), w.klass),
                k = t(o),
                S = function() {
                    return this.start()
                },
                C = S.prototype = {
                    constructor: S,
                    $node: k,
                    start: function() {
                        return b && b.start ? C : (b.methods = {}, b.start = !0, b.open = !1, b.type = o.type, o.autofocus = o == s(), o.readOnly = !w.editable, o.id = o.id || b.id, "text" != o.type && (o.type = "text"), C.component = new l(C, w), C.$root = t(e._.node("div", p(), x.picker, 'id="' + o.id + '_root" tabindex="0"')), f(), w.formatSubmit && g(), h(), w.container ? t(w.container).append(C.$root) : k.after(C.$root), C.on({
                            start: C.component.onStart,
                            render: C.component.onRender,
                            stop: C.component.onStop,
                            open: C.component.onOpen,
                            close: C.component.onClose,
                            set: C.component.onSet
                        }).on({
                            start: w.onStart,
                            render: w.onRender,
                            stop: w.onStop,
                            open: w.onOpen,
                            close: w.onClose,
                            set: w.onSet
                        }), y = i(C.$root.children()[0]), o.autofocus && C.open(), C.trigger("start").trigger("render"))
                    },
                    render: function(t) {
                        return t ? C.$root.html(p()) : C.$root.find("." + x.box).html(C.component.nodes(b.open)), C.trigger("render")
                    },
                    stop: function() {
                        return b.start ? (C.close(), C._hidden && C._hidden.parentNode.removeChild(C._hidden), C.$root.remove(), k.removeClass(x.input).removeData(r), setTimeout(function() {
                            k.off("." + b.id)
                        }, 0), o.type = b.type, o.readOnly = !1, C.trigger("stop"), b.methods = {}, b.start = !1, C) : C
                    },
                    open: function(i) {
                        return b.open ? C : (k.addClass(x.active), a(o, "expanded", !0), setTimeout(function() {
                            C.$root.addClass(x.opened), a(C.$root[0], "hidden", !1)
                        }, 0), i !== !1 && (b.open = !0, y && c.css("overflow", "hidden").css("padding-right", "+=" + n()), C.$root[0].focus(), u.on("click." + b.id + " focusin." + b.id, function(t) {
                            var e = t.target;
                            e != o && e != document && 3 != t.which && C.close(e === C.$root.children()[0])
                        }).on("keydown." + b.id, function(i) {
                            var n = i.keyCode,
                                a = C.component.key[n],
                                o = i.target;
                            27 == n ? C.close(!0) : o != C.$root[0] || !a && 13 != n ? t.contains(C.$root[0], o) && 13 == n && (i.preventDefault(), o.click()) : (i.preventDefault(), a ? e._.trigger(C.component.key.go, C, [e._.trigger(a)]) : C.$root.find("." + x.highlighted).hasClass(x.disabled) || C.set("select", C.component.item.highlight).close())
                        })), C.trigger("open"))
                    },
                    close: function(t) {
                        return t && (C.$root.off("focus.toOpen")[0].focus(), setTimeout(function() {
                            C.$root.on("focus.toOpen", m)
                        }, 0)), k.removeClass(x.active), a(o, "expanded", !1), setTimeout(function() {
                            C.$root.removeClass(x.opened + " " + x.focused), a(C.$root[0], "hidden", !0)
                        }, 0), b.open ? (b.open = !1, y && c.css("overflow", "").css("padding-right", "-=" + n()), u.off("." + b.id), C.trigger("close")) : C
                    },
                    clear: function(t) {
                        return C.set("clear", null, t)
                    },
                    set: function(e, i, n) {
                        var a, o, r = t.isPlainObject(e),
                            s = r ? e : {};
                        if (n = r && t.isPlainObject(i) ? i : n || {}, e) {
                            r || (s[e] = i);
                            for (a in s) o = s[a], a in C.component.item && (void 0 === o && (o = null), C.component.set(a, o, n)), ("select" == a || "clear" == a) && k.val("clear" == a ? "" : C.get(a, w.format)).trigger("change");
                            C.render()
                        }
                        return n.muted ? C : C.trigger("set", s)
                    },
                    get: function(t, i) {
                        if (t = t || "value", null != b[t]) return b[t];
                        if ("valueSubmit" == t) {
                            if (C._hidden) return C._hidden.value;
                            t = "value"
                        }
                        if ("value" == t) return o.value;
                        if (t in C.component.item) {
                            if ("string" == typeof i) {
                                var n = C.component.get(t);
                                return n ? e._.trigger(C.component.formats.toString, C.component, [i, n]) : ""
                            }
                            return C.component.get(t)
                        }
                    },
                    on: function(e, i, n) {
                        var a, o, r = t.isPlainObject(e),
                            s = r ? e : {};
                        if (e) {
                            r || (s[e] = i);
                            for (a in s) o = s[a], n && (a = "_" + a), b.methods[a] = b.methods[a] || [], b.methods[a].push(o)
                        }
                        return C
                    },
                    off: function() {
                        var t, e, i = arguments;
                        for (t = 0, namesCount = i.length; t < namesCount; t += 1) e = i[t], e in b.methods && delete b.methods[e];
                        return C
                    },
                    trigger: function(t, i) {
                        var n = function(t) {
                            var n = b.methods[t];
                            n && n.map(function(t) {
                                e._.trigger(t, C, [i])
                            })
                        };
                        return n("_" + t), n(t), C
                    }
                };
            return new S
        }

        function i(t) {
            var e, i = "position";
            return t.currentStyle ? e = t.currentStyle[i] : window.getComputedStyle && (e = getComputedStyle(t)[i]), "fixed" == e
        }

        function n() {
            if (c.height() <= l.height()) return 0;
            var e = t('<div style="visibility:hidden;width:100px" />').appendTo("body"),
                i = e[0].offsetWidth;
            e.css("overflow", "scroll");
            var n = t('<div style="width:100%" />').appendTo(e),
                a = n[0].offsetWidth;
            return e.remove(), i - a
        }

        function a(e, i, n) {
            if (t.isPlainObject(i))
                for (var a in i) o(e, a, i[a]);
            else o(e, i, n)
        }

        function o(t, e, i) {
            t.setAttribute(("role" == e ? "" : "aria-") + e, i)
        }

        function r(e, i) {
            t.isPlainObject(e) || (e = {
                attribute: i
            }), i = "";
            for (var n in e) {
                var a = ("role" == n ? "" : "aria-") + n,
                    o = e[n];
                i += null == o ? "" : a + '="' + e[n] + '"'
            }
            return i
        }

        function s() {
            try {
                return document.activeElement
            } catch (t) {}
        }
        var l = t(window),
            u = t(document),
            c = t(document.documentElement);
        return e.klasses = function(t) {
            return t = t || "picker", {
                picker: t,
                opened: t + "--opened",
                focused: t + "--focused",
                input: t + "__input",
                active: t + "__input--active",
                target: t + "__input--target",
                holder: t + "__holder",
                frame: t + "__frame",
                wrap: t + "__wrap",
                box: t + "__box"
            }
        }, e._ = {
            group: function(t) {
                for (var i, n = "", a = e._.trigger(t.min, t); a <= e._.trigger(t.max, t, [a]); a += t.i) i = e._.trigger(t.item, t, [a]), n += e._.node(t.node, i[0], i[1], i[2]);
                return n
            },
            node: function(e, i, n, a) {
                return i ? (i = t.isArray(i) ? i.join("") : i, n = n ? ' class="' + n + '"' : "", a = a ? " " + a : "", "<" + e + n + a + ">" + i + "</" + e + ">") : ""
            },
            lead: function(t) {
                return (10 > t ? "0" : "") + t
            },
            trigger: function(t, e, i) {
                return "function" == typeof t ? t.apply(e, i || []) : t
            },
            digits: function(t) {
                return /\d/.test(t[1]) ? 2 : 1
            },
            isDate: function(t) {
                return {}.toString.call(t).indexOf("Date") > -1 && this.isInteger(t.getDate())
            },
            isInteger: function(t) {
                return {}.toString.call(t).indexOf("Number") > -1 && t % 1 === 0
            },
            ariaAttr: r
        }, e.extend = function(i, n) {
            t.fn[i] = function(a, o) {
                var r = this.data(i);
                return "picker" == a ? r : r && "string" == typeof a ? e._.trigger(r[a], r, [o]) : this.each(function() {
                    var o = t(this);
                    o.data(i) || new e(this, i, n, a)
                })
            }, t.fn[i].defaults = n.defaults
        }, e
    }),
    function(t) {
        "function" == typeof define && define.amd ? define(["picker", "jquery"], t) : "object" == typeof exports ? module.exports = t(require("./picker.js"), require("jquery")) : t(Picker, jQuery)
    }(function(t, e) {
        function i(t, e) {
            var i = this,
                n = t.$node[0],
                a = n.value,
                o = t.$node.data("value"),
                r = o || a,
                s = o ? e.formatSubmit : e.format,
                l = function() {
                    return n.currentStyle ? "rtl" == n.currentStyle.direction : "rtl" == getComputedStyle(t.$root[0]).direction
                };
            i.settings = e, i.$node = t.$node, i.queue = {
                min: "measure create",
                max: "measure create",
                now: "now create",
                select: "parse create validate",
                highlight: "parse navigate create validate",
                view: "parse create validate viewset",
                disable: "deactivate",
                enable: "activate"
            }, i.item = {}, i.item.clear = null, i.item.disable = (e.disable || []).slice(0), i.item.enable = - function(t) {
                return t[0] === !0 ? t.shift() : -1
            }(i.item.disable), i.set("min", e.min).set("max", e.max).set("now"), r ? i.set("select", r, {
                format: s
            }) : i.set("select", null).set("highlight", i.item.now), i.key = {
                40: 7,
                38: -7,
                39: function() {
                    return l() ? -1 : 1
                },
                37: function() {
                    return l() ? 1 : -1
                },
                go: function(t) {
                    var e = i.item.highlight,
                        n = new Date(e.year, e.month, e.date + t);
                    i.set("highlight", n, {
                        interval: t
                    }), this.render()
                }
            }, t.on("render", function() {
                t.$root.find("." + e.klass.selectMonth).on("change", function() {
                    var i = this.value;
                    i && (t.set("highlight", [t.get("view").year, i, t.get("highlight").date]), t.$root.find("." + e.klass.selectMonth).trigger("focus"))
                }), t.$root.find("." + e.klass.selectYear).on("change", function() {
                    var i = this.value;
                    i && (t.set("highlight", [i, t.get("view").month, t.get("highlight").date]), t.$root.find("." + e.klass.selectYear).trigger("focus"))
                })
            }, 1).on("open", function() {
                var n = "";
                i.disabled(i.get("now")) && (n = ":not(." + e.klass.buttonToday + ")"), t.$root.find("button" + n + ", select").attr("disabled", !1)
            }, 1).on("close", function() {
                t.$root.find("button, select").attr("disabled", !0)
            }, 1)
        }
        var n = 7,
            a = 6,
            o = t._;
        i.prototype.set = function(t, e, i) {
            var n = this,
                a = n.item;
            return null === e ? ("clear" == t && (t = "select"), a[t] = e, n) : (a["enable" == t ? "disable" : "flip" == t ? "enable" : t] = n.queue[t].split(" ").map(function(a) {
                return e = n[a](t, e, i)
            }).pop(), "select" == t ? n.set("highlight", a.select, i) : "highlight" == t ? n.set("view", a.highlight, i) : t.match(/^(flip|min|max|disable|enable)$/) && (a.select && n.disabled(a.select) && n.set("select", a.select, i), a.highlight && n.disabled(a.highlight) && n.set("highlight", a.highlight, i)), n)
        }, i.prototype.get = function(t) {
            return this.item[t]
        }, i.prototype.create = function(t, i, n) {
            var a, r = this;
            return i = void 0 === i ? t : i, i == -1 / 0 || 1 / 0 == i ? a = i : e.isPlainObject(i) && o.isInteger(i.pick) ? i = i.obj : e.isArray(i) ? (i = new Date(i[0], i[1], i[2]), i = o.isDate(i) ? i : r.create().obj) : i = o.isInteger(i) || o.isDate(i) ? r.normalize(new Date(i), n) : r.now(t, i, n), {
                year: a || i.getFullYear(),
                month: a || i.getMonth(),
                date: a || i.getDate(),
                day: a || i.getDay(),
                obj: a || i,
                pick: a || i.getTime()
            }
        }, i.prototype.createRange = function(t, i) {
            var n = this,
                a = function(t) {
                    return t === !0 || e.isArray(t) || o.isDate(t) ? n.create(t) : t
                };
            return o.isInteger(t) || (t = a(t)), o.isInteger(i) || (i = a(i)), o.isInteger(t) && e.isPlainObject(i) ? t = [i.year, i.month, i.date + t] : o.isInteger(i) && e.isPlainObject(t) && (i = [t.year, t.month, t.date + i]), {
                from: a(t),
                to: a(i)
            }
        }, i.prototype.withinRange = function(t, e) {
            return t = this.createRange(t.from, t.to), e.pick >= t.from.pick && e.pick <= t.to.pick
        }, i.prototype.overlapRanges = function(t, e) {
            var i = this;
            return t = i.createRange(t.from, t.to), e = i.createRange(e.from, e.to), i.withinRange(t, e.from) || i.withinRange(t, e.to) || i.withinRange(e, t.from) || i.withinRange(e, t.to)
        }, i.prototype.now = function(t, e, i) {
            return e = new Date, i && i.rel && e.setDate(e.getDate() + i.rel), this.normalize(e, i)
        }, i.prototype.navigate = function(t, i, n) {
            var a, o, r, s, l = e.isArray(i),
                u = e.isPlainObject(i),
                c = this.item.view;
            if (l || u) {
                for (u ? (o = i.year, r = i.month, s = i.date) : (o = +i[0], r = +i[1], s = +i[2]), n && n.nav && c && c.month !== r && (o = c.year, r = c.month), a = new Date(o, r + (n && n.nav ? n.nav : 0), 1), o = a.getFullYear(), r = a.getMonth(); new Date(o, r, s).getMonth() !== r;) s -= 1;
                i = [o, r, s]
            }
            return i
        }, i.prototype.normalize = function(t) {
            return t.setHours(0, 0, 0, 0), t
        }, i.prototype.measure = function(t, e) {
            var i = this;
            return e ? "string" == typeof e ? e = i.parse(t, e) : o.isInteger(e) && (e = i.now(t, e, {
                rel: e
            })) : e = "min" == t ? -1 / 0 : 1 / 0, e
        }, i.prototype.viewset = function(t, e) {
            return this.create([e.year, e.month, 1])
        }, i.prototype.validate = function(t, i, n) {
            var a, r, s, l, u = this,
                c = i,
                d = n && n.interval ? n.interval : 1,
                p = -1 === u.item.enable,
                h = u.item.min,
                f = u.item.max,
                g = p && u.item.disable.filter(function(t) {
                        if (e.isArray(t)) {
                            var n = u.create(t).pick;
                            n < i.pick ? a = !0 : n > i.pick && (r = !0)
                        }
                        return o.isInteger(t)
                    }).length;
            if ((!n || !n.nav) && (!p && u.disabled(i) || p && u.disabled(i) && (g || a || r) || !p && (i.pick <= h.pick || i.pick >= f.pick)))
                for (p && !g && (!r && d > 0 || !a && 0 > d) && (d *= -1); u.disabled(i) && (Math.abs(d) > 1 && (i.month < c.month || i.month > c.month) && (i = c, d = d > 0 ? 1 : -1), i.pick <= h.pick ? (s = !0, d = 1, i = u.create([h.year, h.month, h.date + (i.pick === h.pick ? 0 : -1)])) : i.pick >= f.pick && (l = !0, d = -1, i = u.create([f.year, f.month, f.date + (i.pick === f.pick ? 0 : 1)])), !s || !l);) i = u.create([i.year, i.month, i.date + d]);
            return i
        }, i.prototype.disabled = function(t) {
            var i = this,
                n = i.item.disable.filter(function(n) {
                    return o.isInteger(n) ? t.day === (i.settings.firstDay ? n : n - 1) % 7 : e.isArray(n) || o.isDate(n) ? t.pick === i.create(n).pick : e.isPlainObject(n) ? i.withinRange(n, t) : void 0
                });
            return n = n.length && !n.filter(function(t) {
                    return e.isArray(t) && "inverted" == t[3] || e.isPlainObject(t) && t.inverted
                }).length, -1 === i.item.enable ? !n : n || t.pick < i.item.min.pick || t.pick > i.item.max.pick
        }, i.prototype.parse = function(t, e, i) {
            var n = this,
                a = {};
            return e && "string" == typeof e ? (i && i.format || (i = i || {}, i.format = n.settings.format), n.formats.toArray(i.format).map(function(t) {
                var i = n.formats[t],
                    r = i ? o.trigger(i, n, [e, a]) : t.replace(/^!/, "").length;
                i && (a[t] = e.substr(0, r)), e = e.substr(r)
            }), [a.yyyy || a.yy, +(a.mm || a.m) - 1, a.dd || a.d]) : e
        }, i.prototype.formats = function() {
            function t(t, e, i) {
                var n = t.match(/\w+/)[0];
                return i.mm || i.m || (i.m = e.indexOf(n) + 1), n.length
            }

            function e(t) {
                return t.match(/\w+/)[0].length
            }
            return {
                d: function(t, e) {
                    return t ? o.digits(t) : e.date
                },
                dd: function(t, e) {
                    return t ? 2 : o.lead(e.date)
                },
                ddd: function(t, i) {
                    return t ? e(t) : this.settings.weekdaysShort[i.day]
                },
                dddd: function(t, i) {
                    return t ? e(t) : this.settings.weekdaysFull[i.day]
                },
                m: function(t, e) {
                    return t ? o.digits(t) : e.month + 1
                },
                mm: function(t, e) {
                    return t ? 2 : o.lead(e.month + 1)
                },
                mmm: function(e, i) {
                    var n = this.settings.monthsShort;
                    return e ? t(e, n, i) : n[i.month]
                },
                mmmm: function(e, i) {
                    var n = this.settings.monthsFull;
                    return e ? t(e, n, i) : n[i.month]
                },
                yy: function(t, e) {
                    return t ? 2 : ("" + e.year).slice(2)
                },
                yyyy: function(t, e) {
                    return t ? 4 : e.year
                },
                toArray: function(t) {
                    return t.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g)
                },
                toString: function(t, e) {
                    var i = this;
                    return i.formats.toArray(t).map(function(t) {
                        return o.trigger(i.formats[t], i, [0, e]) || t.replace(/^!/, "")
                    }).join("")
                }
            }
        }(), i.prototype.isDateExact = function(t, i) {
            var n = this;
            return o.isInteger(t) && o.isInteger(i) || "boolean" == typeof t && "boolean" == typeof i ? t === i : (o.isDate(t) || e.isArray(t)) && (o.isDate(i) || e.isArray(i)) ? n.create(t).pick === n.create(i).pick : e.isPlainObject(t) && e.isPlainObject(i) ? n.isDateExact(t.from, i.from) && n.isDateExact(t.to, i.to) : !1
        }, i.prototype.isDateOverlap = function(t, i) {
            var n = this,
                a = n.settings.firstDay ? 1 : 0;
            return o.isInteger(t) && (o.isDate(i) || e.isArray(i)) ? (t = t % 7 + a, t === n.create(i).day + 1) : o.isInteger(i) && (o.isDate(t) || e.isArray(t)) ? (i = i % 7 + a, i === n.create(t).day + 1) : e.isPlainObject(t) && e.isPlainObject(i) ? n.overlapRanges(t, i) : !1
        }, i.prototype.flipEnable = function(t) {
            var e = this.item;
            e.enable = t || (-1 == e.enable ? 1 : -1)
        }, i.prototype.deactivate = function(t, i) {
            var n = this,
                a = n.item.disable.slice(0);
            return "flip" == i ? n.flipEnable() : i === !1 ? (n.flipEnable(1), a = []) : i === !0 ? (n.flipEnable(-1), a = []) : i.map(function(t) {
                for (var i, r = 0; r < a.length; r += 1)
                    if (n.isDateExact(t, a[r])) {
                        i = !0;
                        break
                    }
                i || (o.isInteger(t) || o.isDate(t) || e.isArray(t) || e.isPlainObject(t) && t.from && t.to) && a.push(t)
            }), a
        }, i.prototype.activate = function(t, i) {
            var n = this,
                a = n.item.disable,
                r = a.length;
            return "flip" == i ? n.flipEnable() : i === !0 ? (n.flipEnable(1), a = []) : i === !1 ? (n.flipEnable(-1), a = []) : i.map(function(t) {
                var i, s, l, u;
                for (l = 0; r > l; l += 1) {
                    if (s = a[l], n.isDateExact(s, t)) {
                        i = a[l] = null, u = !0;
                        break
                    }
                    if (n.isDateOverlap(s, t)) {
                        e.isPlainObject(t) ? (t.inverted = !0, i = t) : e.isArray(t) ? (i = t, i[3] || i.push("inverted")) : o.isDate(t) && (i = [t.getFullYear(), t.getMonth(), t.getDate(), "inverted"]);
                        break
                    }
                }
                if (i)
                    for (l = 0; r > l; l += 1)
                        if (n.isDateExact(a[l], t)) {
                            a[l] = null;
                            break
                        }
                if (u)
                    for (l = 0; r > l; l += 1)
                        if (n.isDateOverlap(a[l], t)) {
                            a[l] = null;
                            break
                        }
                i && a.push(i)
            }), a.filter(function(t) {
                return null != t
            })
        }, i.prototype.nodes = function(t) {
            var e = this,
                i = e.settings,
                r = e.item,
                s = r.now,
                l = r.select,
                u = r.highlight,
                c = r.view,
                d = r.disable,
                p = r.min,
                h = r.max,
                f = function(t, e) {
                    return i.firstDay && (t.push(t.shift()), e.push(e.shift())), o.node("thead", o.node("tr", o.group({
                        min: 0,
                        max: n - 1,
                        i: 1,
                        node: "th",
                        item: function(n) {
                            return [t[n], i.klass.weekdays, 'scope=col title="' + e[n] + '"']
                        }
                    })))
                }((i.showWeekdaysFull ? i.weekdaysFull : i.weekdaysLetter).slice(0), i.weekdaysFull.slice(0)),
                g = function(t) {
                    return o.node("div", " ", i.klass["nav" + (t ? "Next" : "Prev")] + (t && c.year >= h.year && c.month >= h.month || !t && c.year <= p.year && c.month <= p.month ? " " + i.klass.navDisabled : ""), "data-nav=" + (t || -1) + " " + o.ariaAttr({
                            role: "button",
                            controls: e.$node[0].id + "_table"
                        }) + ' title="' + (t ? i.labelMonthNext : i.labelMonthPrev) + '"')
                },
                v = function(n) {
                    var a = i.showMonthsShort ? i.monthsShort : i.monthsFull;
                    return "short_months" == n && (a = i.monthsShort), i.selectMonths && void 0 == n ? o.node("select", o.group({
                        min: 0,
                        max: 11,
                        i: 1,
                        node: "option",
                        item: function(t) {
                            return [a[t], 0, "value=" + t + (c.month == t ? " selected" : "") + (c.year == p.year && t < p.month || c.year == h.year && t > h.month ? " disabled" : "")]
                        }
                    }), i.klass.selectMonth + " browser-default", (t ? "" : "disabled") + " " + o.ariaAttr({
                            controls: e.$node[0].id + "_table"
                        }) + ' title="' + i.labelMonthSelect + '"') : "short_months" == n ? null != l ? o.node("div", a[l.month]) : o.node("div", a[c.month]) : o.node("div", a[c.month], i.klass.month)
                },
                m = function(n) {
                    var a = c.year,
                        r = i.selectYears === !0 ? 5 : ~~(i.selectYears / 2);
                    if (r) {
                        var s = p.year,
                            l = h.year,
                            u = a - r,
                            d = a + r;
                        if (s > u && (d += s - u, u = s), d > l) {
                            var f = u - s,
                                g = d - l;
                            u -= f > g ? g : f, d = l
                        }
                        if (i.selectYears && void 0 == n) return o.node("select", o.group({
                            min: u,
                            max: d,
                            i: 1,
                            node: "option",
                            item: function(t) {
                                return [t, 0, "value=" + t + (a == t ? " selected" : "")]
                            }
                        }), i.klass.selectYear + " browser-default", (t ? "" : "disabled") + " " + o.ariaAttr({
                                controls: e.$node[0].id + "_table"
                            }) + ' title="' + i.labelYearSelect + '"')
                    }
                    return "raw" == n ? o.node("div", a) : o.node("div", a, i.klass.year)
                };
            return createDayLabel = function() {
                return null != l ? o.node("div", l.date) : o.node("div", s.date)
            }, createWeekdayLabel = function() {
                var t;
                t = null != l ? l.day : s.day;
                var e = i.weekdaysFull[t];
                return e
            }, o.node("div", o.node("div", createWeekdayLabel(), "picker__weekday-display") + o.node("div", v("short_months"), i.klass.month_display) + o.node("div", createDayLabel(), i.klass.day_display) + o.node("div", m("raw"), i.klass.year_display), i.klass.date_display) + o.node("div", o.node("div", (i.selectYears ? v() + m() : v() + m()) + g() + g(1), i.klass.header) + o.node("table", f + o.node("tbody", o.group({
                        min: 0,
                        max: a - 1,
                        i: 1,
                        node: "tr",
                        item: function(t) {
                            var a = i.firstDay && 0 === e.create([c.year, c.month, 1]).day ? -7 : 0;
                            return [o.group({
                                min: n * t - c.day + a + 1,
                                max: function() {
                                    return this.min + n - 1
                                },
                                i: 1,
                                node: "td",
                                item: function(t) {
                                    t = e.create([c.year, c.month, t + (i.firstDay ? 1 : 0)]);
                                    var n = l && l.pick == t.pick,
                                        a = u && u.pick == t.pick,
                                        r = d && e.disabled(t) || t.pick < p.pick || t.pick > h.pick,
                                        f = o.trigger(e.formats.toString, e, [i.format, t]);
                                    return [o.node("div", t.date, function(e) {
                                        return e.push(c.month == t.month ? i.klass.infocus : i.klass.outfocus), s.pick == t.pick && e.push(i.klass.now), n && e.push(i.klass.selected), a && e.push(i.klass.highlighted), r && e.push(i.klass.disabled), e.join(" ")
                                    }([i.klass.day]), "data-pick=" + t.pick + " " + o.ariaAttr({
                                            role: "gridcell",
                                            label: f,
                                            selected: n && e.$node.val() === f ? !0 : null,
                                            activedescendant: a ? !0 : null,
                                            disabled: r ? !0 : null
                                        })), "", o.ariaAttr({
                                        role: "presentation"
                                    })]
                                }
                            })]
                        }
                    })), i.klass.table, 'id="' + e.$node[0].id + '_table" ' + o.ariaAttr({
                        role: "grid",
                        controls: e.$node[0].id,
                        readonly: !0
                    })), i.klass.calendar_container) + o.node("div", o.node("button", i.today, "btn-flat picker__today", "type=button data-pick=" + s.pick + (t && !e.disabled(s) ? "" : " disabled") + " " + o.ariaAttr({
                        controls: e.$node[0].id
                    })) + o.node("button", i.clear, "btn-flat picker__clear", "type=button data-clear=1" + (t ? "" : " disabled") + " " + o.ariaAttr({
                        controls: e.$node[0].id
                    })) + o.node("button", i.close, "btn-flat picker__close", "type=button data-close=true " + (t ? "" : " disabled") + " " + o.ariaAttr({
                        controls: e.$node[0].id
                    })), i.klass.footer)
        }, i.defaults = function(t) {
            return {
                labelMonthNext: "Next month",
                labelMonthPrev: "Previous month",
                labelMonthSelect: "Select a month",
                labelYearSelect: "Select a year",
                monthsFull: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                weekdaysFull: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                weekdaysLetter: ["S", "M", "T", "W", "T", "F", "S"],
                today: "Today",
                clear: "Clear",
                close: "Close",
                format: "d mmmm, yyyy",
                klass: {
                    table: t + "table",
                    header: t + "header",
                    date_display: t + "date-display",
                    day_display: t + "day-display",
                    month_display: t + "month-display",
                    year_display: t + "year-display",
                    calendar_container: t + "calendar-container",
                    navPrev: t + "nav--prev",
                    navNext: t + "nav--next",
                    navDisabled: t + "nav--disabled",
                    month: t + "month",
                    year: t + "year",
                    selectMonth: t + "select--month",
                    selectYear: t + "select--year",
                    weekdays: t + "weekday",
                    day: t + "day",
                    disabled: t + "day--disabled",
                    selected: t + "day--selected",
                    highlighted: t + "day--highlighted",
                    now: t + "day--today",
                    infocus: t + "day--infocus",
                    outfocus: t + "day--outfocus",
                    footer: t + "footer",
                    buttonClear: t + "button--clear",
                    buttonToday: t + "button--today",
                    buttonClose: t + "button--close"
                }
            }
        }(t.klasses().picker + "__"), t.extend("pickadate", i)
    });